/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AcceptChatRequestV2Error = {
  __typename?: 'AcceptChatRequestV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: AcceptChatRequestV2Errors;
};

export enum AcceptChatRequestV2Errors {
  NotParticipant = 'NOT_PARTICIPANT',
  NoPendingRequest = 'NO_PENDING_REQUEST',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type AcceptChatRequestV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type AcceptChatRequestV2Result = {
  __typename?: 'AcceptChatRequestV2Result';
  errors?: Maybe<Array<AcceptChatRequestV2Error>>;
  participant?: Maybe<ChatParticipant>;
  success: Scalars['Boolean']['output'];
};

export type AcceptClubJoinRequestError = {
  __typename?: 'AcceptClubJoinRequestError';
  code: AcceptClubJoinRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum AcceptClubJoinRequestErrorCode {
  AlreadyProcessed = 'ALREADY_PROCESSED',
  RequestNotFound = 'REQUEST_NOT_FOUND'
}

export type AcceptClubJoinRequestParams = {
  joinRequestID: Scalars['ID']['input'];
};

export type AcceptClubJoinRequestResult = {
  __typename?: 'AcceptClubJoinRequestResult';
  clubMember?: Maybe<ClubMember>;
  errors?: Maybe<Array<AcceptClubJoinRequestError>>;
  success: Scalars['Boolean']['output'];
};

export enum ActivityType {
  ClubImpression = 'CLUB_IMPRESSION',
  ClubJoined = 'CLUB_JOINED',
  ClubViewed = 'CLUB_VIEWED',
  ClubViewedFromSearch = 'CLUB_VIEWED_FROM_SEARCH',
  EventGuestListViewed = 'EVENT_GUEST_LIST_VIEWED',
  EventHostViewed = 'EVENT_HOST_VIEWED',
  EventImpression = 'EVENT_IMPRESSION',
  EventRsvp = 'EVENT_RSVP',
  EventSaved = 'EVENT_SAVED',
  EventTicketPurchased = 'EVENT_TICKET_PURCHASED',
  EventViewed = 'EVENT_VIEWED',
  EventViewedFromSearch = 'EVENT_VIEWED_FROM_SEARCH',
  IdeaExpressedInterest = 'IDEA_EXPRESSED_INTEREST',
  IdeaImpression = 'IDEA_IMPRESSION',
  IdeaViewed = 'IDEA_VIEWED',
  IdeaViewedFromSearch = 'IDEA_VIEWED_FROM_SEARCH',
  UserViewedFromSearch = 'USER_VIEWED_FROM_SEARCH'
}

export type AddChatParticipantsV2Error = {
  __typename?: 'AddChatParticipantsV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: AddChatParticipantsV2Errors;
};

export enum AddChatParticipantsV2Errors {
  NotAdmin = 'NOT_ADMIN',
  RoomNotFound = 'ROOM_NOT_FOUND',
  UserNotFound = 'USER_NOT_FOUND'
}

export type AddChatParticipantsV2Input = {
  chatRoomID: Scalars['ID']['input'];
  userIDs: Array<Scalars['ID']['input']>;
};

export type AddChatParticipantsV2Result = {
  __typename?: 'AddChatParticipantsV2Result';
  errors?: Maybe<Array<AddChatParticipantsV2Error>>;
  participants?: Maybe<Array<ChatParticipant>>;
  success: Scalars['Boolean']['output'];
};

export type AddMediaToEventReviewHighlightInput = {
  eventId: Scalars['ID']['input'];
  mediaImageIds: Array<Scalars['ID']['input']>;
  mediaVideoIds: Array<Scalars['ID']['input']>;
};

export type AddMediaToEventReviewHighlightResult = {
  __typename?: 'AddMediaToEventReviewHighlightResult';
  error?: Maybe<EventReviewError>;
  media?: Maybe<Array<EventReviewHighlightMedia>>;
};

export type AddressComponentInput = {
  longText?: InputMaybe<Scalars['String']['input']>;
  shortText?: InputMaybe<Scalars['String']['input']>;
  types: Array<AddressComponentType>;
};

export enum AddressComponentType {
  AdministrativeAreaLevel_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  AdministrativeAreaLevel_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  Country = 'COUNTRY',
  Locality = 'LOCALITY',
  PostalCode = 'POSTAL_CODE',
  Route = 'ROUTE',
  StreetNumber = 'STREET_NUMBER',
  Unknown = 'UNKNOWN'
}

export enum Ages {
  Any = 'ANY',
  EighteenNineteen = 'EIGHTEEN_NINETEEN',
  Fifties = 'FIFTIES',
  Forties = 'FORTIES',
  Sixties = 'SIXTIES',
  Thirties = 'THIRTIES',
  Twenties = 'TWENTIES'
}

export type AnalyticsClubAttendeesInput = {
  clubID: Scalars['ID']['input'];
};

export type AnalyticsClubEarningsInput = {
  clubID: Scalars['ID']['input'];
};

export type AnalyticsClubMembersInput = {
  clubID: Scalars['ID']['input'];
};

export type AnalyticsClubTicketsInput = {
  clubID: Scalars['ID']['input'];
};

export enum AnalyticsInterval {
  Day = 'DAY'
}

export type AnalyticsMetric = {
  __typename?: 'AnalyticsMetric';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum AnalyticsPeriod {
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS'
}

export type AnalyticsResult = {
  __typename?: 'AnalyticsResult';
  metrics: Array<AnalyticsMetric>;
  previousMetrics: Array<AnalyticsMetric>;
  previousSummary?: Maybe<AnalyticsSummary>;
  summary?: Maybe<AnalyticsSummary>;
  trendSummary?: Maybe<AnalyticsTrendSummary>;
};

export type AnalyticsSummary = {
  __typename?: 'AnalyticsSummary';
  average: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type AnalyticsSummaryResult = {
  __typename?: 'AnalyticsSummaryResult';
  changePercent: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
};

export type AnalyticsSummaryTypeInput = {
  clubAttendees?: InputMaybe<AnalyticsClubAttendeesInput>;
  clubEarnings?: InputMaybe<AnalyticsClubEarningsInput>;
  clubMembers?: InputMaybe<AnalyticsClubMembersInput>;
  comparisonPeriod: AnalyticsPeriod;
};

export type AnalyticsTrendSummary = {
  __typename?: 'AnalyticsTrendSummary';
  differenceTotal: Scalars['Float']['output'];
  percentageChangeTotal: Scalars['Float']['output'];
};

export type AnalyticsTypeInput = {
  clubMembers?: InputMaybe<AnalyticsClubMembersInput>;
  clubkTickets?: InputMaybe<AnalyticsClubTicketsInput>;
  cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  includePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  interval: AnalyticsInterval;
  period: AnalyticsPeriod;
};

export type ArchiveChatV2Error = {
  __typename?: 'ArchiveChatV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: ArchiveChatV2Errors;
};

export enum ArchiveChatV2Errors {
  NotParticipant = 'NOT_PARTICIPANT',
  RoomNotFound = 'ROOM_NOT_FOUND',
  UserBlocked = 'USER_BLOCKED'
}

export type ArchiveChatV2Input = {
  archived: Scalars['Boolean']['input'];
  chatRoomID: Scalars['ID']['input'];
};

export type ArchiveChatV2Result = {
  __typename?: 'ArchiveChatV2Result';
  errors?: Maybe<Array<ArchiveChatV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type AttendanceInput = {
  attended: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

/**
 * Reason an attendee chose to cancel. Captured for self-cancellations so we
 * can surface aggregate patterns (e.g. how many guests cancel for "feeling
 * unwell"). Distinct from DeleteEventAttendeeReason, which is operational
 * metadata used by the refund pipeline.
 */
export enum AttendeeCancellationReason {
  ChangeOfPlans = 'CHANGE_OF_PLANS',
  FeelingUnwell = 'FEELING_UNWELL',
  SomethingCameUp = 'SOMETHING_CAME_UP',
  WorkCommitment = 'WORK_COMMITMENT'
}

export enum AttendeeRefundType {
  None = 'NONE',
  RefundExcludingFees = 'REFUND_EXCLUDING_FEES',
  RefundIncludingFees = 'REFUND_INCLUDING_FEES'
}

export type Badge = {
  __typename?: 'Badge';
  active: Scalars['Boolean']['output'];
  audiences: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum BadgeTier {
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  OneTime = 'ONE_TIME',
  Silver = 'SILVER'
}

export type BlockUserParams = {
  reason?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
};

export type BlockUserResult = {
  __typename?: 'BlockUserResult';
  errors: Array<UserBlockError>;
  success: Scalars['Boolean']['output'];
};

export type BlockedUserEntry = {
  __typename?: 'BlockedUserEntry';
  blockedAt: Scalars['Date']['output'];
  user: User;
};

export type CancelEventDirectInviteParams = {
  inviteID: Scalars['ID']['input'];
};

export type CancelEventDirectInviteResult = {
  __typename?: 'CancelEventDirectInviteResult';
  success: Scalars['Boolean']['output'];
};

export type CancelFriendRequestError = {
  __typename?: 'CancelFriendRequestError';
  code: CancelFriendRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum CancelFriendRequestErrorCode {
  AlreadyResponded = 'ALREADY_RESPONDED',
  NotFound = 'NOT_FOUND',
  NotSender = 'NOT_SENDER'
}

export type CancelFriendRequestParams = {
  friendRequestID: Scalars['ID']['input'];
};

export type CancelFriendRequestResult = {
  __typename?: 'CancelFriendRequestResult';
  error?: Maybe<CancelFriendRequestError>;
  friendRequest?: Maybe<FriendRequest>;
  success: Scalars['Boolean']['output'];
};

/**
 * Stats impact a cancellation had on the attendee, stamped at the moment the
 * attendance was cancelled.
 * - NONE: no penalty (in-grace self-cancel, or kicked/event-cancelled on them)
 * - STREAK_RESET: self-cancel outside grace and >72h before start
 * - STREAK_RESET_CITY_RERANK: self-cancel outside grace and <72h before start
 */
export enum CancellationImpact {
  None = 'NONE',
  StreakReset = 'STREAK_RESET',
  StreakResetCityRerank = 'STREAK_RESET_CITY_RERANK'
}

export type CanvasAttachment = CanvasLink | CanvasLocation | Discovery | Event | MediaImage;

export type CanvasLink = {
  __typename?: 'CanvasLink';
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<CreationCanvasError>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  limitations: Array<Scalars['String']['output']>;
  state: CanvasLinkState;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum CanvasLinkState {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Preparing = 'PREPARING',
  Ready = 'READY'
}

export type CanvasLocation = {
  __typename?: 'CanvasLocation';
  coordinates: LocationCoordinates;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ChatAttachment = {
  __typename?: 'ChatAttachment';
  author?: Maybe<User>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<MediaImage>;
  messageID: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type: ChatAttachmentType;
  url: Scalars['String']['output'];
  video?: Maybe<MediaVideo>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ChatAttachmentConnection = {
  __typename?: 'ChatAttachmentConnection';
  edges: Array<ChatAttachmentEdge>;
  pageInfo: PageInfo;
};

export type ChatAttachmentEdge = {
  __typename?: 'ChatAttachmentEdge';
  cursor: Scalars['String']['output'];
  node: ChatAttachment;
};

export type ChatAttachmentInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaImageId?: InputMaybe<Scalars['ID']['input']>;
  mediaVideoId?: InputMaybe<Scalars['ID']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  type: ChatAttachmentType;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum ChatAttachmentType {
  File = 'FILE',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type ChatLinkPreview = {
  __typename?: 'ChatLinkPreview';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ChatListConnection = {
  __typename?: 'ChatListConnection';
  edges: Array<ChatListEdge>;
  pageInfo: PageInfo;
};

export type ChatListEdge = {
  __typename?: 'ChatListEdge';
  cursor: Scalars['String']['output'];
  node: ChatListItem;
};

export type ChatListEvent = ChatRoomCreatedEvent | ChatRoomDeletedEvent | ChatRoomUpdatedEvent | ChatUnreadCountChangedEvent;

/**
 * A single item in the chat list. Can be either a regular chat room or a
 * grouped set of club chat rooms.
 */
export type ChatListItem = ChatRoomV2 | ClubChatRoomGroup;

export type ChatListParams = {
  /** Room IDs to exclude from results. */
  excludeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search query to filter by room/club name. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by room type (only applies to non-grouped rooms). */
  type?: InputMaybe<ChatRoomType>;
};

export enum ChatMessageAuthorType {
  System = 'SYSTEM',
  User = 'USER'
}

/**
 * Onboarding card payload attached to a CLUB_ONBOARDING_CARD chat message.
 * Populated only when ChatMessageV2.type == CLUB_ONBOARDING_CARD; null
 * otherwise.
 */
export type ChatMessageClubOnboardingCard = {
  __typename?: 'ChatMessageClubOnboardingCard';
  club: Club;
  kind: ChatMessageClubOnboardingCardKind;
  state: ChatMessageClubOnboardingCardState;
};

/**
 * Which step of the club onboarding flow a CLUB_ONBOARDING_CARD chat message
 * represents. Each kind maps to a single nudge card sent into the manager's
 * Butter DM. CLUB_COMPLETE is sent at most once per club, after the manager
 * finishes all five tasks AND has previously received at least one nudge.
 */
export enum ChatMessageClubOnboardingCardKind {
  ClubChat = 'CLUB_CHAT',
  ClubComplete = 'CLUB_COMPLETE',
  ClubFirstPlan = 'CLUB_FIRST_PLAN',
  ClubHome = 'CLUB_HOME',
  ClubShare = 'CLUB_SHARE',
  ClubWelcomeMessage = 'CLUB_WELCOME_MESSAGE'
}

/**
 * Render state of a CLUB_ONBOARDING_CARD message. ACTIVE renders the full
 * nudge card; COMPLETED renders the compact "task done" pill variant.
 */
export enum ChatMessageClubOnboardingCardState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

export type ChatMessageCreatedEvent = {
  __typename?: 'ChatMessageCreatedEvent';
  cursor: Scalars['String']['output'];
  message: ChatMessageV2;
  roomID: Scalars['ID']['output'];
};

export type ChatMessageDeletedEvent = {
  __typename?: 'ChatMessageDeletedEvent';
  messageID: Scalars['ID']['output'];
  roomID: Scalars['ID']['output'];
};

export type ChatMessageEditHistory = {
  __typename?: 'ChatMessageEditHistory';
  editedAt: Scalars['Date']['output'];
  editor: User;
  editorID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  messageID: Scalars['ID']['output'];
  previousText: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ChatMessageEditHistoryConnection = {
  __typename?: 'ChatMessageEditHistoryConnection';
  edges: Array<ChatMessageEditHistoryEdge>;
  pageInfo: PageInfo;
};

export type ChatMessageEditHistoryEdge = {
  __typename?: 'ChatMessageEditHistoryEdge';
  cursor: Scalars['String']['output'];
  node: ChatMessageEditHistory;
};

/**
 * The intent/purpose of a message, separate from its content type.
 * Most messages have no intent, but certain messages (like plan requests)
 * have a specific intent that provides context about why they were sent.
 */
export enum ChatMessageIntent {
  /** The message was sent as part of a plan request to meet up. */
  PlanRequest = 'PLAN_REQUEST'
}

/**
 * Plan-update payload attached to a PLAN_UPDATE chat message. Populated
 * only when ChatMessageV2.type == PLAN_UPDATE; null otherwise.
 */
export type ChatMessagePlanUpdate = {
  __typename?: 'ChatMessagePlanUpdate';
  /** Total number of actors — render "and N others" as actorCount - shown. */
  actorCount: Scalars['Int']['output'];
  /**
   * The users who performed the activity, most recent first. Default
   * returns the 3 most recent — enough for the overlapping-avatar stack.
   */
  actors: Array<User>;
  kind: ChatMessagePlanUpdateKind;
};


/**
 * Plan-update payload attached to a PLAN_UPDATE chat message. Populated
 * only when ChatMessageV2.type == PLAN_UPDATE; null otherwise.
 */
export type ChatMessagePlanUpdateActorsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Which plan activity a PLAN_UPDATE chat message represents. Drives the
 * verb phrase clients render; copy details live in the message text.
 */
export enum ChatMessagePlanUpdateKind {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Joined = 'JOINED',
  OnTheWay = 'ON_THE_WAY',
  Saved = 'SAVED',
  TicketsPurchased = 'TICKETS_PURCHASED',
  Updated = 'UPDATED',
  WaitlistJoined = 'WAITLIST_JOINED'
}

export enum ChatMessageType {
  ClubOnboardingCard = 'CLUB_ONBOARDING_CARD',
  Event = 'EVENT',
  Image = 'IMAGE',
  Images = 'IMAGES',
  MultiMedia = 'MULTI_MEDIA',
  PlanUpdate = 'PLAN_UPDATE',
  Poll = 'POLL',
  RecapComplete = 'RECAP_COMPLETE',
  RecapCreated = 'RECAP_CREATED',
  Text = 'TEXT'
}

export type ChatMessageUpdatedEvent = {
  __typename?: 'ChatMessageUpdatedEvent';
  cursor: Scalars['String']['output'];
  message: ChatMessageV2;
  messageID: Scalars['ID']['output'];
  roomID: Scalars['ID']['output'];
};

export type ChatMessageV2 = {
  __typename?: 'ChatMessageV2';
  attachments: Array<ChatAttachment>;
  author?: Maybe<User>;
  authorID?: Maybe<Scalars['ID']['output']>;
  authorType: ChatMessageAuthorType;
  chatRoomID: Scalars['ID']['output'];
  /**
   * Onboarding card payload. Set only when type == CLUB_ONBOARDING_CARD;
   * null otherwise.
   */
  clubOnboardingCard?: Maybe<ChatMessageClubOnboardingCard>;
  createdAt: Scalars['Date']['output'];
  /** Number of times this message has been edited. */
  editCount: Scalars['Int']['output'];
  /**
   * Edit history for this message with cursor-based pagination.
   * History entries are ordered by version ASC (oldest first).
   */
  editHistory: ChatMessageEditHistoryConnection;
  editedAt?: Maybe<Scalars['Date']['output']>;
  /** The event associated with this message. Only set for EVENT type messages. */
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The intent/purpose of this message. Most messages have no intent (null),
   * but certain messages like plan requests have a specific intent.
   */
  intent?: Maybe<ChatMessageIntent>;
  isDeleted: Scalars['Boolean']['output'];
  linkPreviews: Array<ChatLinkPreview>;
  mentionedUsers: Array<User>;
  myReaction?: Maybe<Scalars['String']['output']>;
  /** Plan-update payload. Set only when type == PLAN_UPDATE; null otherwise. */
  planUpdate?: Maybe<ChatMessagePlanUpdate>;
  poll?: Maybe<Poll>;
  reactions: Array<ChatReactionGroup>;
  replyTo?: Maybe<ChatMessageV2>;
  replyToID?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: ChatMessageType;
};


export type ChatMessageV2EditHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageV2Connection = {
  __typename?: 'ChatMessageV2Connection';
  edges: Array<ChatMessageV2Edge>;
  pageInfo: PageInfo;
};

export type ChatMessageV2Edge = {
  __typename?: 'ChatMessageV2Edge';
  cursor: Scalars['String']['output'];
  node: ChatMessageV2;
};

export type ChatMessagesV2Params = {
  after?: InputMaybe<Scalars['String']['input']>;
  chatRoomID: Scalars['ID']['input'];
};

export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  archived: Scalars['Boolean']['output'];
  declinedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this participant has a pending request (message_request or plan_request) that hasn't been accepted or declined yet. */
  isPendingRequest: Scalars['Boolean']['output'];
  joinedAt: Scalars['Date']['output'];
  lastReadAt?: Maybe<Scalars['Date']['output']>;
  /** Whether the participant has muted notifications for this chat room. */
  muted: Scalars['Boolean']['output'];
  role: ChatParticipantRole;
  sourceType: ChatParticipantSourceType;
  user: User;
  userID: Scalars['ID']['output'];
};

export type ChatParticipantConnection = {
  __typename?: 'ChatParticipantConnection';
  edges: Array<ChatParticipantEdge>;
  pageInfo: PageInfo;
};

export type ChatParticipantEdge = {
  __typename?: 'ChatParticipantEdge';
  cursor: Scalars['String']['output'];
  node: ChatParticipant;
};

export enum ChatParticipantRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export enum ChatParticipantSourceType {
  AdminAdded = 'ADMIN_ADDED',
  ClubManager = 'CLUB_MANAGER',
  ClubMember = 'CLUB_MEMBER',
  Creator = 'CREATOR',
  EventAttendee = 'EVENT_ATTENDEE',
  Friend = 'FRIEND',
  IdeaInterest = 'IDEA_INTEREST',
  MessageRequest = 'MESSAGE_REQUEST',
  PlanRequest = 'PLAN_REQUEST'
}

export type ChatParticipantsParams = {
  /** Filter participants by user first name or last name (case-insensitive substring match). */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ChatPollInput = {
  options: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type ChatReactionGroup = {
  __typename?: 'ChatReactionGroup';
  count: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
  hasReacted: Scalars['Boolean']['output'];
  messageID: Scalars['ID']['output'];
  users: ChatReactionUserConnection;
};


export type ChatReactionGroupUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatReactionUserConnection = {
  __typename?: 'ChatReactionUserConnection';
  edges: Array<ChatReactionUserEdge>;
  pageInfo: PageInfo;
};

export type ChatReactionUserEdge = {
  __typename?: 'ChatReactionUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/**
 * An activity that occurred in a chat room (e.g., plan request).
 * Activities are displayed as prompts/banners to users.
 */
export type ChatRoomActivity = {
  __typename?: 'ChatRoomActivity';
  activityType: ChatRoomActivityType;
  chatRoomID: Scalars['ID']['output'];
  /** Details for CREATE_EVENT activities. Null for other activity types. */
  createEventDetails?: Maybe<CreateEventActivity>;
  createdAt: Scalars['Date']['output'];
  /** The user who created this activity. */
  createdBy: User;
  /** Whether the current user has dismissed this activity. */
  dismissedByMe: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/**
 * Activity to create when creating a chat room.
 * When provided, this drives the participant source type.
 */
export type ChatRoomActivityInput = {
  /** The type of activity to create. */
  type: ChatRoomActivityType;
};

/** Type of activity that can occur in a chat room. */
export enum ChatRoomActivityType {
  /** An event creation activity - someone suggested meeting up. */
  CreateEvent = 'CREATE_EVENT'
}

export type ChatRoomCreatedEvent = {
  __typename?: 'ChatRoomCreatedEvent';
  cursor: Scalars['String']['output'];
  room: ChatRoomV2;
  roomID: Scalars['ID']['output'];
};

export type ChatRoomDeletedEvent = {
  __typename?: 'ChatRoomDeletedEvent';
  roomID: Scalars['ID']['output'];
};

export type ChatRoomEvent = ChatMessageCreatedEvent | ChatMessageDeletedEvent | ChatMessageUpdatedEvent | ChatRoomDeletedEvent | ChatRoomUpdatedEvent;

export enum ChatRoomOrderBy {
  /**
   * Order by participation first (joined rooms before non-joined), then by recent activity.
   * Requires an authenticated user context.
   */
  Joined = 'JOINED',
  /** Default: order by most recent activity. */
  Recent = 'RECENT'
}

export enum ChatRoomType {
  Club = 'CLUB',
  Direct = 'DIRECT',
  Event = 'EVENT',
  Group = 'GROUP',
  Idea = 'IDEA'
}

export enum ChatRoomUpdateReason {
  Details = 'DETAILS',
  Message = 'MESSAGE',
  Participant = 'PARTICIPANT',
  Typing = 'TYPING'
}

export type ChatRoomUpdatedEvent = {
  __typename?: 'ChatRoomUpdatedEvent';
  cursor: Scalars['String']['output'];
  reason: ChatRoomUpdateReason;
  room: ChatRoomV2;
  roomID: Scalars['ID']['output'];
};

export type ChatRoomV2 = {
  __typename?: 'ChatRoomV2';
  /**
   * The most recent activity for this chat room that the current user hasn't dismissed.
   * Returns null if there are no activities or all have been dismissed.
   */
  activity?: Maybe<ChatRoomActivity>;
  /**
   * Get all attachments for this chat room with cursor-based pagination.
   * Attachments are ordered by created_at DESC (newest first).
   * Only includes attachments from non-deleted messages.
   */
  attachments: ChatAttachmentConnection;
  /**
   * True if the current user sent a message/plan request and ALL other participants
   * have not yet accepted. Returns false if no pending requests exist or if any
   * participant has accepted.
   */
  awaitingMessageRequestAcceptance: Scalars['Boolean']['output'];
  club?: Maybe<Club>;
  clubChatType?: Maybe<ClubChatType>;
  clubChatTypeValue?: Maybe<Scalars['String']['output']>;
  clubID?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  creator?: Maybe<User>;
  creatorID?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['ID']['output']>;
  hasUnread: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  idea?: Maybe<Idea>;
  ideaID?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** True if this is a direct message chat room with the Butter system user. */
  isButterChat: Scalars['Boolean']['output'];
  /** Whether the current user has pinned this chat room. */
  isPinned: Scalars['Boolean']['output'];
  lastMessage?: Maybe<ChatMessageV2>;
  /**
   * Total count of active (non-archived) participants in this chat room.
   * Always available without authentication — exposes only the count, not the participant list.
   */
  memberCount: Scalars['Int']['output'];
  /**
   * Get messages for this chat room with cursor-based pagination.
   * Messages are ordered by created_at DESC (newest first).
   * Use 'after' cursor to load older messages.
   */
  messages: ChatMessageV2Connection;
  myParticipation?: Maybe<ChatParticipant>;
  name: Scalars['String']['output'];
  participants: ChatParticipantConnection;
  type: ChatRoomType;
  updatedAt: Scalars['Date']['output'];
  usersTyping: Array<ChatTypingUser>;
};


export type ChatRoomV2AttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatRoomV2MessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatRoomV2ParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ChatParticipantsParams>;
};

export type ChatRoomV2Connection = {
  __typename?: 'ChatRoomV2Connection';
  edges: Array<ChatRoomV2Edge>;
  pageInfo: PageInfo;
};

export type ChatRoomV2Edge = {
  __typename?: 'ChatRoomV2Edge';
  cursor: Scalars['String']['output'];
  node: ChatRoomV2;
};

export type ChatRoomV2Params = {
  eventID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ideaID?: InputMaybe<Scalars['ID']['input']>;
};

export type ChatRoomsV2Params = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  clubID?: InputMaybe<Scalars['ID']['input']>;
  eventID?: InputMaybe<Scalars['ID']['input']>;
  excludeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<ChatRoomOrderBy>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChatRoomType>;
};

export type ChatTypingUser = {
  __typename?: 'ChatTypingUser';
  id: Scalars['ID']['output'];
  startedAt: Scalars['Date']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

export type ChatUnreadCountChangedEvent = {
  __typename?: 'ChatUnreadCountChangedEvent';
  roomID: Scalars['ID']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type CheckWaitlistLocationRequestStatusInput = {
  requestId: Scalars['ID']['input'];
};

export type CheckWaitlistUserStatusInput = {
  email: Scalars['String']['input'];
  referral?: InputMaybe<WaitlistReferralInput>;
};

export enum ClaimEventCodeInviteOutcome {
  AlreadyAttending = 'ALREADY_ATTENDING',
  AlreadyHost = 'ALREADY_HOST',
  BecameAttendee = 'BECAME_ATTENDEE',
  EventCancelled = 'EVENT_CANCELLED',
  EventEnded = 'EVENT_ENDED',
  EventFull = 'EVENT_FULL',
  InvalidCode = 'INVALID_CODE',
  JoinedWaitlist = 'JOINED_WAITLIST',
  ProvideAttendeeFormAnswers = 'PROVIDE_ATTENDEE_FORM_ANSWERS',
  RequiresTicket = 'REQUIRES_TICKET',
  UserBlocked = 'USER_BLOCKED'
}

export type ClaimEventCodeInviteResult = {
  __typename?: 'ClaimEventCodeInviteResult';
  event?: Maybe<Event>;
  outcome: ClaimEventCodeInviteOutcome;
};

export type ClapParams = {
  entityID: Scalars['ID']['input'];
  entityType: ClappableEntityType;
};

export type ClapResult = {
  __typename?: 'ClapResult';
  success: Scalars['Boolean']['output'];
  summary: ClapSummary;
};

export type ClapSummary = {
  __typename?: 'ClapSummary';
  count: Scalars['Int']['output'];
  entityID: Scalars['ID']['output'];
  entityType: ClappableEntityType;
  hasClapped: Scalars['Boolean']['output'];
};

export enum ClappableEntityType {
  Comment = 'Comment',
  Idea = 'Idea',
  Post = 'Post',
  Unknown = 'Unknown',
  UserDetail = 'UserDetail'
}

export type CleanFriendsResult = {
  __typename?: 'CleanFriendsResult';
  removedFriendsCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Club = {
  __typename?: 'Club';
  ages: Array<Ages>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  askForEmailMarketingConsent: Scalars['Boolean']['output'];
  bannerMediaImageId?: Maybe<Scalars['ID']['output']>;
  canJoin: Scalars['Boolean']['output'];
  canSellTickets: Scalars['Boolean']['output'];
  /**
   * Get a single chat room by ID (v2).
   * Returns null if not found or room doesn't belong to this club.
   * Does not require authentication - suitable for invite previews.
   */
  chatRoomV2?: Maybe<ChatRoomV2>;
  /**
   * All chat rooms for this club (v2).
   * Returns all rooms regardless of user participation.
   * Use myParticipation on each room to check join status.
   */
  chatRoomsV2: ChatRoomV2Connection;
  clubRewards: ClubRewardConnection;
  /**
   * Aggregate club stats. Ranking/reliabilityStatus scoped to the authenticated
   * viewer's city. For event-context reliability, prefer `Event.clubStats` — it
   * scopes to the event's city rather than the viewer's.
   */
  clubStats: ClubStats;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  entityEvents: Array<EntityEvent>;
  eventMoments: Array<ClubEventMoment>;
  events: EventsConnection;
  faqs: Array<ClubFaq>;
  foundingMember: Scalars['Boolean']['output'];
  genders: Array<Gender>;
  group?: Maybe<ClubGroup>;
  hasPendingJoinRequest: Scalars['Boolean']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  insight?: Maybe<ClubPersonalizedInsight>;
  insights: Array<ClubInsight>;
  isManager: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  joinQuestions: Array<ClubJoinQuestion>;
  joinRequests: ClubJoinRequestsConnection;
  locationCities: Array<LocationCity>;
  locationSuburb?: Maybe<LocationSuburb>;
  locationSuburbID?: Maybe<Scalars['ID']['output']>;
  managers: Array<ClubManager>;
  meetingDays: Array<Scalars['String']['output']>;
  members: ClubMembersConnection;
  name: Scalars['String']['output'];
  pendingTicketSalesApprovalRequest?: Maybe<TicketSalesApprovalRequest>;
  personalizedSummary?: Maybe<Scalars['String']['output']>;
  /**
   * Total number of plans this club has hosted in the past
   * (published, non-cancelled events with start_time in the past).
   */
  plansHosted: Scalars['Int']['output'];
  premium: Scalars['Boolean']['output'];
  profileDescription: Scalars['String']['output'];
  profileHeadline: Scalars['String']['output'];
  profileImageUrl: Scalars['String']['output'];
  profileTitle: Scalars['String']['output'];
  profileUser?: Maybe<User>;
  profileUserID: Scalars['ID']['output'];
  socials: Array<Social>;
  ticketSellingEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  verified: Scalars['Boolean']['output'];
  visibility: ClubVisibility;
  welcomeMessage: Scalars['String']['output'];
};


export type ClubChatRoomV2Args = {
  id: Scalars['ID']['input'];
};


export type ClubChatRoomsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ChatRoomsV2Params>;
};


export type ClubClubRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type ClubEntityEventsArgs = {
  params?: InputMaybe<EntityEventsParams>;
};


export type ClubEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: ClubEventsParams;
};


export type ClubJoinRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ClubJoinRequestsParams>;
};


export type ClubManagersArgs = {
  params?: InputMaybe<ClubManagersFilters>;
};


export type ClubMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ClubMembersFilters>;
};

export type ClubBadge = {
  __typename?: 'ClubBadge';
  badge: Badge;
  earnedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  sourceValue?: Maybe<Scalars['Int']['output']>;
  tier: BadgeTier;
};

export type ClubChatRecommendation = {
  __typename?: 'ClubChatRecommendation';
  clubID: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: ClubChatType;
  typeValue: Scalars['String']['output'];
};

export type ClubChatRecommendations = {
  clubID: Scalars['ID']['input'];
};

/**
 * Represents a club's chat rooms grouped into a single row in the chat list.
 * The client can expand this to see individual club chats.
 */
export type ClubChatRoomGroup = {
  __typename?: 'ClubChatRoomGroup';
  /** The chat rooms belonging to this club. Supports filtering and pagination. */
  chatRooms: ChatRoomV2Connection;
  club: Club;
  clubID: Scalars['ID']['output'];
  /**
   * The most recent activity time across all chat rooms in this club.
   * Used for sorting in the chat list.
   */
  latestActivityAt: Scalars['Date']['output'];
};


/**
 * Represents a club's chat rooms grouped into a single row in the chat list.
 * The client can expand this to see individual club chats.
 */
export type ClubChatRoomGroupChatRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ChatRoomsV2Params>;
};

export enum ClubChatType {
  All = 'ALL',
  City = 'CITY',
  Custom = 'CUSTOM',
  Direct = 'DIRECT',
  Interest = 'INTEREST'
}

export type ClubDetailInput = {
  answer: Scalars['String']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<ClubDetailSubtype>;
  type: ClubDetailType;
  visible: Scalars['Boolean']['input'];
};

export enum ClubDetailSubtype {
  FaqExpectation = 'FAQ_EXPECTATION',
  FaqJoin = 'FAQ_JOIN',
  FaqRefundPolicy = 'FAQ_REFUND_POLICY'
}

export enum ClubDetailType {
  Faq = 'FAQ',
  UserFit = 'USER_FIT'
}

export type ClubEdge = {
  __typename?: 'ClubEdge';
  cursor: Scalars['ID']['output'];
  node: Club;
};

export type ClubEngagementParams = {
  clubId: Scalars['ID']['input'];
};

export type ClubEventMoment = {
  __typename?: 'ClubEventMoment';
  caption: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
};

export type ClubEventMomentInput = {
  caption: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
};

export type ClubEventsParams = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  locationCityID?: InputMaybe<Scalars['ID']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClubFaq = {
  __typename?: 'ClubFAQ';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ClubFaqInput = {
  answer: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export enum ClubGroup {
  Builders = 'BUILDERS',
  Creative = 'CREATIVE',
  Exercise = 'EXERCISE',
  Foodie = 'FOODIE',
  SlowRollers = 'SLOW_ROLLERS',
  Sober = 'SOBER'
}

export type ClubInsight = {
  __typename?: 'ClubInsight';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  visible: Scalars['Boolean']['output'];
};

export type ClubInsightInput = {
  answer: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
};

export type ClubJoinAnswerInput = {
  answer: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
};

export type ClubJoinQuestion = {
  __typename?: 'ClubJoinQuestion';
  id: Scalars['ID']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  type: ClubJoinQuestionType;
};

export type ClubJoinQuestionInput = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  type: ClubJoinQuestionType;
};

export enum ClubJoinQuestionType {
  QuestionAnswer = 'QUESTION_ANSWER',
  SingleChoice = 'SINGLE_CHOICE'
}

export type ClubJoinRequest = {
  __typename?: 'ClubJoinRequest';
  answers: Array<ClubJoinRequestAnswer>;
  club: Club;
  clubID: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  status: ClubJoinRequestStatus;
  user: User;
  userID: Scalars['ID']['output'];
};

export type ClubJoinRequestAnswer = {
  __typename?: 'ClubJoinRequestAnswer';
  answer: Scalars['String']['output'];
  clubJoinQuestionID: Scalars['ID']['output'];
  clubJoinRequestID: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  question: ClubJoinQuestion;
};

export type ClubJoinRequestEdge = {
  __typename?: 'ClubJoinRequestEdge';
  cursor: Scalars['String']['output'];
  node: ClubJoinRequest;
};

export enum ClubJoinRequestStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type ClubJoinRequestsConnection = {
  __typename?: 'ClubJoinRequestsConnection';
  edges: Array<ClubJoinRequestEdge>;
  pageInfo: PageInfo;
};

export type ClubJoinRequestsParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ClubJoinRequestStatus>;
};

export type ClubManager = {
  __typename?: 'ClubManager';
  club: Club;
  clubID: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  displayHost: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  primary: Scalars['Boolean']['output'];
  profileDescription?: Maybe<Scalars['String']['output']>;
  profileHeadline?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  profileMediaImage?: Maybe<MediaImage>;
  profileMediaImageId?: Maybe<Scalars['ID']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  user: User;
  userID: Scalars['ID']['output'];
};

export type ClubManagersFilters = {
  excludeUserID?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ClubMember = {
  __typename?: 'ClubMember';
  attendedEvents: EventsConnection;
  club: Club;
  clubID: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  emailMarketingOptIn: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};


export type ClubMemberAttendedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ClubMemberEdge = {
  __typename?: 'ClubMemberEdge';
  cursor: Scalars['String']['output'];
  node: ClubMember;
};

export type ClubMembersConnection = {
  __typename?: 'ClubMembersConnection';
  edges: Array<ClubMemberEdge>;
  pageInfo: PageInfo;
};

export type ClubMembersFilters = {
  friendsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClubMembersParams = {
  clubID: Scalars['ID']['input'];
  optedInForMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ClubParams = {
  id: Scalars['ID']['input'];
};

export type ClubPersonalizedInsight = {
  __typename?: 'ClubPersonalizedInsight';
  body: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ClubReward = {
  __typename?: 'ClubReward';
  earnedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reward: Reward;
};

export type ClubRewardConnection = {
  __typename?: 'ClubRewardConnection';
  edges: Array<ClubRewardEdge>;
  pageInfo: PageInfo;
};

export type ClubRewardEdge = {
  __typename?: 'ClubRewardEdge';
  cursor: Scalars['String']['output'];
  node: ClubReward;
};

export type ClubSocialInput = {
  handle: Scalars['String']['input'];
  type?: InputMaybe<SocialType>;
};

/**
 * Aggregate stats for a club, computed only from events the club hosted
 * (event.clubId is set). Hosts hosting on their own do not affect this.
 */
export type ClubStats = {
  __typename?: 'ClubStats';
  city?: Maybe<ClubStatsCity>;
  global: ClubStatsGlobal;
  /**
   * Past club events finalized with NO hosts attending. Ordered most-recent
   * first.
   */
  recentNoShows: EventsConnection;
  /**
   * Past club events cancelled after at least one guest had confirmed
   * attendance. Ordered most-recent first.
   */
  recentlyCancelled: EventsConnection;
  /**
   * Past club events where at least one host attended (per the
   * "at least one host saves the club" rule). Ordered most-recent first.
   */
  recentlyHosted: EventsConnection;
};


/**
 * Aggregate stats for a club, computed only from events the club hosted
 * (event.clubId is set). Hosts hosting on their own do not affect this.
 */
export type ClubStatsRecentNoShowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Aggregate stats for a club, computed only from events the club hosted
 * (event.clubId is set). Hosts hosting on their own do not affect this.
 */
export type ClubStatsRecentlyCancelledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Aggregate stats for a club, computed only from events the club hosted
 * (event.clubId is set). Hosts hosting on their own do not affect this.
 */
export type ClubStatsRecentlyHostedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Event/viewer-city scoped club ranking and reliability from club_city_stats. */
export type ClubStatsCity = {
  __typename?: 'ClubStatsCity';
  cityName?: Maybe<Scalars['String']['output']>;
  cityRanking?: Maybe<Scalars['Int']['output']>;
  reliabilityStatus: HostReliabilityStatus;
};

/** Global club counters and streaks from the club_stats ledger. */
export type ClubStatsGlobal = {
  __typename?: 'ClubStatsGlobal';
  cancellations: Scalars['Int']['output'];
  longestPlanStreak: Scalars['Int']['output'];
  noShows: Scalars['Int']['output'];
  planStreak: Scalars['Int']['output'];
  plansHosted: Scalars['Int']['output'];
  wentAhead: Scalars['Int']['output'];
};

export enum ClubVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ClubsConnection = {
  __typename?: 'ClubsConnection';
  edges: Array<ClubEdge>;
  pageInfo: PageInfo;
};

export type ClubsParams = {
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  managing?: InputMaybe<Scalars['Boolean']['input']>;
  managingOrMember?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  claps: ClapSummary;
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  postID: Scalars['ID']['output'];
  postedBy: PostedBy;
  replies: CommentsConnection;
  repliesSummary: CommentSummary;
  user: User;
  userID: Scalars['ID']['output'];
};


export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  cursor: Scalars['String']['output'];
  node: Comment;
};

export type CommentParams = {
  id: Scalars['ID']['input'];
};

export type CommentSummary = {
  __typename?: 'CommentSummary';
  count: Scalars['Int']['output'];
  hasCommented: Scalars['Boolean']['output'];
};

export type CommentsConnection = {
  __typename?: 'CommentsConnection';
  edges: Array<CommentEdge>;
  pageInfo: PageInfo;
};

export type CommentsParams = {
  commentID?: InputMaybe<Scalars['ID']['input']>;
  postID: Scalars['ID']['input'];
};

export type CompleteEventReviewInput = {
  reviewId: Scalars['ID']['input'];
};

export type CompleteEventReviewResult = {
  __typename?: 'CompleteEventReviewResult';
  error?: Maybe<EventReviewError>;
  eventReview?: Maybe<EventReview>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoverCostContributionEstimate = {
  __typename?: 'CoverCostContributionEstimate';
  butterFeeCents: Scalars['Int']['output'];
  coverCostCents: Scalars['Int']['output'];
  currency: WalletCurrency;
  feePercentage: Scalars['Int']['output'];
  feePercentageExact: Scalars['Float']['output'];
  totalDueCents: Scalars['Int']['output'];
};

export type CoverCostContributionEstimateParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
  coverCostCents: Scalars['Int']['input'];
};

export type CoverCostContributionIntentError = {
  __typename?: 'CoverCostContributionIntentError';
  message?: Maybe<Scalars['String']['output']>;
  type: CoverCostContributionIntentErrorType;
};

export enum CoverCostContributionIntentErrorType {
  ActiveRequestExists = 'ACTIVE_REQUEST_EXISTS',
  AlreadyAttendingOrHosting = 'ALREADY_ATTENDING_OR_HOSTING',
  EventAtCapacity = 'EVENT_AT_CAPACITY',
  EventCancelledOrEnded = 'EVENT_CANCELLED_OR_ENDED',
  EventNotCoverCost = 'EVENT_NOT_COVER_COST',
  EventNotFound = 'EVENT_NOT_FOUND',
  EventRequestNotFound = 'EVENT_REQUEST_NOT_FOUND',
  InsufficientWalletBalance = 'INSUFFICIENT_WALLET_BALANCE',
  InvalidCoverCostState = 'INVALID_COVER_COST_STATE',
  InvalidIntent = 'INVALID_INTENT',
  InvalidRequestState = 'INVALID_REQUEST_STATE',
  RequestCapReached = 'REQUEST_CAP_REACHED',
  TicketSalesApprovalRequired = 'TICKET_SALES_APPROVAL_REQUIRED',
  UserBlocked = 'USER_BLOCKED',
  WaitlistNotAvailable = 'WAITLIST_NOT_AVAILABLE'
}

export type CoverCostContributionIntentParams = {
  eventID: Scalars['ID']['input'];
  eventRequestID?: InputMaybe<Scalars['ID']['input']>;
  form?: InputMaybe<Array<EventFormInputAnswer>>;
  intent: CreateEventRequestIntent;
  message?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<CoverCostPaymentMethod>;
};

export enum CoverCostPaymentMethod {
  Stripe = 'STRIPE',
  Wallet = 'WALLET'
}

export enum CoverCostPaymentState {
  Authorized = 'AUTHORIZED',
  Cancelled = 'CANCELLED',
  CancelPending = 'CANCEL_PENDING',
  Captured = 'CAPTURED',
  CapturePending = 'CAPTURE_PENDING',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  RequiresPayment = 'REQUIRES_PAYMENT'
}

export enum CoverCostRefundStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export type CreateChatRoomV2Error = {
  __typename?: 'CreateChatRoomV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateChatRoomV2Errors;
};

export enum CreateChatRoomV2Errors {
  ClubChatAlreadyExists = 'CLUB_CHAT_ALREADY_EXISTS',
  ClubNotFound = 'CLUB_NOT_FOUND',
  InvalidClubChatType = 'INVALID_CLUB_CHAT_TYPE',
  InvalidParticipant = 'INVALID_PARTICIPANT',
  InvalidType = 'INVALID_TYPE',
  NotClubManager = 'NOT_CLUB_MANAGER',
  TypeNotAllowed = 'TYPE_NOT_ALLOWED',
  UserBlocked = 'USER_BLOCKED'
}

export type CreateChatRoomV2Input = {
  /**
   * Activity to create when creating the chat room.
   * When provided with type CREATE_PLAN, the participant source type will be PLAN_REQUEST.
   */
  activity?: InputMaybe<ChatRoomActivityInput>;
  clubChatType?: InputMaybe<ClubChatType>;
  clubChatTypeValue?: InputMaybe<Scalars['String']['input']>;
  clubID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['ID']['input']>;
  ideaID?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial message to send when creating the chat room.
   * This is sent from the creator after the room is created.
   */
  initialMessage?: InputMaybe<InitialChatMessageInput>;
  name: Scalars['String']['input'];
  participantIDs: Array<Scalars['ID']['input']>;
  type: ChatRoomType;
};

export type CreateChatRoomV2Result = {
  __typename?: 'CreateChatRoomV2Result';
  chatRoom?: Maybe<ChatRoomV2>;
  errors?: Maybe<Array<CreateChatRoomV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type CreateClubError = {
  __typename?: 'CreateClubError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateClubErrors;
};

export enum CreateClubErrors {
  DecorativeLetters = 'DECORATIVE_LETTERS',
  DescriptionTooLong = 'DESCRIPTION_TOO_LONG',
  NameAlreadyExists = 'NAME_ALREADY_EXISTS',
  NameTooLong = 'NAME_TOO_LONG'
}

export type CreateClubJoinRequestError = {
  __typename?: 'CreateClubJoinRequestError';
  code: CreateClubJoinRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateClubJoinRequestErrorCode {
  AlreadyMember = 'ALREADY_MEMBER',
  MissingRequiredAnswers = 'MISSING_REQUIRED_ANSWERS',
  RequestAlreadyExists = 'REQUEST_ALREADY_EXISTS'
}

export type CreateClubJoinRequestParams = {
  answers?: InputMaybe<Array<ClubJoinAnswerInput>>;
  clubId: Scalars['ID']['input'];
};

export type CreateClubJoinRequestResult = {
  __typename?: 'CreateClubJoinRequestResult';
  errors?: Maybe<Array<CreateClubJoinRequestError>>;
  joinRequest?: Maybe<ClubJoinRequest>;
  success: Scalars['Boolean']['output'];
};

export type CreateClubManagerError = {
  __typename?: 'CreateClubManagerError';
  code: CreateClubManagerErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateClubManagerErrorCode {
  AlreadyManager = 'ALREADY_MANAGER',
  UserNotFound = 'USER_NOT_FOUND'
}

export type CreateClubManagerParams = {
  clubID: Scalars['ID']['input'];
  displayHost: Scalars['Boolean']['input'];
  profileDescription?: InputMaybe<Scalars['String']['input']>;
  profileHeadline?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  profileMediaImageId?: InputMaybe<Scalars['ID']['input']>;
  profileName: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateClubManagerResult = {
  __typename?: 'CreateClubManagerResult';
  clubManager?: Maybe<ClubManager>;
  errors?: Maybe<Array<CreateClubManagerError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateClubMemberParams = {
  answers?: InputMaybe<Array<ClubJoinAnswerInput>>;
  clubId: Scalars['ID']['input'];
};

export type CreateClubMemberResult = {
  __typename?: 'CreateClubMemberResult';
  clubMember?: Maybe<ClubMember>;
  success: Scalars['Boolean']['output'];
};

export type CreateClubParams = {
  ages?: InputMaybe<Array<Ages>>;
  askForEmailMarketingConsent: Scalars['Boolean']['input'];
  bannerMediaImageId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  eventMoments: Array<ClubEventMomentInput>;
  faqs: Array<ClubFaqInput>;
  genders?: InputMaybe<Array<Gender>>;
  group?: InputMaybe<ClubGroup>;
  headline: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  insights: Array<ClubInsightInput>;
  joinQuestions?: InputMaybe<Array<ClubJoinQuestionInput>>;
  locationCityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationSuburbId?: InputMaybe<Scalars['ID']['input']>;
  managerUserIDs: Array<Scalars['ID']['input']>;
  meetingDays: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profileDescription: Scalars['String']['input'];
  profileHeadline: Scalars['String']['input'];
  profileImageUrl: Scalars['String']['input'];
  profileTitle: Scalars['String']['input'];
  socials: Array<ClubSocialInput>;
  ticketSellingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<ClubVisibility>;
  welcomeMessage: Scalars['String']['input'];
};

export type CreateClubResult = {
  __typename?: 'CreateClubResult';
  club?: Maybe<Club>;
  errors?: Maybe<Array<CreateClubError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateCommentError = {
  __typename?: 'CreateCommentError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateCommentErrors;
};

export enum CreateCommentErrors {
  ContentTooLong = 'CONTENT_TOO_LONG',
  NotClubMember = 'NOT_CLUB_MEMBER',
  ParentCommentNotFound = 'PARENT_COMMENT_NOT_FOUND',
  PostNotFound = 'POST_NOT_FOUND'
}

export type CreateCommentParams = {
  content: Scalars['String']['input'];
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  postID: Scalars['ID']['input'];
  repliedToCommentID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCommentResult = {
  __typename?: 'CreateCommentResult';
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<CreateCommentError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateCoverCostContributionIntentResult = {
  __typename?: 'CreateCoverCostContributionIntentResult';
  authorizationExpiresAt?: Maybe<Scalars['Date']['output']>;
  butterFeeCents: Scalars['Int']['output'];
  canProceed: Scalars['Boolean']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  coverCostCents: Scalars['Int']['output'];
  currency?: Maybe<WalletCurrency>;
  errors?: Maybe<Array<CoverCostContributionIntentError>>;
  eventID: Scalars['ID']['output'];
  intent: CreateEventRequestIntent;
  intentExpiresAt?: Maybe<Scalars['Date']['output']>;
  paymentMethod: CoverCostPaymentMethod;
  paymentState?: Maybe<CoverCostPaymentState>;
  request?: Maybe<EventRequest>;
  resultingRequestState?: Maybe<EventRequestState>;
  topUpRequiredCents: Scalars['Int']['output'];
  totalDueCents: Scalars['Int']['output'];
  walletAvailableCents: Scalars['Int']['output'];
  walletIntentID?: Maybe<Scalars['ID']['output']>;
  willJoinWaitlist: Scalars['Boolean']['output'];
  willMoveFunds: Scalars['Boolean']['output'];
};

export type CreateCuratedEventInput = {
  displayOrder: Scalars['Int']['input'];
  eventId: Scalars['ID']['input'];
  locationCityId: Scalars['ID']['input'];
  userGroup: Scalars['String']['input'];
};

export type CreateDiscountCodeError = {
  __typename?: 'CreateDiscountCodeError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateDiscountCodeErrors;
};

export enum CreateDiscountCodeErrors {
  ClubNotFound = 'CLUB_NOT_FOUND',
  CodeAlreadyExists = 'CODE_ALREADY_EXISTS',
  InvalidValue = 'INVALID_VALUE',
  Unauthorized = 'UNAUTHORIZED'
}

export type CreateDiscountCodeParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  type: DiscountCodeType;
  value: Scalars['Int']['input'];
};

export type CreateDiscountCodeResult = {
  __typename?: 'CreateDiscountCodeResult';
  discountCode?: Maybe<DiscountCode>;
  errors?: Maybe<Array<CreateDiscountCodeError>>;
  success: Scalars['Boolean']['output'];
};

/**
 * Details for a CREATE_EVENT activity.
 * Fields are populated incrementally by the event compaction worker.
 */
export type CreateEventActivity = {
  __typename?: 'CreateEventActivity';
  description?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['Date']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loading: Scalars['Boolean']['output'];
  /** Resolved media image for the cover image. */
  mediaImage?: Maybe<MediaImage>;
  /** Resolved place from the linked place entity. */
  place?: Maybe<Place>;
  prompt?: Maybe<Scalars['String']['output']>;
};

export type CreateEventAttendeeError = {
  __typename?: 'CreateEventAttendeeError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateEventAttendeeErrors;
};

export enum CreateEventAttendeeErrors {
  AlreadyAttending = 'ALREADY_ATTENDING',
  EventFull = 'EVENT_FULL',
  EventNotFound = 'EVENT_NOT_FOUND',
  RsvpRequestsEnabled = 'RSVP_REQUESTS_ENABLED',
  TicketedEvent = 'TICKETED_EVENT',
  UserBlocked = 'USER_BLOCKED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type CreateEventAttendeeParams = {
  eventID: Scalars['ID']['input'];
  form?: InputMaybe<Array<EventFormInputAnswer>>;
  userID: Scalars['ID']['input'];
};

export type CreateEventAttendeeResult = {
  __typename?: 'CreateEventAttendeeResult';
  attendee?: Maybe<EventAttendee>;
  errors?: Maybe<Array<CreateEventAttendeeError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateEventCodeInviteResult = {
  __typename?: 'CreateEventCodeInviteResult';
  error?: Maybe<Scalars['String']['output']>;
  invite?: Maybe<EventCodeInvite>;
  success: Scalars['Boolean']['output'];
};

export type CreateEventDirectGroupInviteError = {
  __typename?: 'CreateEventDirectGroupInviteError';
  message: Scalars['String']['output'];
  type: CreateEventDirectGroupInviteErrors;
};

export enum CreateEventDirectGroupInviteErrors {
  EventCancelled = 'EVENT_CANCELLED',
  EventEnded = 'EVENT_ENDED',
  InvalidGroup = 'INVALID_GROUP',
  InvalidRecipient = 'INVALID_RECIPIENT',
  NotAuthorized = 'NOT_AUTHORIZED',
  NoGroups = 'NO_GROUPS',
  NoRecipients = 'NO_RECIPIENTS'
}

export type CreateEventDirectGroupInviteParams = {
  eventID: Scalars['ID']['input'];
  groups: Array<EventInviteGroupSelection>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventDirectGroupInviteResult = {
  __typename?: 'CreateEventDirectGroupInviteResult';
  error?: Maybe<CreateEventDirectGroupInviteError>;
  groups: Array<EventInviteGroup>;
  queuedInviteCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateEventDirectInviteError = {
  __typename?: 'CreateEventDirectInviteError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateEventDirectInviteErrors;
};

export enum CreateEventDirectInviteErrors {
  ActiveRequest = 'ACTIVE_REQUEST',
  AlreadyAttending = 'ALREADY_ATTENDING',
  AlreadyHosting = 'ALREADY_HOSTING',
  AlreadyInvited = 'ALREADY_INVITED',
  AlreadyWaitlisted = 'ALREADY_WAITLISTED',
  Blocked = 'BLOCKED',
  EventCancelled = 'EVENT_CANCELLED',
  EventEnded = 'EVENT_ENDED',
  EventNotFound = 'EVENT_NOT_FOUND',
  InvitingSelf = 'INVITING_SELF',
  NotAuthorized = 'NOT_AUTHORIZED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type CreateEventDirectInviteInviteeResult = {
  __typename?: 'CreateEventDirectInviteInviteeResult';
  errors?: Maybe<Array<CreateEventDirectInviteError>>;
  invite?: Maybe<EventDirectInvite>;
  inviteeUserID: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateEventDirectInviteParams = {
  eventID: Scalars['ID']['input'];
  inviteeUserIDs: Array<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventDirectInviteResult = {
  __typename?: 'CreateEventDirectInviteResult';
  results: Array<CreateEventDirectInviteInviteeResult>;
  success: Scalars['Boolean']['output'];
};

export type CreateEventError = {
  __typename?: 'CreateEventError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateEventErrors;
};

export enum CreateEventErrors {
  BannerImageRequired = 'BANNER_IMAGE_REQUIRED',
  CapacityBelowAttendeeCount = 'CAPACITY_BELOW_ATTENDEE_COUNT',
  ChatActivityAlreadyHasEvent = 'CHAT_ACTIVITY_ALREADY_HAS_EVENT',
  ChatActivityNotFound = 'CHAT_ACTIVITY_NOT_FOUND',
  CoverCostDescriptionRequired = 'COVER_COST_DESCRIPTION_REQUIRED',
  CoverCostPerPersonCentsInvalid = 'COVER_COST_PER_PERSON_CENTS_INVALID',
  CoverCostRequired = 'COVER_COST_REQUIRED',
  CoverCostRequiredByInvalid = 'COVER_COST_REQUIRED_BY_INVALID',
  CoverCostRequiredParticipantsInvalid = 'COVER_COST_REQUIRED_PARTICIPANTS_INVALID',
  CoverCostSettingsLocked = 'COVER_COST_SETTINGS_LOCKED',
  DecorativeLetters = 'DECORATIVE_LETTERS',
  DescriptionTooLong = 'DESCRIPTION_TOO_LONG',
  GooglePlaceNotFound = 'GOOGLE_PLACE_NOT_FOUND',
  InvalidGooglePlaceId = 'INVALID_GOOGLE_PLACE_ID',
  InvalidPlaceId = 'INVALID_PLACE_ID',
  InvalidTicketVariations = 'INVALID_TICKET_VARIATIONS',
  LocationCityResolutionFailed = 'LOCATION_CITY_RESOLUTION_FAILED',
  LocationOutsideSupportedCity = 'LOCATION_OUTSIDE_SUPPORTED_CITY',
  MenuSampleTooLong = 'MENU_SAMPLE_TOO_LONG',
  MonetizationPlanTypeLocked = 'MONETIZATION_PLAN_TYPE_LOCKED',
  NotClubManager = 'NOT_CLUB_MANAGER',
  StartDateInPast = 'START_DATE_IN_PAST',
  TicketSalesApprovalRequestInvalid = 'TICKET_SALES_APPROVAL_REQUEST_INVALID',
  TicketSalesApprovalRequestNotFound = 'TICKET_SALES_APPROVAL_REQUEST_NOT_FOUND',
  TicketSalesApprovalRequired = 'TICKET_SALES_APPROVAL_REQUIRED',
  TitleTooLong = 'TITLE_TOO_LONG',
  TooManyBannerImages = 'TOO_MANY_BANNER_IMAGES'
}

export type CreateEventFormInput = {
  label: Scalars['String']['input'];
  placeholder: Scalars['String']['input'];
  selectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  type: EventFormInputType;
};

export type CreateEventFromIdeaParams = {
  id: Scalars['ID']['input'];
  ideaInterestDay: IdeaInterestDay;
  ideaInterestTime: IdeaInterestTime;
};

export type CreateEventParams = {
  absorbFees?: InputMaybe<Scalars['Boolean']['input']>;
  ages?: InputMaybe<Array<Ages>>;
  allowInvites?: InputMaybe<Scalars['Boolean']['input']>;
  approveGuests?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  bannerImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  capacity: Scalars['Int']['input'];
  chatRoomActivityID?: InputMaybe<Scalars['ID']['input']>;
  clubID?: InputMaybe<Scalars['ID']['input']>;
  cohostsUserIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  coverCost?: InputMaybe<EventCoverCostParams>;
  description: Scalars['String']['input'];
  earlyBirdDiscount?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['Date']['input'];
  form?: InputMaybe<Array<CreateEventFormInput>>;
  genders: Array<Gender>;
  /** Resolve a newly selected venue from Google Places. */
  googlePlaceID?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  hideFromNonMatching?: InputMaybe<Scalars['Boolean']['input']>;
  idea?: InputMaybe<CreateEventFromIdeaParams>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Deprecated compatibility payload for older clients. New clients should send
   * placeID or googlePlaceID; event writes resolve and persist only internal event city and place IDs.
   * @deprecated Use placeID or googlePlaceID
   */
  location?: InputMaybe<LocationParams>;
  menuSample?: InputMaybe<Scalars['String']['input']>;
  /** Reuse an existing Butter place, such as when duplicating a plan. */
  placeID?: InputMaybe<Scalars['ID']['input']>;
  publicPreciseLocation?: InputMaybe<Scalars['Boolean']['input']>;
  publishAt?: InputMaybe<Scalars['Date']['input']>;
  startDate: Scalars['Date']['input'];
  structure?: InputMaybe<EventStructure>;
  ticketInclusions?: InputMaybe<Array<CreateEventTicketInclusionInput>>;
  ticketPrice?: InputMaybe<Scalars['Int']['input']>;
  ticketSalesApprovalRequestID?: InputMaybe<Scalars['ID']['input']>;
  ticketVariations?: InputMaybe<Array<EventTicketVariationInput>>;
  tippingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  tone?: InputMaybe<EventTone>;
  type?: InputMaybe<EventType>;
  waitlists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEventRequestError = {
  __typename?: 'CreateEventRequestError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreateEventRequestErrors;
};

export enum CreateEventRequestErrors {
  AlreadyAttendingOrHosting = 'ALREADY_ATTENDING_OR_HOSTING',
  CoverCostContributionIntentRequired = 'COVER_COST_CONTRIBUTION_INTENT_REQUIRED',
  CoverCostIntentStale = 'COVER_COST_INTENT_STALE',
  CoverCostUnavailable = 'COVER_COST_UNAVAILABLE',
  DuplicateEventRequest = 'DUPLICATE_EVENT_REQUEST',
  EventAtCapacity = 'EVENT_AT_CAPACITY',
  EventCancelledOrEnded = 'EVENT_CANCELLED_OR_ENDED',
  InsufficientCoverCostBalance = 'INSUFFICIENT_COVER_COST_BALANCE',
  InvalidCoverCostContributionIntent = 'INVALID_COVER_COST_CONTRIBUTION_INTENT',
  InvalidIntent = 'INVALID_INTENT',
  OpenRequestCapReached = 'OPEN_REQUEST_CAP_REACHED',
  TicketedEventNotAtCapacity = 'TICKETED_EVENT_NOT_AT_CAPACITY',
  TicketedEventWaitlistDisabled = 'TICKETED_EVENT_WAITLIST_DISABLED',
  UserBlocked = 'USER_BLOCKED',
  WaitlistNotAvailable = 'WAITLIST_NOT_AVAILABLE'
}

export enum CreateEventRequestIntent {
  JoinWaitlist = 'JOIN_WAITLIST',
  Pending = 'PENDING'
}

export type CreateEventRequestParams = {
  coverCostContributionIntentID?: InputMaybe<Scalars['ID']['input']>;
  eventID: Scalars['ID']['input'];
  form?: InputMaybe<Array<EventFormInputAnswer>>;
  intent?: InputMaybe<CreateEventRequestIntent>;
  message?: InputMaybe<Scalars['String']['input']>;
  type: EventRequestType;
  userID: Scalars['ID']['input'];
};

export type CreateEventRequestResult = {
  __typename?: 'CreateEventRequestResult';
  errors?: Maybe<Array<CreateEventRequestError>>;
  request?: Maybe<EventRequest>;
  success: Scalars['Boolean']['output'];
};

export type CreateEventResult = {
  __typename?: 'CreateEventResult';
  errors?: Maybe<Array<CreateEventError>>;
  event?: Maybe<Event>;
  success: Scalars['Boolean']['output'];
};

export type CreateEventTicketInclusionInput = {
  position: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateEventTicketPurchaseError = {
  __typename?: 'CreateEventTicketPurchaseError';
  message: Scalars['String']['output'];
  type: CreateEventTicketPurchaseIntentErrors;
};

export type CreateEventTicketPurchaseFromWalletParams = {
  approvalRequest?: InputMaybe<EventTicketApprovalRequestInput>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  earlyBird: Scalars['Boolean']['input'];
  eventID: Scalars['ID']['input'];
  eventTicketVariationID?: InputMaybe<Scalars['ID']['input']>;
  walletID: Scalars['ID']['input'];
};

export type CreateEventTicketPurchaseFromWalletResult = {
  __typename?: 'CreateEventTicketPurchaseFromWalletResult';
  errors?: Maybe<Array<CreateEventTicketPurchaseError>>;
  request?: Maybe<EventRequest>;
  success: Scalars['Boolean']['output'];
  walletIntentID?: Maybe<Scalars['ID']['output']>;
};

export enum CreateEventTicketPurchaseIntentErrors {
  AlreadyAttending = 'ALREADY_ATTENDING',
  ApprovalRequestRequired = 'APPROVAL_REQUEST_REQUIRED',
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  DiscountCodeInvalid = 'DISCOUNT_CODE_INVALID',
  EventFull = 'EVENT_FULL',
  EventScheduled = 'EVENT_SCHEDULED',
  FormIncomplete = 'FORM_INCOMPLETE',
  InvalidApprovalRequest = 'INVALID_APPROVAL_REQUEST',
  PriceChanged = 'PRICE_CHANGED',
  ProfileIncomplete = 'PROFILE_INCOMPLETE',
  TicketSalesApprovalRequired = 'TICKET_SALES_APPROVAL_REQUIRED',
  TicketVariationUnavailable = 'TICKET_VARIATION_UNAVAILABLE',
  UserBlocked = 'USER_BLOCKED'
}

export type CreateEventTicketPurchaseIntentParams = {
  approvalRequest?: InputMaybe<EventTicketApprovalRequestInput>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  earlyBird: Scalars['Boolean']['input'];
  eventID: Scalars['ID']['input'];
  eventTicketVariationID?: InputMaybe<Scalars['ID']['input']>;
  expectedTotalCents?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateEventTicketPurchaseIntentResult = {
  __typename?: 'CreateEventTicketPurchaseIntentResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CreateEventTicketPurchaseError>>;
  processing: Scalars['Boolean']['output'];
  request?: Maybe<EventRequest>;
  success: Scalars['Boolean']['output'];
  ticketCost?: Maybe<EventTicketCheckoutCost>;
  walletIntentID?: Maybe<Scalars['String']['output']>;
};

export type CreateFriendRequestError = {
  __typename?: 'CreateFriendRequestError';
  code: CreateFriendRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateFriendRequestErrorCode {
  AlreadyFriends = 'ALREADY_FRIENDS',
  CannotFriendSelf = 'CANNOT_FRIEND_SELF',
  OnCooldown = 'ON_COOLDOWN',
  PendingRequestExists = 'PENDING_REQUEST_EXISTS',
  PhoneNumberMismatch = 'PHONE_NUMBER_MISMATCH',
  RecipientDeleted = 'RECIPIENT_DELETED',
  RecipientNotFound = 'RECIPIENT_NOT_FOUND',
  UserBlocked = 'USER_BLOCKED'
}

export type CreateFriendRequestParams = {
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * When provided, verifies it matches the recipient's phone number
   * and directly befriends (skips request flow).
   * Acts as proof the caller has their contact info.
   */
  recipientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  recipientUserID: Scalars['ID']['input'];
};

export type CreateFriendRequestResult = {
  __typename?: 'CreateFriendRequestResult';
  error?: Maybe<CreateFriendRequestError>;
  friendRequest?: Maybe<FriendRequest>;
};

export type CreateGlobalPayoutOnboardingLinkError = {
  __typename?: 'CreateGlobalPayoutOnboardingLinkError';
  code: CreateGlobalPayoutOnboardingLinkErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateGlobalPayoutOnboardingLinkErrorCode {
  GlobalPayoutsUnavailable = 'GLOBAL_PAYOUTS_UNAVAILABLE',
  PendingRequirements = 'PENDING_REQUIREMENTS',
  ProviderConflict = 'PROVIDER_CONFLICT',
  RestrictedRecipient = 'RESTRICTED_RECIPIENT',
  UnsupportedCurrencyOrCountry = 'UNSUPPORTED_CURRENCY_OR_COUNTRY'
}

export type CreateGlobalPayoutOnboardingLinkParams = {
  businessType: StripeConnectAccountBusinessType;
  walletID: Scalars['ID']['input'];
};

export type CreateGlobalPayoutOnboardingLinkResult = {
  __typename?: 'CreateGlobalPayoutOnboardingLinkResult';
  accountLinkURL?: Maybe<Scalars['String']['output']>;
  error?: Maybe<CreateGlobalPayoutOnboardingLinkError>;
  setup?: Maybe<WalletPayoutSetup>;
  success: Scalars['Boolean']['output'];
};

export type CreateIdeaInterestParams = {
  days?: InputMaybe<Array<IdeaInterestDay>>;
  ideaID: Scalars['ID']['input'];
  times?: InputMaybe<Array<IdeaInterestTime>>;
};

export type CreateIdeaInterestResult = {
  __typename?: 'CreateIdeaInterestResult';
  idea?: Maybe<Idea>;
  interest?: Maybe<IdeaInterest>;
};

export type CreateIdeaParams = {
  description: Scalars['String']['input'];
  imageUrls: Array<Scalars['String']['input']>;
  locationCityID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateIdeaResult = {
  __typename?: 'CreateIdeaResult';
  idea?: Maybe<Idea>;
  success: Scalars['Boolean']['output'];
};

export type CreatePollParams = {
  options: Array<Scalars['String']['input']>;
  ownerID: Scalars['String']['input'];
  ownerType: PollOwnerType;
  question: Scalars['String']['input'];
};

export type CreatePollResult = {
  __typename?: 'CreatePollResult';
  poll?: Maybe<Poll>;
  success: Scalars['Boolean']['output'];
};

export type CreatePostError = {
  __typename?: 'CreatePostError';
  message?: Maybe<Scalars['String']['output']>;
  type: CreatePostErrors;
};

export enum CreatePostErrors {
  ClubNotFound = 'CLUB_NOT_FOUND',
  ContentTooLong = 'CONTENT_TOO_LONG',
  NotClubMember = 'NOT_CLUB_MEMBER'
}

export type CreatePostParams = {
  content: Scalars['String']['input'];
  entityID: Scalars['ID']['input'];
  entityType: PostEntityType;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  poll?: InputMaybe<CreatePostPollParams>;
};

export type CreatePostPollParams = {
  options: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type CreatePostResult = {
  __typename?: 'CreatePostResult';
  errors?: Maybe<Array<CreatePostError>>;
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserParams = {
  /**
   * Legacy fallback for old mobile clients. Looked up by name in Australia.
   * Prefer `locationCityId` when available — at least one of the two is required.
   */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional unverified contact address. Phone account creation does not require it.
   * This address is not used to link accounts or claim a waitlist registration.
   */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  referrerType?: InputMaybe<ReferrerType>;
  referrerUserId?: InputMaybe<Scalars['ID']['input']>;
  referrerWaitlistUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWalletPayoutIntentError = {
  __typename?: 'CreateWalletPayoutIntentError';
  code: CreateWalletPayoutIntentErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateWalletPayoutIntentErrorCode {
  BelowMinimum = 'BELOW_MINIMUM',
  Failed = 'FAILED',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  SetupPending = 'SETUP_PENDING',
  SetupRequired = 'SETUP_REQUIRED',
  SetupRestricted = 'SETUP_RESTRICTED',
  Unsupported = 'UNSUPPORTED'
}

export type CreateWalletPayoutIntentParams = {
  amount: Scalars['Int']['input'];
  walletID: Scalars['ID']['input'];
};

export type CreateWalletPayoutIntentResult = {
  __typename?: 'CreateWalletPayoutIntentResult';
  error?: Maybe<CreateWalletPayoutIntentError>;
  status: CreateWalletPayoutIntentStatus;
  success: Scalars['Boolean']['output'];
};

export enum CreateWalletPayoutIntentStatus {
  Accepted = 'ACCEPTED',
  BelowMinimum = 'BELOW_MINIMUM',
  Failed = 'FAILED',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  Pending = 'PENDING',
  SetupRequired = 'SETUP_REQUIRED',
  Unsupported = 'UNSUPPORTED'
}

export type CreateWalletTipIntentParams = {
  amountCents: Scalars['Int']['input'];
  eventID: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  receivingUserID?: InputMaybe<Scalars['ID']['input']>;
  walletID: Scalars['ID']['input'];
};

export type CreateWalletTipIntentResult = {
  __typename?: 'CreateWalletTipIntentResult';
  success: Scalars['Boolean']['output'];
};

export type CreateWalletTopUpIntentParams = {
  amount: Scalars['Int']['input'];
  walletID: Scalars['ID']['input'];
};

export type CreateWalletTopUpIntentResult = {
  __typename?: 'CreateWalletTopUpIntentResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  walletIntentID?: Maybe<Scalars['String']['output']>;
};

export type CreationCanvasAreaInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  locationCityID?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum CreationCanvasAttachmentKind {
  AttendedPlan = 'ATTENDED_PLAN',
  Discovery = 'DISCOVERY',
  Event = 'EVENT',
  Link = 'LINK',
  Photo = 'PHOTO',
  SavedPlan = 'SAVED_PLAN'
}

export type CreationCanvasAttachmentReferenceInput = {
  id: Scalars['ID']['input'];
  kind: CreationCanvasAttachmentKind;
};

export type CreationCanvasAttachmentResult = {
  __typename?: 'CreationCanvasAttachmentResult';
  attachment?: Maybe<CanvasAttachment>;
  error?: Maybe<CreationCanvasError>;
};

export type CreationCanvasClubDraft = {
  __typename?: 'CreationCanvasClubDraft';
  description: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  images: Array<CreationCanvasImage>;
  insights: Array<CreationCanvasClubInsight>;
  locationCityIDs: Array<Scalars['ID']['output']>;
  meetingDays: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CreationCanvasClubInsight = {
  __typename?: 'CreationCanvasClubInsight';
  answer: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type CreationCanvasContext = {
  __typename?: 'CreationCanvasContext';
  inputRevision: Scalars['Int']['output'];
  overview: Scalars['String']['output'];
  revision: Scalars['Int']['output'];
};

export type CreationCanvasContextInput = {
  attachments: Array<CreationCanvasAttachmentReferenceInput>;
  inputRevision: Scalars['Int']['input'];
  location?: InputMaybe<CreationCanvasLocationInput>;
  overview: Scalars['String']['input'];
};

export type CreationCanvasCoreDetails = {
  __typename?: 'CreationCanvasCoreDetails';
  contextRevision: Scalars['Int']['output'];
  howMany?: Maybe<Scalars['Int']['output']>;
  /** Expressed group size when no exact count is known, such as A few mates or 4–6 people. */
  howManyLabel?: Maybe<Scalars['String']['output']>;
  howOften?: Maybe<Scalars['String']['output']>;
  what?: Maybe<Scalars['String']['output']>;
  when?: Maybe<Scalars['String']['output']>;
};

export type CreationCanvasDraft = CreationCanvasClubDraft | CreationCanvasIdeaDraft | CreationCanvasPlanDraft;

export type CreationCanvasDraftSet = {
  __typename?: 'CreationCanvasDraftSet';
  id: Scalars['ID']['output'];
  kind: CreationCanvasKind;
  slots: Array<CreationCanvasSlot>;
};

export enum CreationCanvasEditField {
  Description = 'DESCRIPTION',
  General = 'GENERAL',
  HowMany = 'HOW_MANY',
  Image = 'IMAGE',
  PostAs = 'POST_AS',
  Title = 'TITLE',
  When = 'WHEN',
  Where = 'WHERE'
}

export type CreationCanvasEditingFocus = {
  __typename?: 'CreationCanvasEditingFocus';
  contextRevision: Scalars['Int']['output'];
  field: CreationCanvasEditField;
  fields: Array<CreationCanvasEditField>;
  message: Scalars['String']['output'];
  revisionID: Scalars['ID']['output'];
  slot: Scalars['Int']['output'];
  turnID: Scalars['ID']['output'];
};

export type CreationCanvasError = {
  __typename?: 'CreationCanvasError';
  attachmentID?: Maybe<Scalars['ID']['output']>;
  attachmentKind?: Maybe<CreationCanvasAttachmentKind>;
  code: CreationCanvasErrorCode;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export enum CreationCanvasErrorCode {
  AssetUnavailable = 'ASSET_UNAVAILABLE',
  Busy = 'BUSY',
  Conflict = 'CONFLICT',
  Expired = 'EXPIRED',
  GenerationFailed = 'GENERATION_FAILED',
  InvalidInput = 'INVALID_INPUT',
  LimitReached = 'LIMIT_REACHED',
  NotFound = 'NOT_FOUND',
  ProviderUnavailable = 'PROVIDER_UNAVAILABLE',
  QueueFull = 'QUEUE_FULL',
  Unavailable = 'UNAVAILABLE'
}

export type CreationCanvasFieldIssue = {
  __typename?: 'CreationCanvasFieldIssue';
  code: CreationCanvasIssueCode;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CreationCanvasHandoff = {
  __typename?: 'CreationCanvasHandoff';
  issues: Array<CreationCanvasFieldIssue>;
  kind: CreationCanvasKind;
  prefill?: Maybe<CreationCanvasDraft>;
  revisionID: Scalars['ID']['output'];
  sessionID: Scalars['ID']['output'];
  state: CreationCanvasHandoffState;
};

export type CreationCanvasHandoffResult = {
  __typename?: 'CreationCanvasHandoffResult';
  error?: Maybe<CreationCanvasError>;
  handoff?: Maybe<CreationCanvasHandoff>;
};

export enum CreationCanvasHandoffState {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Preparing = 'PREPARING',
  Ready = 'READY'
}

export type CreationCanvasIdeaDraft = {
  __typename?: 'CreationCanvasIdeaDraft';
  description: Scalars['String']['output'];
  images: Array<CreationCanvasImage>;
  name: Scalars['String']['output'];
};

export type CreationCanvasImage = {
  __typename?: 'CreationCanvasImage';
  mediaImageId?: Maybe<Scalars['ID']['output']>;
  source: CreationCanvasSource;
  url: Scalars['String']['output'];
};

export enum CreationCanvasIssueCode {
  ImageUnavailable = 'IMAGE_UNAVAILABLE',
  InvalidValue = 'INVALID_VALUE',
  MissingValue = 'MISSING_VALUE',
  ResearchUnavailable = 'RESEARCH_UNAVAILABLE',
  StaleDate = 'STALE_DATE',
  SuggestedValue = 'SUGGESTED_VALUE'
}

export enum CreationCanvasKind {
  Club = 'CLUB',
  Idea = 'IDEA',
  Plan = 'PLAN'
}

export type CreationCanvasLocationInput = {
  label: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreationCanvasMessage = {
  __typename?: 'CreationCanvasMessage';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  role: CreationCanvasRole;
  text: Scalars['String']['output'];
  turnID: Scalars['ID']['output'];
};

export enum CreationCanvasMessageIntent {
  PlanOptions = 'PLAN_OPTIONS',
  PlanRefine = 'PLAN_REFINE'
}

export type CreationCanvasPlace = {
  __typename?: 'CreationCanvasPlace';
  city?: Maybe<Scalars['String']['output']>;
  coordinates: LocationCoordinates;
  countryCode?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  googlePlaceId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: CreationCanvasSource;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type CreationCanvasPlanDraft = {
  __typename?: 'CreationCanvasPlanDraft';
  capacity?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  endTime?: Maybe<Scalars['Date']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  images: Array<CreationCanvasImage>;
  name: Scalars['String']['output'];
  place?: Maybe<CreationCanvasPlace>;
  postingClub?: Maybe<CreationCanvasPostingClub>;
  startTime?: Maybe<Scalars['Date']['output']>;
  structure?: Maybe<EventStructure>;
  timezone?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<EventTone>;
};

export type CreationCanvasPostingClub = {
  __typename?: 'CreationCanvasPostingClub';
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreationCanvasRevision = {
  __typename?: 'CreationCanvasRevision';
  createdAt: Scalars['Date']['output'];
  draft: CreationCanvasDraft;
  id: Scalars['ID']['output'];
  issues: Array<CreationCanvasFieldIssue>;
  kind: CreationCanvasKind;
  revision: Scalars['Int']['output'];
  setID: Scalars['ID']['output'];
  slot: Scalars['Int']['output'];
};

export enum CreationCanvasRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type CreationCanvasSession = {
  __typename?: 'CreationCanvasSession';
  activeTurn?: Maybe<CreationCanvasTurn>;
  attachments: Array<CanvasAttachment>;
  context?: Maybe<CreationCanvasContext>;
  coreDetails?: Maybe<CreationCanvasCoreDetails>;
  currentSet?: Maybe<CreationCanvasDraftSet>;
  editingFocus?: Maybe<CreationCanvasEditingFocus>;
  expiresAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  latestTurn?: Maybe<CreationCanvasTurn>;
  messages: Array<CreationCanvasMessage>;
  previousSet?: Maybe<CreationCanvasDraftSet>;
  queueCapacity: Scalars['Int']['output'];
  queuedTurns: Array<CreationCanvasTurn>;
  selectedHandoff?: Maybe<CreationCanvasHandoff>;
  selectedRevisionID?: Maybe<Scalars['ID']['output']>;
  state: CreationCanvasState;
  version: Scalars['Int']['output'];
};

export type CreationCanvasSessionResult = {
  __typename?: 'CreationCanvasSessionResult';
  error?: Maybe<CreationCanvasError>;
  session?: Maybe<CreationCanvasSession>;
};

export type CreationCanvasSlot = {
  __typename?: 'CreationCanvasSlot';
  error?: Maybe<CreationCanvasError>;
  latestReadyRevision?: Maybe<CreationCanvasRevision>;
  slot: Scalars['Int']['output'];
  state: CreationCanvasSlotState;
};

export type CreationCanvasSlotProgress = {
  __typename?: 'CreationCanvasSlotProgress';
  kind: CreationCanvasKind;
  message: Scalars['String']['output'];
  setID?: Maybe<Scalars['ID']['output']>;
  /** Zero during collection research; otherwise the option slot (1–3). */
  slot: Scalars['Int']['output'];
};

export enum CreationCanvasSlotState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Working = 'WORKING'
}

export type CreationCanvasSource = {
  __typename?: 'CreationCanvasSource';
  attribution?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerID: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum CreationCanvasStage {
  Drafting = 'DRAFTING',
  Idle = 'IDLE',
  Interpreting = 'INTERPRETING',
  Researching = 'RESEARCHING'
}

export enum CreationCanvasState {
  AwaitingReply = 'AWAITING_REPLY',
  Empty = 'EMPTY',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Ready = 'READY',
  Working = 'WORKING'
}

export type CreationCanvasTurn = {
  __typename?: 'CreationCanvasTurn';
  error?: Maybe<CreationCanvasError>;
  id: Scalars['ID']['output'];
  progress?: Maybe<CreationCanvasSlotProgress>;
  scopeSummary?: Maybe<Scalars['String']['output']>;
  stage: CreationCanvasStage;
  state: CreationCanvasTurnState;
  targetSlots: Array<Scalars['Int']['output']>;
  workingSlot?: Maybe<Scalars['Int']['output']>;
};

export type CreationCanvasTurnResult = {
  __typename?: 'CreationCanvasTurnResult';
  error?: Maybe<CreationCanvasError>;
  session?: Maybe<CreationCanvasSession>;
  turn?: Maybe<CreationCanvasTurn>;
};

export enum CreationCanvasTurnState {
  AwaitingReply = 'AWAITING_REPLY',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type CuratedEvent = {
  __typename?: 'CuratedEvent';
  createdAt: Scalars['Date']['output'];
  displayOrder: Scalars['Int']['output'];
  event: Event;
  id: Scalars['ID']['output'];
  locationCity: LocationCity;
  userGroup: Scalars['String']['output'];
};

export type CuratedEventsConnection = {
  __typename?: 'CuratedEventsConnection';
  edges: Array<CuratedEventsEdge>;
  pageInfo: PageInfo;
};

export type CuratedEventsEdge = {
  __typename?: 'CuratedEventsEdge';
  cursor: Scalars['String']['output'];
  node: CuratedEvent;
};

export type CuratedEventsParams = {
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  userGroup?: InputMaybe<Scalars['String']['input']>;
};

export type DeclineChatRequestV2Error = {
  __typename?: 'DeclineChatRequestV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: DeclineChatRequestV2Errors;
};

export enum DeclineChatRequestV2Errors {
  NotParticipant = 'NOT_PARTICIPANT',
  NoPendingRequest = 'NO_PENDING_REQUEST',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type DeclineChatRequestV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type DeclineChatRequestV2Result = {
  __typename?: 'DeclineChatRequestV2Result';
  errors?: Maybe<Array<DeclineChatRequestV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeclineClubJoinRequestError = {
  __typename?: 'DeclineClubJoinRequestError';
  code: DeclineClubJoinRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum DeclineClubJoinRequestErrorCode {
  AlreadyProcessed = 'ALREADY_PROCESSED',
  RequestNotFound = 'REQUEST_NOT_FOUND'
}

export type DeclineClubJoinRequestParams = {
  joinRequestID: Scalars['ID']['input'];
};

export type DeclineClubJoinRequestResult = {
  __typename?: 'DeclineClubJoinRequestResult';
  errors?: Maybe<Array<DeclineClubJoinRequestError>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteChatMessageV2Error = {
  __typename?: 'DeleteChatMessageV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: DeleteChatMessageV2Errors;
};

export enum DeleteChatMessageV2Errors {
  MessageNotFound = 'MESSAGE_NOT_FOUND',
  NotAuthorized = 'NOT_AUTHORIZED'
}

export type DeleteChatMessageV2Input = {
  messageID: Scalars['ID']['input'];
};

export type DeleteChatMessageV2Result = {
  __typename?: 'DeleteChatMessageV2Result';
  errors?: Maybe<Array<DeleteChatMessageV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteChatRoomV2Error = {
  __typename?: 'DeleteChatRoomV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: DeleteChatRoomV2Errors;
};

export enum DeleteChatRoomV2Errors {
  NotAdmin = 'NOT_ADMIN',
  RoomNotFound = 'ROOM_NOT_FOUND',
  TypeNotAllowed = 'TYPE_NOT_ALLOWED'
}

export type DeleteChatRoomV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type DeleteChatRoomV2Result = {
  __typename?: 'DeleteChatRoomV2Result';
  errors?: Maybe<Array<DeleteChatRoomV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteClubError = {
  __typename?: 'DeleteClubError';
  code: DeleteClubErrorCode;
  message: Scalars['String']['output'];
};

export enum DeleteClubErrorCode {
  NotAuthorized = 'NOT_AUTHORIZED'
}

export type DeleteClubManagerError = {
  __typename?: 'DeleteClubManagerError';
  code: DeleteClubManagerErrorCode;
  message: Scalars['String']['output'];
};

export enum DeleteClubManagerErrorCode {
  CannotDeleteOwner = 'CANNOT_DELETE_OWNER'
}

export type DeleteClubManagerParams = {
  id: Scalars['ID']['input'];
};

export type DeleteClubManagerResult = {
  __typename?: 'DeleteClubManagerResult';
  errors?: Maybe<Array<DeleteClubManagerError>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteClubMemberParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
  memberID?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteClubMemberResult = {
  __typename?: 'DeleteClubMemberResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteClubMembersError = {
  __typename?: 'DeleteClubMembersError';
  message?: Maybe<Scalars['String']['output']>;
  type: DeleteClubMembersErrors;
};

export enum DeleteClubMembersErrors {
  TooManyMembers = 'TOO_MANY_MEMBERS'
}

export type DeleteClubMembersParams = {
  clubID: Scalars['ID']['input'];
  memberIDs: Array<Scalars['ID']['input']>;
};

export type DeleteClubMembersResult = {
  __typename?: 'DeleteClubMembersResult';
  errors?: Maybe<Array<DeleteClubMembersError>>;
  removedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteClubParams = {
  id: Scalars['ID']['input'];
};

export type DeleteClubResult = {
  __typename?: 'DeleteClubResult';
  error?: Maybe<DeleteClubError>;
  success: Scalars['Boolean']['output'];
};

export type DeleteCommentParams = {
  id: Scalars['ID']['input'];
};

export type DeleteCommentResult = {
  __typename?: 'DeleteCommentResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteDiscountCodeParams = {
  id: Scalars['ID']['input'];
};

export type DeleteEventAttendeeParams = {
  /** Optional free-text note from the attendee explaining the cancellation. */
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Attendee-supplied cancellation reason. Required server-side when the
   * canceller is the attendee themselves and the event is non-empty.
   */
  cancellationReason?: InputMaybe<AttendeeCancellationReason>;
  id: Scalars['ID']['input'];
  /**
   * The legacy reason for deleting the attendee. Required for ticketed clients
   * that omit refundType.
   * Use refundType to control refund behavior.
   * @deprecated Use refundType to control refund behavior. reason remains supported for legacy removal metadata.
   */
  reason?: InputMaybe<DeleteEventAttendeeReason>;
  /**
   * Explicit refund behavior for paid attendee removals. Optional for
   * backwards compatibility; omitted values preserve the legacy behavior
   * inferred from reason.
   */
  refundType?: InputMaybe<AttendeeRefundType>;
};

export enum DeleteEventAttendeeReason {
  AdminFullRefund = 'ADMIN_FULL_REFUND',
  AdminInitiated = 'ADMIN_INITIATED',
  HostInitiated = 'HOST_INITIATED'
}

export type DeleteEventAttendeeResult = {
  __typename?: 'DeleteEventAttendeeResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteEventRequestParams = {
  /** Optional note stored with the request when its owner withdraws. */
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteEventRequestResult = {
  __typename?: 'DeleteEventRequestResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteIdeaInterestParams = {
  id: Scalars['ID']['input'];
};

export type DeleteIdeaInterestResult = {
  __typename?: 'DeleteIdeaInterestResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteIdeaParams = {
  id: Scalars['ID']['input'];
};

export type DeleteIdeaResult = {
  __typename?: 'DeleteIdeaResult';
  success: Scalars['Boolean']['output'];
};

export type DeletePostParams = {
  id: Scalars['ID']['input'];
};

export type DeletePostResult = {
  __typename?: 'DeletePostResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult';
  success: Scalars['Boolean']['output'];
};

export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type DirectInvitesSentParams = {
  status?: InputMaybe<EventDirectInviteStatus>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  clubID?: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currentUses: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxUses?: Maybe<Scalars['Int']['output']>;
  type: DiscountCodeType;
  updatedAt: Scalars['Date']['output'];
  userID?: Maybe<Scalars['ID']['output']>;
  value: Scalars['Int']['output'];
};

export type DiscountCodeEdge = {
  __typename?: 'DiscountCodeEdge';
  cursor: Scalars['String']['output'];
  node: DiscountCode;
};

export enum DiscountCodeType {
  Fixed = 'FIXED',
  Free = 'FREE',
  Percentage = 'PERCENTAGE'
}

export type DiscountCodeValidation = {
  __typename?: 'DiscountCodeValidation';
  discountCode?: Maybe<DiscountCode>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type DiscountCodesConnection = {
  __typename?: 'DiscountCodesConnection';
  edges: Array<DiscountCodeEdge>;
  pageInfo: PageInfo;
};

export type DiscountCodesParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type DiscoveriesConnection = {
  __typename?: 'DiscoveriesConnection';
  categories: Array<DiscoveryCategory>;
  edges: Array<DiscoveryEdge>;
  pageInfo: PageInfo;
};

export type Discovery = {
  __typename?: 'Discovery';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  locationCity: LocationCity;
  name: Scalars['String']['output'];
  references: Array<DiscoveryReference>;
};

export type DiscoveryCategory = {
  __typename?: 'DiscoveryCategory';
  /** First active date in the city's timezone, inclusive, formatted YYYY-MM-DD. */
  activeFrom?: Maybe<Scalars['String']['output']>;
  /** Last active date in the city's timezone, inclusive, formatted YYYY-MM-DD. */
  activeUntil?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: DiscoveryCategoryKind;
  locationCityID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum DiscoveryCategoryKind {
  Fixed = 'FIXED',
  Mood = 'MOOD'
}

export type DiscoveryEdge = {
  __typename?: 'DiscoveryEdge';
  cursor: Scalars['ID']['output'];
  node: Discovery;
};

export type DiscoveryReference = {
  __typename?: 'DiscoveryReference';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type DismissChatRoomActivityError = {
  __typename?: 'DismissChatRoomActivityError';
  message?: Maybe<Scalars['String']['output']>;
  type: DismissChatRoomActivityErrors;
};

export enum DismissChatRoomActivityErrors {
  ActivityNotFound = 'ACTIVITY_NOT_FOUND',
  AlreadyDismissed = 'ALREADY_DISMISSED',
  NotParticipant = 'NOT_PARTICIPANT'
}

export type DismissChatRoomActivityInput = {
  activityID: Scalars['ID']['input'];
};

export type DismissChatRoomActivityResult = {
  __typename?: 'DismissChatRoomActivityResult';
  errors?: Maybe<Array<DismissChatRoomActivityError>>;
  success: Scalars['Boolean']['output'];
};

export type DisplayNameInput = {
  text: Scalars['String']['input'];
};

export type DuplicateEventError = {
  __typename?: 'DuplicateEventError';
  message?: Maybe<Scalars['String']['output']>;
  type: DuplicateEventErrors;
};

export enum DuplicateEventErrors {
  CapacityBelowAttendeeCount = 'CAPACITY_BELOW_ATTENDEE_COUNT',
  GooglePlaceNotFound = 'GOOGLE_PLACE_NOT_FOUND',
  InvalidGooglePlaceId = 'INVALID_GOOGLE_PLACE_ID',
  InvalidTicketVariations = 'INVALID_TICKET_VARIATIONS',
  LocationCityResolutionFailed = 'LOCATION_CITY_RESOLUTION_FAILED',
  LocationOutsideSupportedCity = 'LOCATION_OUTSIDE_SUPPORTED_CITY',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotClubManager = 'NOT_CLUB_MANAGER',
  SourceEventNotFound = 'SOURCE_EVENT_NOT_FOUND',
  StartDateInPast = 'START_DATE_IN_PAST',
  TitleTooLong = 'TITLE_TOO_LONG',
  TooManyBannerImages = 'TOO_MANY_BANNER_IMAGES'
}

export type DuplicateEventInput = {
  /** New event end date/time */
  endDate: Scalars['Date']['input'];
  /** The event to copy from */
  sourceEventId: Scalars['ID']['input'];
  /** New event start date/time */
  startDate: Scalars['Date']['input'];
};

export type DuplicateEventResult = {
  __typename?: 'DuplicateEventResult';
  errors?: Maybe<Array<DuplicateEventError>>;
  event?: Maybe<Event>;
  success: Scalars['Boolean']['output'];
};

export type EditChatMessageV2Error = {
  __typename?: 'EditChatMessageV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: EditChatMessageV2Errors;
};

export enum EditChatMessageV2Errors {
  BlockedUrl = 'BLOCKED_URL',
  MessageNotFound = 'MESSAGE_NOT_FOUND',
  NotAuthor = 'NOT_AUTHOR'
}

export type EditChatMessageV2Input = {
  messageID: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type EditChatMessageV2Result = {
  __typename?: 'EditChatMessageV2Result';
  errors?: Maybe<Array<EditChatMessageV2Error>>;
  message?: Maybe<ChatMessageV2>;
  success: Scalars['Boolean']['output'];
};

export type EntityEvent = {
  __typename?: 'EntityEvent';
  data: Scalars['JSON']['output'];
  dismissed: Scalars['Boolean']['output'];
  entityID: Scalars['ID']['output'];
  entityType: EntityEventEntityType;
  id: Scalars['ID']['output'];
  type: EntityEventType;
};

export enum EntityEventEntityType {
  Club = 'CLUB',
  Event = 'EVENT',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export enum EntityEventType {
  AttendanceReconfirmation = 'ATTENDANCE_RECONFIRMATION',
  AttendeeJoinedNotification = 'ATTENDEE_JOINED_NOTIFICATION',
  AttendeeLeftEventWaitlistNotification = 'ATTENDEE_LEFT_EVENT_WAITLIST_NOTIFICATION',
  ClubChatCreated = 'CLUB_CHAT_CREATED',
  ClubMemberJoined = 'CLUB_MEMBER_JOINED',
  ClubOnboardingChat = 'CLUB_ONBOARDING_CHAT',
  ClubOnboardingFirstPlan = 'CLUB_ONBOARDING_FIRST_PLAN',
  ClubOnboardingHome = 'CLUB_ONBOARDING_HOME',
  ClubOnboardingShare = 'CLUB_ONBOARDING_SHARE',
  ClubOnboardingStart = 'CLUB_ONBOARDING_START',
  ClubOnboardingWelcomeMessage = 'CLUB_ONBOARDING_WELCOME_MESSAGE',
  ClubVerified = 'CLUB_VERIFIED',
  DirectInviteReceived = 'DIRECT_INVITE_RECEIVED',
  EventConflictFromHostAccept = 'EVENT_CONFLICT_FROM_HOST_ACCEPT',
  FoundingMemberAwarded = 'FOUNDING_MEMBER_AWARDED',
  HostKitGranted = 'HOST_KIT_GRANTED',
  RequestUserWaitlistNotification = 'REQUEST_USER_WAITLIST_NOTIFICATION',
  Unknown = 'UNKNOWN'
}

export type EntityEventsParams = {
  includeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<EntityEventType>>;
};

export type Event = {
  __typename?: 'Event';
  absorbFees: Scalars['Boolean']['output'];
  ages: Array<Ages>;
  allowInvites: Scalars['Boolean']['output'];
  approveGuests: Scalars['Boolean']['output'];
  atCapacity: Scalars['Boolean']['output'];
  attendees: EventAttendeesConnection;
  bannerImageUrl: Scalars['String']['output'];
  bannerImageUrls: Array<Scalars['String']['output']>;
  canceled: Scalars['Boolean']['output'];
  /**
   * Free-text host note for cancellations, currently used when the host selects
   * "Something else". Null when no note was provided.
   */
  cancellationNote?: Maybe<Scalars['String']['output']>;
  /**
   * Host-selected reason for cancelling this plan. Null when the plan has not
   * been cancelled or older cancellations did not capture a reason.
   */
  cancellationReason?: Maybe<EventCancellationReason>;
  /** When this plan was cancelled. Null while the plan is active. */
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  capacity: Scalars['Int']['output'];
  category?: Maybe<EventCategory>;
  club?: Maybe<Club>;
  clubID?: Maybe<Scalars['ID']['output']>;
  /**
   * Reliability stats for the hosting club, scoped to the event's city.
   * Null when the event is not hosted under a club (clubID is nil).
   * Counters are global; badge / cityRanking come from club_city_stats
   * keyed by (club_id, event city).
   */
  clubStats?: Maybe<ClubStats>;
  comments: CommentsConnection;
  /**
   * The transitive closure of the viewer's conflict graph rooted at this event:
   * every event the viewer is actively attending that overlaps in time with
   * this one, transitively through other overlaps. Includes this event when
   * the viewer is actively attending it. Empty for unauthenticated viewers,
   * when the viewer has only a pending request / waitlist entry / unaccepted
   * invite on this event, or when the viewer has no overlapping commitments.
   * Use this (rather than conflictingEvents) when you need the whole
   * connected component (e.g. "Sort your clashes").
   */
  conflictCluster: EventsConnection;
  /**
   * Events the viewer is attending that overlap in time with this event.
   * Uses half-open interval overlap, so back-to-back events do not conflict.
   * Returns an empty connection for unauthenticated viewers.
   */
  conflictingEvents: EventsConnection;
  coverCost?: Maybe<EventCoverCost>;
  createdAt: Scalars['Date']['output'];
  /** Plain-text description (HTML stripped). Use for previews, notifications, search, calendar notes. */
  description: Scalars['String']['output'];
  directInvitesSent: EventDirectInvitesConnection;
  earlyBirdDiscount?: Maybe<Scalars['Int']['output']>;
  earlyBirdTicketCost?: Maybe<EventTicketCost>;
  endDate: Scalars['Date']['output'];
  entityEvents: Array<EntityEvent>;
  formInputs: Array<EventFormInput>;
  friendsAttending: FriendsAttendingConnection;
  genders: Array<Gender>;
  hasEnded: Scalars['Boolean']['output'];
  hasStarted: Scalars['Boolean']['output'];
  headline: Scalars['String']['output'];
  hiddenReason?: Maybe<EventHiddenReason>;
  hideFromNonMatching: Scalars['Boolean']['output'];
  highlightMedia: EventReviewHighlightMediaConnection;
  hosts: Array<Host>;
  id: Scalars['ID']['output'];
  inWaitlist: Scalars['Boolean']['output'];
  insight?: Maybe<EventPersonalizedInsight>;
  /** @deprecated Compatibility shim; use category instead */
  interests: Array<Scalars['String']['output']>;
  inviteGroups: Array<EventInviteGroup>;
  isAttending: Scalars['Boolean']['output'];
  isHosting: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  /**
   * Open Graph metadata resolved for URLs found in the event description.
   * Populated asynchronously by a worker after create/update — may be empty
   * until resolution completes. Clients can use this to render link text from
   * the resolved page title instead of the raw URL.
   */
  linkPreviews: Array<EventLinkPreview>;
  /** @deprecated Use place */
  location: Location;
  /** @deprecated Use place.name */
  locationName: Scalars['String']['output'];
  /**
   * Legacy event suburb identifier. Events now use an internal event city;
   * this remains nullable for old clients and resolves to null for plan events.
   * @deprecated Events no longer store a location suburb
   */
  locationSuburbId?: Maybe<Scalars['ID']['output']>;
  /** Sanitized HTML menu sample for rendering with a rich-text component. Null when the menu has no rich formatting — clients should fall back to `menuSample`. Anchor text for raw-URL links is replaced server-side with the page title resolved by the link-preview worker. */
  menuRichText?: Maybe<Scalars['String']['output']>;
  /** Plain-text menu sample (HTML stripped). Use for old clients, previews, notifications, and search. */
  menuSample: Scalars['String']['output'];
  myAttendance?: Maybe<EventAttendee>;
  myHost?: Maybe<Host>;
  myPendingDirectInvite?: Maybe<EventDirectInvite>;
  myRequest?: Maybe<EventRequest>;
  /** Whether the authenticated viewer has a processed, active ticket outside refund handling. */
  myTicketConfirmed: Scalars['Boolean']['output'];
  pendingRequestCount: Scalars['Int']['output'];
  personalizedSummary?: Maybe<Scalars['String']['output']>;
  /** Canonical Butter place with exact details redacted for unauthorized viewers. */
  place: EventPlace;
  /**
   * The host flagged as `primary` on this event. Returns null only if the
   * event has no rows in event_hosts — every published event should have
   * exactly one primary host. Prefer this over `hosts` when you only need
   * the lead host's profile / stats; co-host stats are never surfaced in
   * event-context displays.
   */
  primaryHost?: Maybe<Host>;
  /** Whether the exact venue, address, and coordinates are public to non-guests. */
  publicPreciseLocation: Scalars['Boolean']['output'];
  publishedAt: Scalars['Date']['output'];
  regularTicketCost?: Maybe<EventTicketCost>;
  requests: EventRequestsConnection;
  review?: Maybe<EventReview>;
  /** Sanitized HTML description for rendering with a rich-text component. Null when the description has no rich formatting — clients should fall back to `description`. Anchor text for raw-URL links is replaced server-side with the page title resolved by the link-preview worker. */
  richDescription?: Maybe<Scalars['String']['output']>;
  saved: Scalars['Boolean']['output'];
  similarEvents: Array<Event>;
  similarEventsV2: EventsConnection;
  startDate: Scalars['Date']['output'];
  structure?: Maybe<EventStructure>;
  ticketEarnings?: Maybe<EventTicketEarningsSummary>;
  ticketInclusions: Array<EventTicketInclusion>;
  ticketPrice: Scalars['Int']['output'];
  ticketVariations: Array<EventTicketVariation>;
  tippingEnabled: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  tone?: Maybe<EventTone>;
  /**
   * Gross ticket revenue in the event's current payable-wallet currency only.
   * @deprecated Use ticketEarnings instead
   */
  totalRevenueCents: Scalars['Int']['output'];
  /** @deprecated Use ticketEarnings instead */
  totalTicketsSold: Scalars['Int']['output'];
  type: EventType;
  uneditableFields: Array<EventUneditableField>;
  /** Get a specific user's attendance record for this event, if they are attending. */
  userAttendance?: Maybe<EventAttendee>;
  /** Get a specific user's pending direct invite to this event, if one exists. */
  userPendingDirectInvite?: Maybe<EventDirectInvite>;
  viewCount24h: Scalars['Int']['output'];
  waitlists: Scalars['Boolean']['output'];
};


export type EventAttendeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params?: InputMaybe<EventAttendeeParams>;
};


export type EventCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventConflictClusterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type EventConflictingEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type EventDirectInvitesSentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params?: InputMaybe<DirectInvitesSentParams>;
};


export type EventFriendsAttendingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type EventHighlightMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type EventInviteGroupsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type EventRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type EventSimilarEventsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params: SimilarEventsParams;
};


export type EventUserAttendanceArgs = {
  userID: Scalars['ID']['input'];
};


export type EventUserPendingDirectInviteArgs = {
  userID: Scalars['ID']['input'];
};

export type EventAttendee = {
  __typename?: 'EventAttendee';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  /**
   * Stats impact stamped at cancellation time. Null while the attendance is
   * active.
   */
  cancellationImpact?: Maybe<CancellationImpact>;
  /**
   * Attendee-supplied reason for a self-cancellation. Null when still active
   * or when cancelled by a host/admin.
   */
  cancellationReason?: Maybe<AttendeeCancellationReason>;
  /** When this attendance was cancelled. Null while the attendance is active. */
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  eventID: Scalars['ID']['output'];
  eventRegistrationID?: Maybe<Scalars['ID']['output']>;
  eventReservationID?: Maybe<Scalars['ID']['output']>;
  form?: Maybe<Array<EventRequestFormAnswer>>;
  /** Guest reliability stats scoped to this event city. */
  guestStats: GuestStats;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  onTheWay: Scalars['Boolean']['output'];
  reconfirmed: Scalars['Boolean']['output'];
  /** Attendee-supplied reason for a refund request. Null when no reason was provided. */
  refundRequestReason?: Maybe<Scalars['String']['output']>;
  /** When this ticketed attendee requested a refund. Null when no refund has been requested. */
  refundRequestedAt?: Maybe<Scalars['Date']['output']>;
  reservation?: Maybe<EventReservation>;
  ticketSale?: Maybe<WalletIntentEventTicketSale>;
  /** The canonical ticket variation purchased by this attendee. Null for legacy tickets. */
  ticketVariation?: Maybe<EventTicketVariation>;
  user: User;
  userID: Scalars['ID']['output'];
};

export type EventAttendeeEdge = {
  __typename?: 'EventAttendeeEdge';
  cursor: Scalars['String']['output'];
  node: EventAttendee;
};

export type EventAttendeeParams = {
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EventAttendeeStatusFilter>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export enum EventAttendeeStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Cancelled = 'CANCELLED'
}

export type EventAttendeesConnection = {
  __typename?: 'EventAttendeesConnection';
  edges: Array<EventAttendeeEdge>;
  pageInfo: PageInfo;
};

/**
 * Reason a host selects when cancelling their plan. The labels rendered to
 * the host live in the mobile app — this enum is the persisted backing
 * value. New entries should be added at the end so old clients keep working.
 */
export enum EventCancellationReason {
  AvailabilityChanged = 'AVAILABILITY_CHANGED',
  CoverCostRequirementNotMet = 'COVER_COST_REQUIREMENT_NOT_MET',
  GuestsUnresponsive = 'GUESTS_UNRESPONSIVE',
  NervousAboutOffline = 'NERVOUS_ABOUT_OFFLINE',
  NotEnoughPeople = 'NOT_ENOUGH_PEOPLE',
  Other = 'OTHER',
  WantedGuestsLeft = 'WANTED_GUESTS_LEFT',
  WontConnectWithGuests = 'WONT_CONNECT_WITH_GUESTS'
}

export type EventCategory = {
  __typename?: 'EventCategory';
  children: Array<EventCategory>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<EventCategory>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  verified: Scalars['Boolean']['output'];
};

export type EventCodeInvite = {
  __typename?: 'EventCodeInvite';
  claimCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: User;
  createdByUserID: Scalars['ID']['output'];
  event: Event;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export enum EventConflictResolutionAction {
  /** Immediate soft-cancel of an existing attendance. Free events only. */
  LeaveEvent = 'LEAVE_EVENT',
  /**
   * Stamp refund_requested fields on an existing ticketed attendance or a
   * confirmed paid Cover Cost attendance. Does NOT remove the user — host/admin
   * still drives the actual cancel.
   */
  RequestRefund = 'REQUEST_REFUND',
  /**
   * Create attendance for the (free) target event. Ticketed events must
   * use the existing ticket-purchase flow.
   */
  RsvpEvent = 'RSVP_EVENT',
  /** Add the event to saved plans. */
  SaveEvent = 'SAVE_EVENT',
  /** Remove the event from saved plans. */
  UnsaveEvent = 'UNSAVE_EVENT'
}

export type EventConflictResolutionOperation = {
  action: EventConflictResolutionAction;
  /** Optional, only meaningful with LEAVE_EVENT. */
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  /** Optional, only meaningful with LEAVE_EVENT. */
  cancellationReason?: InputMaybe<AttendeeCancellationReason>;
  eventID: Scalars['ID']['input'];
  /** Optional, only meaningful with REQUEST_REFUND. */
  refundReason?: InputMaybe<Scalars['String']['input']>;
};

export type EventConflictResolutionPreview = {
  __typename?: 'EventConflictResolutionPreview';
  /**
   * True when the previewed operation should be highlighted as
   * stats-impacting. For guest conflict resolution this means a LEAVE op counts
   * as a late cancellation; for host event cancellation this means active
   * attendees make the cancellation count against host stats.
   */
  countsAsLateCancellation: Scalars['Boolean']['output'];
  /**
   * 1-based city ranking for the relevant stats context; home city for
   * guest conflict resolution, event city for host cancellation. Null when the
   * user has no applicable city or has never ranked.
   */
  currentCityRanking?: Maybe<Scalars['Int']['output']>;
  /** Current global plan streak. */
  currentPlanStreak: Scalars['Int']['output'];
  projectedCityRanking?: Maybe<Scalars['Int']['output']>;
  /** Plan streak after the previewed operation is applied. */
  projectedPlanStreak: Scalars['Int']['output'];
};

export type EventCoverCost = {
  __typename?: 'EventCoverCost';
  amountDueCents: Scalars['Int']['output'];
  amountDueCentsTotal: Scalars['Int']['output'];
  /**
   * True when the authenticated viewer can currently create a Cover Cost join action.
   * This includes either a paid pending request or a direct waitlist request, and
   * excludes viewers who are already attending, hosting, or have an active request.
   */
  canSendJoinRequest: Scalars['Boolean']['output'];
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  contributedParticipantCount: Scalars['Int']['output'];
  coveredParticipantCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  /**
   * Event-level Cover Cost request availability, ignoring viewer-specific host,
   * attendee, and existing-request state. Prefer canSendJoinRequest for viewer CTAs.
   */
  openForNewRequests: Scalars['Boolean']['output'];
  participantCount: Scalars['Int']['output'];
  perPersonCents: Scalars['Int']['output'];
  perPersonCentsTotal: Scalars['Int']['output'];
  raisedCents: Scalars['Int']['output'];
  refundedCents: Scalars['Int']['output'];
  refundedParticipantCount: Scalars['Int']['output'];
  releasedAt?: Maybe<Scalars['Date']['output']>;
  remainingCents: Scalars['Int']['output'];
  requiredBy: Scalars['Date']['output'];
  requiredCents: Scalars['Int']['output'];
  requiredParticipants: Scalars['Int']['output'];
};

export type EventCoverCostParams = {
  description?: InputMaybe<Scalars['String']['input']>;
  perPersonCents?: InputMaybe<Scalars['Int']['input']>;
  perPersonCentsTotal?: InputMaybe<Scalars['Int']['input']>;
  requiredBy?: InputMaybe<Scalars['Date']['input']>;
  requiredParticipants?: InputMaybe<Scalars['Int']['input']>;
};

export type EventDirectInvite = {
  __typename?: 'EventDirectInvite';
  createdAt: Scalars['Date']['output'];
  event: Event;
  eventID: Scalars['ID']['output'];
  /** Guest reliability stats for the invitee scoped to this event city. */
  guestStats: GuestStats;
  id: Scalars['ID']['output'];
  invitee: User;
  inviteeUserID: Scalars['ID']['output'];
  inviter: User;
  inviterUserID: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['Date']['output']>;
  status: EventDirectInviteStatus;
};

export type EventDirectInviteEdge = {
  __typename?: 'EventDirectInviteEdge';
  cursor: Scalars['String']['output'];
  node: EventDirectInvite;
};

export enum EventDirectInviteStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type EventDirectInvitesConnection = {
  __typename?: 'EventDirectInvitesConnection';
  edges: Array<EventDirectInviteEdge>;
  pageInfo: PageInfo;
};

export type EventDirectInvitesSentParams = {
  eventID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EventDirectInviteStatus>;
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventFormInput = {
  __typename?: 'EventFormInput';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
  selectOptions: Array<Scalars['String']['output']>;
  type: EventFormInputType;
};

export type EventFormInputAnswer = {
  formQuestionID?: InputMaybe<Scalars['ID']['input']>;
  formQuestionLabel: Scalars['String']['input'];
  formQuestionOptions: Array<Scalars['String']['input']>;
  formQuestionType: EventFormInputType;
  selectedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['String']['input'];
};

export enum EventFormInputType {
  Select = 'SELECT',
  Text = 'TEXT'
}

export enum EventHiddenReason {
  AdminHidden = 'ADMIN_HIDDEN',
  WaitingTicketSalesApproval = 'WAITING_TICKET_SALES_APPROVAL'
}

export type EventHostDetails = {
  __typename?: 'EventHostDetails';
  headline?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  profileMediaImage?: Maybe<MediaImage>;
  profileMediaImageId?: Maybe<Scalars['ID']['output']>;
};

export type EventInviteGroup = {
  __typename?: 'EventInviteGroup';
  audiences: Array<EventInviteGroupAudience>;
  event?: Maybe<Event>;
  id: Scalars['ID']['output'];
  kind: EventInviteGroupKind;
  people: EventInviteGroupPeopleConnection;
  summary: EventInviteGroupPeopleSummary;
};


export type EventInviteGroupPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type EventInviteGroupAudience = {
  __typename?: 'EventInviteGroupAudience';
  summary: EventInviteGroupPeopleSummary;
  type: EventInviteGroupPersonType;
};

export type EventInviteGroupAudienceSelection = {
  excludedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode: EventInviteRecipientSelectionMode;
  type: EventInviteGroupPersonType;
};

export enum EventInviteGroupKind {
  ClubMembers = 'CLUB_MEMBERS',
  PreviousEvent = 'PREVIOUS_EVENT',
  Referrals = 'REFERRALS'
}

export type EventInviteGroupPeopleConnection = {
  __typename?: 'EventInviteGroupPeopleConnection';
  edges: Array<EventInviteGroupPersonEdge>;
  pageInfo: PageInfo;
};

export type EventInviteGroupPeopleSummary = {
  __typename?: 'EventInviteGroupPeopleSummary';
  attendingCount: Scalars['Int']['output'];
  invitableCount: Scalars['Int']['output'];
  invitedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  unavailableCount: Scalars['Int']['output'];
};

export type EventInviteGroupPerson = {
  __typename?: 'EventInviteGroupPerson';
  status: EventInviteGroupPersonStatus;
  type: EventInviteGroupPersonType;
  user: User;
};

export type EventInviteGroupPersonEdge = {
  __typename?: 'EventInviteGroupPersonEdge';
  cursor: Scalars['String']['output'];
  node: EventInviteGroupPerson;
};

export enum EventInviteGroupPersonStatus {
  AlreadyAttending = 'ALREADY_ATTENDING',
  AlreadyInvited = 'ALREADY_INVITED',
  AlreadyRequested = 'ALREADY_REQUESTED',
  AlreadyWaitlisted = 'ALREADY_WAITLISTED',
  Host = 'HOST',
  Invitable = 'INVITABLE'
}

export enum EventInviteGroupPersonType {
  ClubMember = 'CLUB_MEMBER',
  Guest = 'GUEST',
  Referred = 'REFERRED',
  Waitlisted = 'WAITLISTED'
}

export type EventInviteGroupSelection = {
  audiences: Array<EventInviteGroupAudienceSelection>;
  groupID: Scalars['ID']['input'];
};

export enum EventInviteRecipientSelectionMode {
  AllEligible = 'ALL_ELIGIBLE',
  SelectedUsers = 'SELECTED_USERS'
}

export type EventLinkPreview = {
  __typename?: 'EventLinkPreview';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type EventParams = {
  id: Scalars['ID']['input'];
};

export type EventPersonalizedInsight = {
  __typename?: 'EventPersonalizedInsight';
  body: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Viewer-specific Butter place details for an event. */
export type EventPlace = {
  __typename?: 'EventPlace';
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<LocationCoordinates>;
  country?: Maybe<Scalars['String']['output']>;
  exactDetailsHidden: Scalars['Boolean']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * The selected location is a geographic area, such as a city or neighborhood,
   * rather than a specific venue or address. Independent of viewer permissions.
   */
  isGeneralArea: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postcode?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export enum EventRating {
  Awesome = 'AWESOME',
  MissedIt = 'MISSED_IT',
  Ok = 'OK'
}

export type EventRegistration = {
  __typename?: 'EventRegistration';
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  decisionExpiresAt?: Maybe<Scalars['Date']['output']>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  requestState?: Maybe<EventRequestState>;
  requestType?: Maybe<EventRequestType>;
  resolutionReason?: Maybe<EventRequestResolutionReason>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  submittedAt?: Maybe<Scalars['Date']['output']>;
};

export type EventRequest = {
  __typename?: 'EventRequest';
  /** @deprecated Use state instead. */
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  decisionExpiresAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use state instead. */
  declined: Scalars['Boolean']['output'];
  eventRegistrationID?: Maybe<Scalars['ID']['output']>;
  eventReservationID?: Maybe<Scalars['ID']['output']>;
  form?: Maybe<Array<EventRequestFormAnswer>>;
  /** Guest reliability stats scoped to this event city. */
  guestStats: GuestStats;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reservation?: Maybe<EventReservation>;
  resolutionReason?: Maybe<EventRequestResolutionReason>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  state: EventRequestState;
  submittedAt?: Maybe<Scalars['Date']['output']>;
  ticketPurchase?: Maybe<EventRequestTicketPurchaseDetails>;
  ticketPurchaseCode?: Maybe<EventTicketPurchaseCode>;
  type: EventRequestType;
  user: User;
  userID: Scalars['ID']['output'];
};

export type EventRequestEdge = {
  __typename?: 'EventRequestEdge';
  cursor: Scalars['String']['output'];
  node: EventRequest;
};

export type EventRequestFormAnswer = {
  __typename?: 'EventRequestFormAnswer';
  formQuestionID?: Maybe<Scalars['ID']['output']>;
  formQuestionLabel: Scalars['String']['output'];
  formQuestionOptions: Array<Scalars['String']['output']>;
  formQuestionType: EventFormInputType;
  selectedValues?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
};

export type EventRequestParams = {
  eventID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export enum EventRequestResolutionReason {
  ApprovalDeadline = 'APPROVAL_DEADLINE',
  EventFull = 'EVENT_FULL',
  HostDeclined = 'HOST_DECLINED',
  PaymentCancelled = 'PAYMENT_CANCELLED',
  PaymentFailed = 'PAYMENT_FAILED',
  UserWithdrew = 'USER_WITHDREW',
  VariationSoldOut = 'VARIATION_SOLD_OUT'
}

export enum EventRequestState {
  Approving = 'APPROVING',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  InAcceptedWaitlist = 'IN_ACCEPTED_WAITLIST',
  Pending = 'PENDING',
  PendingWaitlist = 'PENDING_WAITLIST'
}

/**
 * Request-scoped ticket purchase details visible to the requester and event host.
 * Excludes wallet, Stripe, and internal payment identifiers.
 */
export type EventRequestTicketPurchaseDetails = {
  __typename?: 'EventRequestTicketPurchaseDetails';
  state: WalletIntentState;
  totalCostCents: Scalars['Int']['output'];
  variation?: Maybe<EventTicketVariation>;
};

export enum EventRequestType {
  Invite = 'INVITE',
  Request = 'REQUEST'
}

export type EventRequestsConnection = {
  __typename?: 'EventRequestsConnection';
  edges: Array<EventRequestEdge>;
  pageInfo: PageInfo;
};

export type EventReservation = {
  __typename?: 'EventReservation';
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  eventID: Scalars['ID']['output'];
  eventRegistrationID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  registration?: Maybe<EventRegistration>;
  reservedAt?: Maybe<Scalars['Date']['output']>;
  state: EventReservationState;
  userID?: Maybe<Scalars['ID']['output']>;
};

export enum EventReservationState {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Reserved = 'RESERVED'
}

export type EventReview = {
  __typename?: 'EventReview';
  attendance: EventReviewAttendanceConnection;
  attended?: Maybe<Scalars['Boolean']['output']>;
  clubStatsAfter?: Maybe<ClubStats>;
  clubStatsBefore?: Maybe<ClubStats>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  currentStep: ReviewStep;
  earnedClubBadges: Array<ClubBadge>;
  earnedGuestBadges: Array<GuestBadge>;
  earnedGuestRewards: Array<GuestReward>;
  earnedHostBadges: Array<HostBadge>;
  earnedHostRewards: Array<HostReward>;
  /** @deprecated Use earnedGuestRewards / earnedHostRewards. Always returns an empty list. */
  earnedRewards: Array<UserReward>;
  event: Event;
  eventID: Scalars['ID']['output'];
  eventRating?: Maybe<EventRating>;
  finalizedAt?: Maybe<Scalars['Date']['output']>;
  guestStatsAfter?: Maybe<GuestStats>;
  guestStatsBefore?: Maybe<GuestStats>;
  highlightMedia: EventReviewHighlightMediaConnection;
  hostNoShows: Array<EventReviewHostNoShow>;
  hostStatsAfter?: Maybe<HostStats>;
  hostStatsBefore?: Maybe<HostStats>;
  id: Scalars['ID']['output'];
  isFinalized: Scalars['Boolean']['output'];
  isHost: Scalars['Boolean']['output'];
  /** @deprecated use guestStatsAfter */
  statsAfter?: Maybe<UserStats>;
  /** @deprecated use guestStatsBefore */
  statsBefore?: Maybe<UserStats>;
  tip?: Maybe<WalletIntentTipSent>;
  tippable?: Maybe<TipRecipient>;
  user: User;
  userID: Scalars['ID']['output'];
  userTags: EventReviewUserTagConnection;
  usersLiked: EventReviewUserLikedConnection;
};


export type EventReviewAttendanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type EventReviewHighlightMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  scope?: InputMaybe<HighlightMediaScope>;
};


export type EventReviewUserTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type EventReviewUsersLikedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type EventReviewAttendance = {
  __typename?: 'EventReviewAttendance';
  attended: Scalars['Boolean']['output'];
  attendeeUser: User;
  attendeeUserID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type EventReviewAttendanceConnection = {
  __typename?: 'EventReviewAttendanceConnection';
  edges: Array<EventReviewAttendanceEdge>;
  pageInfo: PageInfo;
};

export type EventReviewAttendanceEdge = {
  __typename?: 'EventReviewAttendanceEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewAttendance;
};

export type EventReviewConnection = {
  __typename?: 'EventReviewConnection';
  edges: Array<EventReviewEdge>;
  pageInfo: PageInfo;
};

export type EventReviewEdge = {
  __typename?: 'EventReviewEdge';
  cursor: Scalars['String']['output'];
  node: EventReview;
};

export type EventReviewError = {
  __typename?: 'EventReviewError';
  code: EventReviewErrorCode;
  message: Scalars['String']['output'];
};

export enum EventReviewErrorCode {
  EventReviewAlreadyCompleted = 'EVENT_REVIEW_ALREADY_COMPLETED',
  EventReviewExpired = 'EVENT_REVIEW_EXPIRED',
  EventReviewNotFound = 'EVENT_REVIEW_NOT_FOUND',
  HighlightMediaNotFound = 'HIGHLIGHT_MEDIA_NOT_FOUND',
  HostOnly = 'HOST_ONLY',
  InvalidRating = 'INVALID_RATING',
  InvalidStep = 'INVALID_STEP',
  MediaAlreadyAdded = 'MEDIA_ALREADY_ADDED',
  NotAuthorized = 'NOT_AUTHORIZED',
  NoMediaProvided = 'NO_MEDIA_PROVIDED'
}

export type EventReviewHighlightMedia = {
  __typename?: 'EventReviewHighlightMedia';
  createdAt: Scalars['Date']['output'];
  event: Event;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  mediaImage?: Maybe<MediaImage>;
  mediaImageID?: Maybe<Scalars['ID']['output']>;
  mediaVideo?: Maybe<MediaVideo>;
  mediaVideoID?: Maybe<Scalars['ID']['output']>;
  uploadedByUser: User;
  uploadedByUserID: Scalars['ID']['output'];
};

export type EventReviewHighlightMediaConnection = {
  __typename?: 'EventReviewHighlightMediaConnection';
  edges: Array<EventReviewHighlightMediaEdge>;
  pageInfo: PageInfo;
};

export type EventReviewHighlightMediaEdge = {
  __typename?: 'EventReviewHighlightMediaEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewHighlightMedia;
};

export type EventReviewHighlightMediaInput = {
  eventId: Scalars['ID']['input'];
};

export type EventReviewHighlightMonth = {
  __typename?: 'EventReviewHighlightMonth';
  count: Scalars['Int']['output'];
  media: EventReviewHighlightMediaConnection;
  month: Scalars['Int']['output'];
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};


export type EventReviewHighlightMonthMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type EventReviewHostNoShow = {
  __typename?: 'EventReviewHostNoShow';
  hostUser: User;
  hostUserID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type EventReviewHostNoShowConnection = {
  __typename?: 'EventReviewHostNoShowConnection';
  edges: Array<EventReviewHostNoShowEdge>;
  pageInfo: PageInfo;
};

export type EventReviewHostNoShowEdge = {
  __typename?: 'EventReviewHostNoShowEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewHostNoShow;
};

export type EventReviewInput = {
  eventId: Scalars['ID']['input'];
};

export type EventReviewParticipant = {
  __typename?: 'EventReviewParticipant';
  id: Scalars['ID']['output'];
  user: User;
};

export type EventReviewParticipantConnection = {
  __typename?: 'EventReviewParticipantConnection';
  edges: Array<EventReviewParticipantEdge>;
  pageInfo: PageInfo;
};

export type EventReviewParticipantEdge = {
  __typename?: 'EventReviewParticipantEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewParticipant;
};

export type EventReviewParticipantsInput = {
  query?: InputMaybe<Scalars['String']['input']>;
  reviewId: Scalars['ID']['input'];
};

export type EventReviewStatus = {
  __typename?: 'EventReviewStatus';
  completed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type EventReviewStatusConnection = {
  __typename?: 'EventReviewStatusConnection';
  edges: Array<EventReviewStatusEdge>;
  pageInfo: PageInfo;
};

export type EventReviewStatusEdge = {
  __typename?: 'EventReviewStatusEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewStatus;
};

export type EventReviewStatusInput = {
  eventId: Scalars['ID']['input'];
};

export type EventReviewUserLiked = {
  __typename?: 'EventReviewUserLiked';
  id: Scalars['ID']['output'];
  targetUser: User;
  targetUserID: Scalars['ID']['output'];
};

export type EventReviewUserLikedConnection = {
  __typename?: 'EventReviewUserLikedConnection';
  edges: Array<EventReviewUserLikedEdge>;
  pageInfo: PageInfo;
};

export type EventReviewUserLikedEdge = {
  __typename?: 'EventReviewUserLikedEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewUserLiked;
};

export type EventReviewUserTag = {
  __typename?: 'EventReviewUserTag';
  event: Event;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tag: EventReviewUserTagType;
  taggedUser: User;
  taggedUserID: Scalars['ID']['output'];
  taggerUser: User;
  taggerUserID: Scalars['ID']['output'];
};

export type EventReviewUserTagConnection = {
  __typename?: 'EventReviewUserTagConnection';
  edges: Array<EventReviewUserTagEdge>;
  pageInfo: PageInfo;
};

export type EventReviewUserTagEdge = {
  __typename?: 'EventReviewUserTagEdge';
  cursor: Scalars['String']['output'];
  node: EventReviewUserTag;
};

export type EventReviewUserTagInput = {
  tags: Array<EventReviewUserTagType>;
  userId: Scalars['ID']['input'];
};

export enum EventReviewUserTagType {
  AsksGoodQs = 'ASKS_GOOD_QS',
  BringsPeopleIn = 'BRINGS_PEOPLE_IN',
  Confident = 'CONFIDENT',
  Considerate = 'CONSIDERATE',
  DeepChats = 'DEEP_CHATS',
  DryHumour = 'DRY_HUMOUR',
  GoesWithTheFlow = 'GOES_WITH_THE_FLOW',
  GoodTaste = 'GOOD_TASTE',
  GroupGlue = 'GROUP_GLUE',
  HighEnergy = 'HIGH_ENERGY',
  Outgoing = 'OUTGOING',
  QuickWit = 'QUICK_WIT',
  QuietFunny = 'QUIET_FUNNY',
  ShyFriendly = 'SHY_FRIENDLY',
  SillyEnergy = 'SILLY_ENERGY',
  SmartTakes = 'SMART_TAKES',
  SoftSpoken = 'SOFT_SPOKEN',
  Spontaneous = 'SPONTANEOUS',
  Storyteller = 'STORYTELLER',
  Thoughtful = 'THOUGHTFUL',
  WarmsUp = 'WARMS_UP'
}

export type EventScheduleConflictsParams = {
  endDate: Scalars['Date']['input'];
  excludeEventID?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export enum EventStructure {
  Casual = 'CASUAL',
  Curated = 'CURATED',
  OpenEnded = 'OPEN_ENDED'
}

export type EventTicketApprovalRequestInput = {
  eventRequestID?: InputMaybe<Scalars['ID']['input']>;
  form?: InputMaybe<Array<EventFormInputAnswer>>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type EventTicketCheckoutCost = {
  __typename?: 'EventTicketCheckoutCost';
  basePriceCents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  feeAmountCents: Scalars['Int']['output'];
  originalTotalCents?: Maybe<Scalars['Int']['output']>;
  stripeFeeCents: Scalars['Int']['output'];
  totalCostCents: Scalars['Int']['output'];
  totalDiscountCents: Scalars['Int']['output'];
};

export type EventTicketCost = {
  __typename?: 'EventTicketCost';
  available: Scalars['Boolean']['output'];
  basePriceCents: Scalars['Int']['output'];
  currency: WalletCurrency;
  discount: Scalars['Int']['output'];
  discountCents: Scalars['Int']['output'];
  earlyBirdDiscountCents: Scalars['Int']['output'];
  feeAmountCents: Scalars['Int']['output'];
  feePercentage: Scalars['Int']['output'];
  originalTotalCents: Scalars['Int']['output'];
  receivesCents: Scalars['Int']['output'];
  stripeFeeCents: Scalars['Int']['output'];
  totalCostCents: Scalars['Int']['output'];
  totalDiscountCents: Scalars['Int']['output'];
};

/** Ticket activity in the event's current payable-wallet currency. Other currencies are excluded. */
export type EventTicketEarningsSummary = {
  __typename?: 'EventTicketEarningsSummary';
  activeTicketsSold: Scalars['Int']['output'];
  currency: WalletCurrency;
  grossTicketSalesCents: Scalars['Int']['output'];
  grossTicketsSold: Scalars['Int']['output'];
  netEarningsCents: Scalars['Int']['output'];
  refundedTickets: Scalars['Int']['output'];
  refundsCents: Scalars['Int']['output'];
};

export type EventTicketInclusion = {
  __typename?: 'EventTicketInclusion';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export enum EventTicketPaymentMethod {
  Free = 'FREE',
  Stripe = 'STRIPE',
  Unknown = 'UNKNOWN',
  Wallet = 'WALLET'
}

export type EventTicketPurchaseCode = {
  __typename?: 'EventTicketPurchaseCode';
  anonymousUserID: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  event: Event;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  redeemedAt?: Maybe<Scalars['Date']['output']>;
  redeemedByUserID?: Maybe<Scalars['ID']['output']>;
  status: EventTicketPurchaseCodeStatus;
};

export enum EventTicketPurchaseCodeStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

export enum EventTicketPurchaseRefundReason {
  AdminInitiated = 'ADMIN_INITIATED',
  EventCancelled = 'EVENT_CANCELLED',
  HostInitiated = 'HOST_INITIATED',
  RequestedByBuyer = 'REQUESTED_BY_BUYER'
}

export enum EventTicketType {
  EarlyBird = 'EARLY_BIRD',
  Standard = 'STANDARD',
  Unknown = 'UNKNOWN'
}

export type EventTicketVariation = {
  __typename?: 'EventTicketVariation';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  availabilityEndsAt?: Maybe<Scalars['Date']['output']>;
  available: Scalars['Boolean']['output'];
  availableAfterID?: Maybe<Scalars['ID']['output']>;
  availableForDays?: Maybe<Scalars['Int']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  capacityIncreaseAllowed: Scalars['Boolean']['output'];
  checkoutStatus: EventTicketVariationCheckoutStatus;
  description?: Maybe<Scalars['String']['output']>;
  emoji: Scalars['String']['output'];
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  priceCents: Scalars['Int']['output'];
  settingsEditable: Scalars['Boolean']['output'];
  ticketsRemaining?: Maybe<Scalars['Int']['output']>;
  ticketsSold: Scalars['Int']['output'];
  totalCostCents: Scalars['Int']['output'];
};

export enum EventTicketVariationCheckoutStatus {
  Archived = 'ARCHIVED',
  Available = 'AVAILABLE',
  EventFull = 'EVENT_FULL',
  EventUnavailable = 'EVENT_UNAVAILABLE',
  Expired = 'EXPIRED',
  SequenceCompleted = 'SEQUENCE_COMPLETED',
  SoldOut = 'SOLD_OUT',
  Upcoming = 'UPCOMING'
}

export type EventTicketVariationInput = {
  /** Zero-based position of one earlier variation that must become unavailable first. */
  availableAfterPosition?: InputMaybe<Scalars['Int']['input']>;
  availableForDays?: InputMaybe<Scalars['Int']['input']>;
  capacity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional for backward compatibility. New variations default to 🎟️ when omitted;
   * existing variations preserve their current emoji when omitted during updates.
   */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** Existing variation ID when updating; omit for newly created variations. */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  priceCents: Scalars['Int']['input'];
};

export enum EventTone {
  Chatty = 'CHATTY',
  HighEnergy = 'HIGH_ENERGY',
  LaidBack = 'LAID_BACK'
}

export enum EventType {
  CoverCost = 'COVER_COST',
  Free = 'FREE',
  Ticketed = 'TICKETED'
}

export enum EventUneditableField {
  CoverCostAmount = 'COVER_COST_AMOUNT',
  CoverCostCapacity = 'COVER_COST_CAPACITY',
  CoverCostRequiredBy = 'COVER_COST_REQUIRED_BY',
  CoverCostRequiredParticipants = 'COVER_COST_REQUIRED_PARTICIPANTS',
  MonetizationPlanType = 'MONETIZATION_PLAN_TYPE'
}

export type EventsAttendedSummary = {
  __typename?: 'EventsAttendedSummary';
  eventsAttendedCount: Scalars['Int']['output'];
  eventsAttendedHours: Scalars['Int']['output'];
  eventsAttendedPeopleMet: Scalars['Int']['output'];
};

export type EventsConnection = {
  __typename?: 'EventsConnection';
  edges: Array<EventEdge>;
  /** City resolved for the public website feed. Null for other queries or an unknown location. */
  locationCity?: Maybe<LocationCity>;
  pageInfo: PageInfo;
};

export type EventsParams = {
  ages?: InputMaybe<Array<Ages>>;
  attendingUserID?: InputMaybe<Scalars['ID']['input']>;
  awaitingReconfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter events where the current user can invite others.
   * Returns events where user is a host OR (user is attendee AND allowInvites is true).
   * Requires authentication.
   */
  canInvite?: InputMaybe<Scalars['Boolean']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  clubID?: InputMaybe<Scalars['ID']['input']>;
  dashboard?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardV2?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter events where ALL specified users are attendees.
   * Useful for finding events where a group attended together.
   */
  everyAttendeeUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  /** Filter events where the specified user is either a host OR an attendee. */
  hostOrAttendeeUserID?: InputMaybe<Scalars['ID']['input']>;
  hostUserID?: InputMaybe<Scalars['ID']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCityID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Apply the public website feed filters: public, visible, published, non-draft,
   * non-canceled plans that have not started. Overrides published, canceled and
   * upcoming filters. Uses locationCityID when supplied, otherwise resolves the
   * city from Cloudflare IP location. Unknown locations return an empty connection.
   * Defaults to false.
   */
  publicWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requestPending?: InputMaybe<Scalars['Boolean']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExampleEvent = {
  __typename?: 'ExampleEvent';
  title: Scalars['String']['output'];
};

export type ExampleEventsSummary = {
  __typename?: 'ExampleEventsSummary';
  exampleEvents: Array<ExampleEvent>;
};

export enum ExchangeEventCodeForDirectInviteOutcome {
  AlreadyAttending = 'ALREADY_ATTENDING',
  AlreadyHost = 'ALREADY_HOST',
  EventCancelled = 'EVENT_CANCELLED',
  EventEnded = 'EVENT_ENDED',
  InvalidCode = 'INVALID_CODE',
  Success = 'SUCCESS'
}

export type ExchangeEventCodeForDirectInviteResult = {
  __typename?: 'ExchangeEventCodeForDirectInviteResult';
  event?: Maybe<Event>;
  invite?: Maybe<EventDirectInvite>;
  outcome: ExchangeEventCodeForDirectInviteOutcome;
};

export type ExportClubMembersCsvResult = {
  __typename?: 'ExportClubMembersCsvResult';
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ExportEventGuestFormAnswersCsvResult = {
  __typename?: 'ExportEventGuestFormAnswersCsvResult';
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ExportEventGuestListCsvResult = {
  __typename?: 'ExportEventGuestListCsvResult';
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FeedActivityMetadataInput = {
  absolutePosition: Scalars['Int']['input'];
  exposureID: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pagePosition: Scalars['Int']['input'];
  responseID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
  type: FeedV2Type;
};

export type FeedV2Connection = {
  __typename?: 'FeedV2Connection';
  edges: Array<FeedV2Edge>;
  pageInfo: PageInfo;
};

export type FeedV2Edge = {
  __typename?: 'FeedV2Edge';
  cursor: Scalars['String']['output'];
  feedMetadata?: Maybe<FeedV2Metadata>;
  node: FeedV2Node;
};

export type FeedV2Metadata = {
  __typename?: 'FeedV2Metadata';
  absolutePosition: Scalars['Int']['output'];
  exposureID: Scalars['ID']['output'];
  pageNumber: Scalars['Int']['output'];
  pagePosition: Scalars['Int']['output'];
  responseID: Scalars['ID']['output'];
  sessionID: Scalars['ID']['output'];
  type: FeedV2Type;
};

export type FeedV2Node = Club | Event | ExampleEventsSummary | Idea | ParticipatedEventsSummary | SavedEventsSummary;

export type FeedV2Params = {
  feedResponseID?: InputMaybe<Scalars['ID']['input']>;
  feedSessionID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<FeedV2Type>;
};

export enum FeedV2Type {
  Clubs = 'CLUBS',
  Default = 'DEFAULT',
  Ideas = 'IDEAS',
  Premium = 'PREMIUM'
}

export type FindLocationCityParams = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  locationCountryId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FindLocationSuburbParams = {
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type FindPossibleFriendsParams = {
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type FollowUserError = {
  __typename?: 'FollowUserError';
  code: FollowUserErrorCode;
  message: Scalars['String']['output'];
};

export enum FollowUserErrorCode {
  CannotFollowFriend = 'CANNOT_FOLLOW_FRIEND',
  CannotFollowSelf = 'CANNOT_FOLLOW_SELF',
  UserBlocked = 'USER_BLOCKED',
  UserDeleted = 'USER_DELETED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type FollowUserParams = {
  followedUserID: Scalars['ID']['input'];
};

export type FollowUserResult = {
  __typename?: 'FollowUserResult';
  error?: Maybe<FollowUserError>;
  followedUserID?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type FollowerEdge = {
  __typename?: 'FollowerEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FollowersConnection = {
  __typename?: 'FollowersConnection';
  edges: Array<FollowerEdge>;
  pageInfo: PageInfo;
};

export type FollowingConnection = {
  __typename?: 'FollowingConnection';
  edges: Array<FollowingEdge>;
  pageInfo: PageInfo;
};

export type FollowingEdge = {
  __typename?: 'FollowingEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FrequentAttendee = {
  __typename?: 'FrequentAttendee';
  attendancePercentage: Scalars['Float']['output'];
  attendedEvents: Scalars['Int']['output'];
  totalEvents: Scalars['Int']['output'];
  user: User;
};

export type FrequentAttendeesParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
};

export type FriendRequest = {
  __typename?: 'FriendRequest';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  recipient: User;
  recipientID: Scalars['ID']['output'];
  sender: User;
  senderID: Scalars['ID']['output'];
  status: FriendRequestStatus;
};

export enum FriendRequestDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export type FriendRequestEdge = {
  __typename?: 'FriendRequestEdge';
  cursor: Scalars['String']['output'];
  node: FriendRequest;
};

export enum FriendRequestResponseType {
  Accept = 'ACCEPT',
  Decline = 'DECLINE',
  Follow = 'FOLLOW'
}

export enum FriendRequestStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type FriendRequestsConnection = {
  __typename?: 'FriendRequestsConnection';
  edges: Array<FriendRequestEdge>;
  pageInfo: PageInfo;
};

export type FriendsAttendingConnection = {
  __typename?: 'FriendsAttendingConnection';
  edges: Array<FriendsAttendingEdge>;
  pageInfo: PageInfo;
};

export type FriendsAttendingEdge = {
  __typename?: 'FriendsAttendingEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FriendsConnection = {
  __typename?: 'FriendsConnection';
  edges: Array<UserFriendEdge>;
  pageInfo: PageInfo;
};

export type FriendsParams = {
  mutualOnly?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum Gender {
  Any = 'ANY',
  Female = 'FEMALE',
  Lgbtqia = 'LGBTQIA',
  Male = 'MALE'
}

export type GenerateClubFromInstagramInput = {
  instagramHandle: Scalars['String']['input'];
};

export type GenerateClubFromInstagramResult = {
  __typename?: 'GenerateClubFromInstagramResult';
  club?: Maybe<GeneratedClubFromInstagram>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Result of a single event generation step in the stream */
export type GenerateEventStreamResult = {
  __typename?: 'GenerateEventStreamResult';
  /** Error message if this event failed to generate */
  error?: Maybe<Scalars['String']['output']>;
  /** The generated event (null if error) */
  event?: Maybe<GeneratedEvent>;
  /** 0-based index of this event in the sequence */
  index: Scalars['Int']['output'];
};

/** Input for generating event options */
export type GenerateEventsInput = {
  /** Chat room activity ID to use as the basis for event generation */
  chatActivityID?: InputMaybe<Scalars['ID']['input']>;
  /** Number of event options to generate (default: 3) */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** User location override. Falls back to stored user location if not provided. */
  location?: InputMaybe<UserLocationInput>;
  /** Free text prompt (e.g., "Coffee in Fitzroy next Thursday arvo") */
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type GeneratedClubFromInstagram = {
  __typename?: 'GeneratedClubFromInstagram';
  bannerMediaImageId?: Maybe<Scalars['ID']['output']>;
  bannerMediaImageUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eventCaptions?: Maybe<Array<Scalars['String']['output']>>;
  eventPhotos?: Maybe<Array<Scalars['String']['output']>>;
  headline: Scalars['String']['output'];
  hostDescription: Scalars['String']['output'];
  hostHeadline: Scalars['String']['output'];
  hostName: Scalars['String']['output'];
  meetingFrequency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  perfectForYouIf?: Maybe<Array<Scalars['String']['output']>>;
  profilePic?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<Array<Scalars['String']['output']>>;
  suburb?: Maybe<Scalars['String']['output']>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

/** Generated event from AI agent - represents a single event option */
export type GeneratedEvent = {
  __typename?: 'GeneratedEvent';
  /** Suggested capacity */
  capacity: Scalars['Int']['output'];
  /** 2-3 sentence description */
  description: Scalars['String']['output'];
  /** End time in RFC3339 format */
  endTime: Scalars['Date']['output'];
  /** Google Place ID for the venue */
  googlePlaceID: Scalars['String']['output'];
  /** Short 1-sentence headline */
  headline: Scalars['String']['output'];
  /** Cover image URL from search_images (Cloudflare) */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Resolved media image for the cover image. */
  mediaImage?: Maybe<MediaImage>;
  /** MediaImage record ID (internal, used by mediaImage resolver) */
  mediaImageId?: Maybe<Scalars['ID']['output']>;
  /** Event name */
  name: Scalars['String']['output'];
  /** Resolved place details from the googlePlaceID. */
  place?: Maybe<PlaceDetails>;
  /** Start time in RFC3339 format */
  startTime: Scalars['Date']['output'];
  /** Event structure */
  structure?: Maybe<EventStructure>;
  /** Event tone */
  tone?: Maybe<EventTone>;
};

export type GooglePlace = {
  __typename?: 'GooglePlace';
  addressComponents?: Maybe<Array<GooglePlaceAddressComponent>>;
  displayName: GooglePlaceDisplayName;
  formattedAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: GooglePlaceLocationCoordinates;
  name: Scalars['String']['output'];
};

export type GooglePlaceAddressComponent = {
  __typename?: 'GooglePlaceAddressComponent';
  longText?: Maybe<Scalars['String']['output']>;
  shortText?: Maybe<Scalars['String']['output']>;
  types: Array<AddressComponentType>;
};

export type GooglePlaceDisplayName = {
  __typename?: 'GooglePlaceDisplayName';
  text: Scalars['String']['output'];
};

export type GooglePlaceInput = {
  addressComponents?: InputMaybe<Array<AddressComponentInput>>;
  displayName: DisplayNameInput;
  formattedAddress: Scalars['String']['input'];
  id: Scalars['String']['input'];
  location: LocationCoordinatesInput;
  name: Scalars['String']['input'];
};

export type GooglePlaceLocationCoordinates = {
  __typename?: 'GooglePlaceLocationCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GuestBadge = {
  __typename?: 'GuestBadge';
  badge: Badge;
  earnedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  sourceValue?: Maybe<Scalars['Int']['output']>;
  tier: BadgeTier;
};

/**
 * Reliability-status variants for guests, mirroring HostReliabilityStatus but
 * with guest-oriented copy.
 */
export enum GuestReliabilityStatus {
  AlwaysShowsUp = 'ALWAYS_SHOWS_UP',
  HasMissedPlansBefore = 'HAS_MISSED_PLANS_BEFORE',
  NewToButter = 'NEW_TO_BUTTER',
  UsuallyShowsUp = 'USUALLY_SHOWS_UP'
}

export type GuestReward = {
  __typename?: 'GuestReward';
  earnedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reward: Reward;
};

export type GuestRewardConnection = {
  __typename?: 'GuestRewardConnection';
  edges: Array<GuestRewardEdge>;
  pageInfo: PageInfo;
};

export type GuestRewardEdge = {
  __typename?: 'GuestRewardEdge';
  cursor: Scalars['String']['output'];
  node: GuestReward;
};

/**
 * Per-guest reliability stats. cancelledEarly is informational only — it doesn't
 * influence streak or reliabilityStatus but is exposed so clients can show
 * historical context.
 */
export type GuestStats = {
  __typename?: 'GuestStats';
  city?: Maybe<GuestStatsCity>;
  global: GuestStatsGlobal;
  /**
   * Events the user RSVP'd to, didn't cancel, and was reconciled as a
   * no-show. Ordered most-recent first.
   */
  noShows: EventsConnection;
  /**
   * Past events the user attended (review finalized as attended).
   * Ordered most-recent first.
   */
  recentlyAttended: EventsConnection;
  /**
   * Events the user cancelled their RSVP for outside the early-cancel grace
   * period (late or outside-grace-neutral). Ordered most-recent first.
   */
  recentlyCancelled: EventsConnection;
};


/**
 * Per-guest reliability stats. cancelledEarly is informational only — it doesn't
 * influence streak or reliabilityStatus but is exposed so clients can show
 * historical context.
 */
export type GuestStatsNoShowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Per-guest reliability stats. cancelledEarly is informational only — it doesn't
 * influence streak or reliabilityStatus but is exposed so clients can show
 * historical context.
 */
export type GuestStatsRecentlyAttendedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Per-guest reliability stats. cancelledEarly is informational only — it doesn't
 * influence streak or reliabilityStatus but is exposed so clients can show
 * historical context.
 */
export type GuestStatsRecentlyCancelledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Event/home-city scoped guest ranking and reliability from guest_city_stats. */
export type GuestStatsCity = {
  __typename?: 'GuestStatsCity';
  cityName?: Maybe<Scalars['String']['output']>;
  cityRanking?: Maybe<Scalars['Int']['output']>;
  reliabilityStatus: GuestReliabilityStatus;
};

/** Global guest counters and streaks from the guest_stats ledger. */
export type GuestStatsGlobal = {
  __typename?: 'GuestStatsGlobal';
  attended: Scalars['Int']['output'];
  cancelledEarly: Scalars['Int']['output'];
  cancelledLate: Scalars['Int']['output'];
  longestPlanStreak: Scalars['Int']['output'];
  noShow: Scalars['Int']['output'];
  planStreak: Scalars['Int']['output'];
};

/**
 * Represents the user's unseen chats status.
 * Used by both query and subscription for Apollo cache reconciliation.
 */
export type HasUnseenChatsStatus = {
  __typename?: 'HasUnseenChatsStatus';
  /** Whether the user has unseen chat messages. */
  hasUnseenChats: Scalars['Boolean']['output'];
};

export type HasWaitlistInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  locationCityDistrictId?: InputMaybe<Scalars['ID']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  referral?: InputMaybe<WaitlistReferralInput>;
  waitlistDistrictId?: InputMaybe<Scalars['ID']['input']>;
};

export type HasWaitlistResult = {
  __typename?: 'HasWaitlistResult';
  /** Whether a waitlist exists for this city/group pair. */
  exists: Scalars['Boolean']['output'];
  /** Whether the waitlist is currently locked (users need to join the waitlist). */
  isLocked: Scalars['Boolean']['output'];
  /** The waitlist ID if one exists. */
  waitlistId?: Maybe<Scalars['ID']['output']>;
};

export enum HighlightMediaScope {
  All = 'ALL',
  Mine = 'MINE'
}

export type Host = {
  __typename?: 'Host';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  clubID?: Maybe<Scalars['ID']['output']>;
  /**
   * Effective display profile for this host. When the event has a clubID and
   * the host user is an active ClubManager (owner or co-host) of that club,
   * fields come from the ClubManager's profile, with per-field fallback to the
   * user's personal profile. Otherwise, fields come entirely from the user.
   */
  details: EventHostDetails;
  eventID: Scalars['ID']['output'];
  /**
   * Reliability stats for this host, scoped to the event's city. Counters
   * are global; badge / cityRanking come from host_city_stats keyed
   * by (user_id, event city).
   * Falls back to NEW_TO_BUTTER with global counters when the host has no
   * row for that city.
   */
  hostStats: HostStats;
  id: Scalars['ID']['output'];
  onTheWay: Scalars['Boolean']['output'];
  primary: Scalars['Boolean']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

export type HostBadge = {
  __typename?: 'HostBadge';
  badge: Badge;
  earnedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  sourceValue?: Maybe<Scalars['Int']['output']>;
  tier: BadgeTier;
};

/**
 * Reliability-status variants for hosts and clubs. Computed by the daily stats
 * recompute job from the host's (or club's) age-weighted event outcomes.
 */
export enum HostReliabilityStatus {
  AlwaysFollowsThrough = 'ALWAYS_FOLLOWS_THROUGH',
  NewToButter = 'NEW_TO_BUTTER',
  PlansDontAlwaysGoAhead = 'PLANS_DONT_ALWAYS_GO_AHEAD',
  UsuallyComesThrough = 'USUALLY_COMES_THROUGH'
}

export type HostReward = {
  __typename?: 'HostReward';
  earnedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reward: Reward;
};

export type HostRewardConnection = {
  __typename?: 'HostRewardConnection';
  edges: Array<HostRewardEdge>;
  pageInfo: PageInfo;
};

export type HostRewardEdge = {
  __typename?: 'HostRewardEdge';
  cursor: Scalars['String']['output'];
  node: HostReward;
};

/**
 * Per-host reliability stats. Counters/streaks live under `global`; ranking and
 * reliability live under nullable `city` when a city context exists.
 */
export type HostStats = {
  __typename?: 'HostStats';
  city?: Maybe<HostStatsCity>;
  global: HostStatsGlobal;
  /**
   * Past events this host hosted where reconciliation marked them no-show.
   * Ordered most-recent first. Used by the host-detail track-record list.
   */
  recentNoShows: EventsConnection;
  /**
   * Events this host owned that were cancelled after at least one guest had
   * confirmed attendance. Ordered most-recent first.
   */
  recentlyCancelled: EventsConnection;
  /**
   * Past events this host hosted where reconciliation marked them present.
   * Ordered most-recent first. Used by the host-detail "recent plans" list.
   */
  recentlyHosted: EventsConnection;
};


/**
 * Per-host reliability stats. Counters/streaks live under `global`; ranking and
 * reliability live under nullable `city` when a city context exists.
 */
export type HostStatsRecentNoShowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Per-host reliability stats. Counters/streaks live under `global`; ranking and
 * reliability live under nullable `city` when a city context exists.
 */
export type HostStatsRecentlyCancelledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Per-host reliability stats. Counters/streaks live under `global`; ranking and
 * reliability live under nullable `city` when a city context exists.
 */
export type HostStatsRecentlyHostedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Event/home-city scoped host ranking and reliability from host_city_stats. */
export type HostStatsCity = {
  __typename?: 'HostStatsCity';
  cityName?: Maybe<Scalars['String']['output']>;
  cityRanking?: Maybe<Scalars['Int']['output']>;
  reliabilityStatus: HostReliabilityStatus;
};

/** Global host counters and streaks from the host_stats ledger. */
export type HostStatsGlobal = {
  __typename?: 'HostStatsGlobal';
  cancellations: Scalars['Int']['output'];
  longestPlanStreak: Scalars['Int']['output'];
  noShows: Scalars['Int']['output'];
  planStreak: Scalars['Int']['output'];
  plansHosted: Scalars['Int']['output'];
  wentAhead: Scalars['Int']['output'];
};

export enum HostTool {
  Audience = 'AUDIENCE',
  GroupTickets = 'GROUP_TICKETS',
  Subscriptions = 'SUBSCRIPTIONS',
  Tickets = 'TICKETS',
  TicketTypes = 'TICKET_TYPES',
  Waivers = 'WAIVERS'
}

export type HostToolAccess = {
  __typename?: 'HostToolAccess';
  hasAccess: Scalars['Boolean']['output'];
  tool: HostTool;
};

export enum HostToolAccessGrantSource {
  Admin = 'ADMIN',
  ApprovalRequest = 'APPROVAL_REQUEST',
  Earned = 'EARNED',
  Legacy = 'LEGACY'
}

export enum HostToolAccessStatus {
  Active = 'ACTIVE',
  Earning = 'EARNING',
  Paused = 'PAUSED',
  PendingApproval = 'PENDING_APPROVAL'
}

export enum HostToolGroup {
  HostKit = 'HOST_KIT'
}

export type HostToolGroupAccess = {
  __typename?: 'HostToolGroupAccess';
  activeMembers?: Maybe<HostToolRequirementProgress>;
  currentPlanStreak: HostToolRequirementProgress;
  grantedAt?: Maybe<Scalars['String']['output']>;
  group: HostToolGroup;
  hasAccess: Scalars['Boolean']['output'];
  pendingApprovalRequest: Scalars['Boolean']['output'];
  qualifyingPlans: HostToolRequirementProgress;
  sources: Array<HostToolAccessGrantSource>;
  status: HostToolAccessStatus;
  tools: Array<HostToolAccess>;
};

export type HostToolRequirementProgress = {
  __typename?: 'HostToolRequirementProgress';
  achieved: Scalars['Boolean']['output'];
  current: Scalars['Int']['output'];
  required: Scalars['Int']['output'];
};

export type HostToolsAccessInput = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
};

export type Idea = {
  __typename?: 'Idea';
  cancelled: Scalars['Boolean']['output'];
  claps: ClapSummary;
  comments: CommentsConnection;
  createdAt: Scalars['Date']['output'];
  creator: User;
  creatorUserID: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  interest: IdeaInterestConnection;
  locationCity: LocationCity;
  myInterest?: Maybe<IdeaInterest>;
  name: Scalars['String']['output'];
  personalizedSummary?: Maybe<Scalars['String']['output']>;
};


export type IdeaCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaInterestArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};

export type IdeaInterest = {
  __typename?: 'IdeaInterest';
  days?: Maybe<Array<IdeaInterestDay>>;
  id: Scalars['ID']['output'];
  ideaID: Scalars['ID']['output'];
  times?: Maybe<Array<IdeaInterestTime>>;
  user: User;
  userID: Scalars['ID']['output'];
};

export type IdeaInterestConnection = {
  __typename?: 'IdeaInterestConnection';
  edges: Array<IdeaInterestEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export enum IdeaInterestDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type IdeaInterestEdge = {
  __typename?: 'IdeaInterestEdge';
  cursor: Scalars['ID']['output'];
  node: IdeaInterest;
};

export enum IdeaInterestTime {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export type IdeaParams = {
  id: Scalars['ID']['input'];
};

export type IdeasConnection = {
  __typename?: 'IdeasConnection';
  edges: Array<IdeasEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type IdeasEdge = {
  __typename?: 'IdeasEdge';
  cursor: Scalars['ID']['output'];
  node: Idea;
};

export type IdeasParams = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  creatorID?: InputMaybe<Scalars['ID']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  interestedOrCreator?: InputMaybe<Scalars['Boolean']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Array<ListOrder>>;
};

export enum ImageVariant {
  Club = 'CLUB',
  Event = 'EVENT',
  Flexlarge = 'FLEXLARGE',
  Flexsmall = 'FLEXSMALL'
}

export type ImportTicketCheckoutProfileFromInstagramError = {
  __typename?: 'ImportTicketCheckoutProfileFromInstagramError';
  code: ImportTicketCheckoutProfileFromInstagramErrorCode;
  message: Scalars['String']['output'];
};

export enum ImportTicketCheckoutProfileFromInstagramErrorCode {
  PrivateAccount = 'PRIVATE_ACCOUNT',
  ProfileNotFound = 'PROFILE_NOT_FOUND',
  RateLimited = 'RATE_LIMITED'
}

export type ImportTicketCheckoutProfileFromInstagramParams = {
  instagramHandle: Scalars['String']['input'];
};

export type ImportTicketCheckoutProfileFromInstagramResult = {
  __typename?: 'ImportTicketCheckoutProfileFromInstagramResult';
  error?: Maybe<ImportTicketCheckoutProfileFromInstagramError>;
  profile?: Maybe<TicketCheckoutProfileFromInstagram>;
};

/** Initial message to send when creating a chat room. */
export type InitialChatMessageInput = {
  /** Attachments for the message (images, videos, files). */
  attachments?: InputMaybe<Array<ChatAttachmentInput>>;
  /**
   * The intent/purpose of the message.
   * When set to PLAN_REQUEST, the participant source type will be set to PLAN_REQUEST.
   */
  intent?: InputMaybe<ChatMessageIntent>;
  /** The text content of the message. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** The message type. Defaults to TEXT if not specified. */
  type?: InputMaybe<ChatMessageType>;
};

export type JoinChatV2Error = {
  __typename?: 'JoinChatV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: JoinChatV2Errors;
};

export enum JoinChatV2Errors {
  NotClubMember = 'NOT_CLUB_MEMBER',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type JoinChatV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type JoinChatV2Result = {
  __typename?: 'JoinChatV2Result';
  errors?: Maybe<Array<JoinChatV2Error>>;
  participant?: Maybe<ChatParticipant>;
  success: Scalars['Boolean']['output'];
};

export type JoinClubError = {
  __typename?: 'JoinClubError';
  message?: Maybe<Scalars['String']['output']>;
  type: JoinClubErrors;
};

export enum JoinClubErrors {
  AlreadyMember = 'ALREADY_MEMBER',
  ClubNotFound = 'CLUB_NOT_FOUND'
}

export type LeaveChatV2Error = {
  __typename?: 'LeaveChatV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: LeaveChatV2Errors;
};

export enum LeaveChatV2Errors {
  CannotLeaveRoomType = 'CANNOT_LEAVE_ROOM_TYPE',
  NotParticipant = 'NOT_PARTICIPANT',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type LeaveChatV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type LeaveChatV2Result = {
  __typename?: 'LeaveChatV2Result';
  errors?: Maybe<Array<LeaveChatV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type LeaveClubError = {
  __typename?: 'LeaveClubError';
  message?: Maybe<Scalars['String']['output']>;
  type: LeaveClubErrors;
};

export enum LeaveClubErrors {
  ClubNotFound = 'CLUB_NOT_FOUND',
  NotMember = 'NOT_MEMBER'
}

export type LinkPhoneNumberParams = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LinkPhoneNumberResult = {
  __typename?: 'LinkPhoneNumberResult';
  error?: Maybe<VerifyPhoneVerificationCodeError>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ListOrder = {
  direction: ListOrderDirection;
  field: Scalars['String']['input'];
};

export enum ListOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Location = {
  __typename?: 'Location';
  city: Scalars['String']['output'];
  /**
   * Privacy-safe coordinates for a roughly two-kilometre area around the venue,
   * falling back to its city when precise coordinates are unavailable.
   * These never contain the exact venue coordinates.
   */
  coordinates?: Maybe<Coordinates>;
  country: Scalars['String']['output'];
  /** Whether the exact venue, address, and coordinates are hidden from the current viewer. */
  exactDetailsHidden: Scalars['Boolean']['output'];
  googlePlace?: Maybe<GooglePlace>;
  name: Scalars['String']['output'];
  postcode: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type LocationCitiesConnection = {
  __typename?: 'LocationCitiesConnection';
  edges: Array<LocationCityEdge>;
  pageInfo: PageInfo;
};

export type LocationCity = {
  __typename?: 'LocationCity';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** @deprecated Use waitlistDistricts */
  districts: Array<LocationCityDistrict>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  locationCountryId?: Maybe<Scalars['ID']['output']>;
  longitude: Scalars['Float']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  waitlistDistricts: Array<WaitlistDistrict>;
};

export type LocationCityDistrict = {
  __typename?: 'LocationCityDistrict';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  locationCity: LocationCity;
  locationCityId: Scalars['ID']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type LocationCityEdge = {
  __typename?: 'LocationCityEdge';
  cursor: Scalars['ID']['output'];
  node: LocationCity;
};

export type LocationCoordinates = {
  __typename?: 'LocationCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LocationCoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LocationCountry = {
  __typename?: 'LocationCountry';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

/** Location input for proximity-based search */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LocationParams = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  googlePlace?: InputMaybe<GooglePlaceInput>;
  name: Scalars['String']['input'];
  postcode: Scalars['Int']['input'];
  state: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};

export type LocationSuburb = {
  __typename?: 'LocationSuburb';
  city: LocationCity;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  locationCityId: Scalars['ID']['output'];
  longitude: Scalars['Float']['output'];
  postcode: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type LocationSuburbEdge = {
  __typename?: 'LocationSuburbEdge';
  cursor: Scalars['ID']['output'];
  node: LocationSuburb;
};

export type LocationSuburbsConnection = {
  __typename?: 'LocationSuburbsConnection';
  edges: Array<LocationSuburbEdge>;
  pageInfo: PageInfo;
};

export type LogoutOfDeviceInput = {
  /**
   * The deviceId of the device that's logging out — same value the client
   * sends to upsertUserDevice.
   */
  deviceId: Scalars['String']['input'];
};

export type LogoutOfDeviceResult = {
  __typename?: 'LogoutOfDeviceResult';
  success: Scalars['Boolean']['output'];
};

export type MarkAllNotificationsReadResult = {
  __typename?: 'MarkAllNotificationsReadResult';
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type MarkChatAsReadV2Error = {
  __typename?: 'MarkChatAsReadV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: MarkChatAsReadV2Errors;
};

export enum MarkChatAsReadV2Errors {
  NotParticipant = 'NOT_PARTICIPANT',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type MarkChatAsReadV2Input = {
  chatRoomID: Scalars['ID']['input'];
  messageID?: InputMaybe<Scalars['ID']['input']>;
};

export type MarkChatAsReadV2Result = {
  __typename?: 'MarkChatAsReadV2Result';
  errors?: Maybe<Array<MarkChatAsReadV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type MarkChatsSeenResult = {
  __typename?: 'MarkChatsSeenResult';
  success: Scalars['Boolean']['output'];
};

export type MarkEventReviewAttendanceInput = {
  attendance: Array<AttendanceInput>;
  reviewId: Scalars['ID']['input'];
};

export type MarkEventReviewAttendanceResult = {
  __typename?: 'MarkEventReviewAttendanceResult';
  error?: Maybe<EventReviewError>;
  eventReview?: Maybe<EventReview>;
};

export type MarkEventReviewUsersLikedInput = {
  reviewId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type MarkEventReviewUsersLikedResult = {
  __typename?: 'MarkEventReviewUsersLikedResult';
  error?: Maybe<EventReviewError>;
  eventReview?: Maybe<EventReview>;
};

export type MarkNotificationReadResult = {
  __typename?: 'MarkNotificationReadResult';
  notification?: Maybe<Notification>;
  success: Scalars['Boolean']['output'];
};

export type MarkNotificationsSeenResult = {
  __typename?: 'MarkNotificationsSeenResult';
  success: Scalars['Boolean']['output'];
};

export type MarkUserAsUnmetParams = {
  userID: Scalars['ID']['input'];
};

export type MarkUserAsUnmetResult = {
  __typename?: 'MarkUserAsUnmetResult';
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['ID']['output']>;
};

export type MediaImage = {
  __typename?: 'MediaImage';
  cloudflareImageId: Scalars['String']['output'];
  /** Club variant URL (optimized for club images) */
  clubUrl: Scalars['String']['output'];
  /** Event variant URL (optimized for event images) */
  eventUrl: Scalars['String']['output'];
  /** Large flexible variant (for full-screen viewing) */
  flexLargeUrl: Scalars['String']['output'];
  /** Small flexible variant (for thumbnails and chat bubbles) */
  flexSmallUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Default public variant URL */
  url: Scalars['String']['output'];
};

export type MediaVideo = {
  __typename?: 'MediaVideo';
  cloudflareVideoId: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  playbackDash?: Maybe<Scalars['String']['output']>;
  playbackHls: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** Entity type for mentionable user lookup */
export enum MentionableEntityType {
  Event = 'EVENT',
  Idea = 'IDEA'
}

/** Input parameters for mentionable user lookup */
export type MentionableParams = {
  entityId: Scalars['ID']['input'];
  entityType: MentionableEntityType;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type Met = {
  __typename?: 'Met';
  event: Event;
  id: Scalars['ID']['output'];
  user: User;
};

export type MetConnection = {
  __typename?: 'MetConnection';
  edges: Array<MetEdge>;
  pageInfo: PageInfo;
};

export type MetEdge = {
  __typename?: 'MetEdge';
  cursor: Scalars['String']['output'];
  node: Met;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Accept a message request or plan request for a chat room.
   * Sets the participant's accepted_at timestamp.
   * Only works if the current user has a pending request (message_request or plan_request source_type with null accepted_at).
   */
  acceptChatRequestV2: AcceptChatRequestV2Result;
  acceptClubJoinRequest: AcceptClubJoinRequestResult;
  /**
   * Add participants to a chat room.
   * Only room admins can add participants.
   */
  addChatParticipantsV2: AddChatParticipantsV2Result;
  addMediaToEventReviewHighlight: AddMediaToEventReviewHighlightResult;
  /**
   * Archive or unarchive a chat for the current user.
   * This is a per-user setting and doesn't affect other participants.
   */
  archiveChatV2: ArchiveChatV2Result;
  blockUser: BlockUserResult;
  cancelEventDirectInvite: CancelEventDirectInviteResult;
  cancelFriendRequest: CancelFriendRequestResult;
  claimEventCodeInvite: ClaimEventCodeInviteResult;
  clap: ClapResult;
  /**
   * Cleans the current user's friend list by removing friends that don't meet retention criteria.
   * A friend is kept if:
   * - They share a direct chat room where both are active participants, OR
   * - They have attended 2+ finished, non-cancelled events together.
   * All other friends are removed (bidirectionally).
   */
  cleanFriends: CleanFriendsResult;
  completeEventReview: CompleteEventReviewResult;
  /**
   * Create a new chat room.
   * For direct chats, exactly 2 participants (including creator) are required.
   */
  createChatRoomV2: CreateChatRoomV2Result;
  createClub: CreateClubResult;
  createClubJoinRequest: CreateClubJoinRequestResult;
  createClubManager: CreateClubManagerResult;
  createClubMember: CreateClubMemberResult;
  createComment: CreateCommentResult;
  createCoverCostContributionIntent: CreateCoverCostContributionIntentResult;
  createCuratedEvent: CuratedEvent;
  createDiscountCode: CreateDiscountCodeResult;
  createEvent: CreateEventResult;
  createEventAttendee: CreateEventAttendeeResult;
  createEventCodeInvite: CreateEventCodeInviteResult;
  createEventDirectGroupInvite: CreateEventDirectGroupInviteResult;
  createEventDirectInvite: CreateEventDirectInviteResult;
  createEventRequest: CreateEventRequestResult;
  createEventTicketPurchaseFromWallet: CreateEventTicketPurchaseFromWalletResult;
  createEventTicketPurchaseIntent: CreateEventTicketPurchaseIntentResult;
  createFriendRequest: CreateFriendRequestResult;
  createGlobalPayoutOnboardingLink: CreateGlobalPayoutOnboardingLinkResult;
  createIdea: CreateIdeaResult;
  createIdeaInterest: CreateIdeaInterestResult;
  createPoll: CreatePollResult;
  createPost: CreatePostResult;
  createUser: User;
  createWalletPayoutIntent: CreateWalletPayoutIntentResult;
  createWalletTipIntent: CreateWalletTipIntentResult;
  createWalletTopUpIntent: CreateWalletTopUpIntentResult;
  /**
   * Decline a message request or plan request for a chat room.
   * Sets the participant's declined_at timestamp.
   * Declined chats will not appear in the chat list.
   * Only works if the current user has a pending request (message_request or plan_request source_type with null accepted_at and null declined_at).
   */
  declineChatRequestV2: DeclineChatRequestV2Result;
  declineClubJoinRequest: DeclineClubJoinRequestResult;
  /**
   * Soft-delete a message.
   * Authors can delete their own messages. Admins can delete any message.
   */
  deleteChatMessageV2: DeleteChatMessageV2Result;
  /**
   * Delete a group or club chat for all participants.
   * Only room admins can delete it.
   */
  deleteChatRoomV2: DeleteChatRoomV2Result;
  deleteClub: DeleteClubResult;
  deleteClubManager: DeleteClubManagerResult;
  deleteClubMember: DeleteClubMemberResult;
  deleteClubMembers: DeleteClubMembersResult;
  deleteComment: DeleteCommentResult;
  deleteCuratedEvent: Scalars['Boolean']['output'];
  deleteDiscountCode: Scalars['Boolean']['output'];
  deleteEventAttendee: DeleteEventAttendeeResult;
  deleteEventRequest: DeleteEventRequestResult;
  deleteIdea: DeleteIdeaResult;
  deleteIdeaInterest: DeleteIdeaInterestResult;
  deletePost: DeletePostResult;
  deleteUser: DeleteUserResult;
  /**
   * Dismiss a chat room activity for the current user.
   * The activity will no longer appear for this user, but remains visible to other participants.
   */
  dismissChatRoomActivity: DismissChatRoomActivityResult;
  duplicateEvent: DuplicateEventResult;
  /**
   * Edit a message's text content.
   * Only the message author can edit.
   */
  editChatMessageV2: EditChatMessageV2Result;
  exchangeEventCodeForDirectInvite: ExchangeEventCodeForDirectInviteResult;
  exportClubMembersCsv: ExportClubMembersCsvResult;
  exportEventGuestFormAnswersCsv: ExportEventGuestFormAnswersCsvResult;
  exportEventGuestListCsv: ExportEventGuestListCsvResult;
  followUser: FollowUserResult;
  importTicketCheckoutProfileFromInstagram: ImportTicketCheckoutProfileFromInstagramResult;
  /**
   * Join a chat room as the current user.
   * Allows self-join for invite link scenarios (e.g., club chat invites).
   * Idempotent: succeeds if already a participant.
   */
  joinChatV2: JoinChatV2Result;
  /** Leave a chat room. The user's participation is soft-deleted. */
  leaveChatV2: LeaveChatV2Result;
  linkPhoneNumber: LinkPhoneNumberResult;
  /**
   * Mark a single device as logged out for the calling user: nulls its push_token,
   * stamps logged_out_at, and removes that device's token from the legacy
   * User.device_tokens array. Called on logout from this device — sibling devices
   * (if the user is signed in on multiple) keep receiving notifications.
   */
  logoutOfDevice: LogoutOfDeviceResult;
  markAllNotificationsRead: MarkAllNotificationsReadResult;
  /**
   * Mark a chat as read up to a specific message (or the latest message).
   * Updates the participant's last_read_at and last_read_message_id.
   */
  markChatAsReadV2: MarkChatAsReadV2Result;
  /**
   * Mark all chats as seen by updating the user's last_seen_chats_at timestamp.
   * This clears the global chat indicator but does not affect per-room unread states.
   */
  markChatsSeen: MarkChatsSeenResult;
  markEventReviewAttendance: MarkEventReviewAttendanceResult;
  markEventReviewUsersLiked: MarkEventReviewUsersLikedResult;
  markNotificationRead: MarkNotificationReadResult;
  markNotificationsSeen: MarkNotificationsSeenResult;
  markUserAsUnmet: MarkUserAsUnmetResult;
  /**
   * Mute or unmute a chat room for the current user.
   * When muted, the user will not receive push notifications for new messages in this room.
   */
  muteChat: MuteChatResult;
  /** Pin a chat room to the current user's starred section. */
  pinChatV2: PinChatV2Result;
  prepareCreationCanvasAttachment: CreationCanvasAttachmentResult;
  prepareCreationCanvasHandoff: CreationCanvasHandoffResult;
  redeemEventTicketPurchaseCode: RedeemEventTicketPurchaseCodeResult;
  /** Register a request for Butter to support a waitlist location. This is a PUBLIC endpoint that does not require authentication. */
  registerWaitlistLocationRequest: RegisterWaitlistLocationRequestResult;
  /** Register a new user on the waitlist. This is a PUBLIC endpoint that does not require authentication. */
  registerWaitlistUser: RegisterWaitlistUserResult;
  /**
   * Remove a participant from a chat room.
   * Admins can remove any participant. Users can remove themselves.
   */
  removeChatParticipantV2: RemoveChatParticipantV2Result;
  removeMediaFromEventReviewHighlight: RemoveMediaFromEventReviewHighlightResult;
  /**
   * Remove a plan request from a chat room.
   * If the plan request has not been accepted, deletes the entire chat room.
   * If the plan request has been accepted, removes only the plan activity.
   * Only room admins can remove plan requests.
   */
  removePlanRequest: RemovePlanRequestResult;
  report: ReportResult;
  reportEvent: ReportEventResult;
  reportHostNoShows: ReportHostNoShowsResult;
  requestTicketSalesApproval: TicketSalesApprovalRequestResult;
  resolveEventConflicts: ResolveEventConflictsResult;
  respondToEventDirectInvite: RespondToEventDirectInviteResult;
  respondToFriendRequest: RespondToFriendRequestResult;
  saveEvent: SaveEventResult;
  selectCreationCanvasOption: CreationCanvasSessionResult;
  /**
   * Send a message to a chat room.
   * Only participants can send messages.
   */
  sendChatMessageV2: SendChatMessageV2Result;
  sendPasswordlessAuthEmail: SendPasswordlessAuthEmailResult;
  sendPhoneVerificationCode: SendPhoneVerificationCodeResult;
  /**
   * Set typing indicator status.
   * isTyping=true starts/refreshes the indicator.
   * isTyping=false stops the indicator.
   */
  setChatTypingV2: SetChatTypingV2Result;
  startCreationCanvas: CreationCanvasSessionResult;
  submitCreationCanvasMessage: CreationCanvasTurnResult;
  submitEventReviewRating: SubmitEventReviewRatingResult;
  submitEventReviewUserTags: SubmitEventReviewUserTagsResult;
  /**
   * Toggle a reaction emoji on a message.
   * If the user has already reacted with this emoji, the reaction is removed.
   */
  toggleChatReactionV2: ToggleChatReactionV2Result;
  togglePollVote: TogglePollVoteResult;
  trackActivity: TrackActivityResult;
  unblockUser: UnblockUserResult;
  unfollowUser: UnfollowUserResult;
  unfriendUser: UnfriendUserResult;
  /** Unpin a chat room from the current user's starred section. */
  unpinChatV2: UnpinChatV2Result;
  unsaveEvent: UnsaveEventResult;
  /**
   * Update chat room details (name, image).
   * Only room admins can update.
   */
  updateChatRoomV2: UpdateChatRoomV2Result;
  updateClub: UpdateClubResult;
  updateClubManager: UpdateClubManagerResult;
  updateClubMember: UpdateClubMemberResult;
  updateComment: UpdateCommentResult;
  updateCreationCanvasContext: CreationCanvasSessionResult;
  updateDiscountCode: UpdateDiscountCodeResult;
  updateEntityEvent: UpdateEntityEventResult;
  updateEvent: UpdateEventResult;
  updateEventAttendee: UpdateEventAttendeeResult;
  updateEventHost: UpdateEventHostResult;
  updateEventRequest: UpdateEventRequestResult;
  updateEventReviewStep: UpdateEventReviewStepResult;
  updateIdea: UpdateIdeaResult;
  updateIdeaInterest: UpdateIdeaInterestResult;
  updateNotificationSetting: UpdateNotificationSettingResult;
  updatePoll: UpdatePollResult;
  updatePost: UpdatePostResult;
  updateUser: User;
  /** Update push notification tokens for a waitlist location request. This is a PUBLIC endpoint that does not require authentication. */
  updateWaitlistLocationRequestPushTokens: UpdateWaitlistLocationRequestPushTokensResult;
  /** Update push notification tokens for a waitlist user. This is a PUBLIC endpoint that does not require authentication. */
  updateWaitlistUserPushTokens: UpdateWaitlistUserPushTokensResult;
  uploadImage: UploadImageResult;
  /**
   * Insert or update the calling user's device record, keyed by (userID, deviceID).
   * Mobile clients should call this on every app open with the latest push token,
   * app version, and supported capabilities.
   */
  upsertUserDevice: UpsertUserDeviceResult;
  verifyPhoneNumber: VerifyPhoneNumberResult;
  verifyPhoneVerificationCode: VerifyPhoneVerificationCodeResult;
};


export type MutationAcceptChatRequestV2Args = {
  input: AcceptChatRequestV2Input;
};


export type MutationAcceptClubJoinRequestArgs = {
  params: AcceptClubJoinRequestParams;
};


export type MutationAddChatParticipantsV2Args = {
  input: AddChatParticipantsV2Input;
};


export type MutationAddMediaToEventReviewHighlightArgs = {
  input: AddMediaToEventReviewHighlightInput;
};


export type MutationArchiveChatV2Args = {
  input: ArchiveChatV2Input;
};


export type MutationBlockUserArgs = {
  params: BlockUserParams;
};


export type MutationCancelEventDirectInviteArgs = {
  params: CancelEventDirectInviteParams;
};


export type MutationCancelFriendRequestArgs = {
  params: CancelFriendRequestParams;
};


export type MutationClaimEventCodeInviteArgs = {
  code: Scalars['String']['input'];
};


export type MutationClapArgs = {
  params: ClapParams;
};


export type MutationCompleteEventReviewArgs = {
  input: CompleteEventReviewInput;
};


export type MutationCreateChatRoomV2Args = {
  input: CreateChatRoomV2Input;
};


export type MutationCreateClubArgs = {
  params: CreateClubParams;
};


export type MutationCreateClubJoinRequestArgs = {
  params: CreateClubJoinRequestParams;
};


export type MutationCreateClubManagerArgs = {
  params: CreateClubManagerParams;
};


export type MutationCreateClubMemberArgs = {
  params: CreateClubMemberParams;
};


export type MutationCreateCommentArgs = {
  params: CreateCommentParams;
};


export type MutationCreateCoverCostContributionIntentArgs = {
  params: CoverCostContributionIntentParams;
};


export type MutationCreateCuratedEventArgs = {
  input: CreateCuratedEventInput;
};


export type MutationCreateDiscountCodeArgs = {
  params: CreateDiscountCodeParams;
};


export type MutationCreateEventArgs = {
  params: CreateEventParams;
};


export type MutationCreateEventAttendeeArgs = {
  params: CreateEventAttendeeParams;
};


export type MutationCreateEventCodeInviteArgs = {
  eventID: Scalars['ID']['input'];
};


export type MutationCreateEventDirectGroupInviteArgs = {
  params: CreateEventDirectGroupInviteParams;
};


export type MutationCreateEventDirectInviteArgs = {
  params: CreateEventDirectInviteParams;
};


export type MutationCreateEventRequestArgs = {
  params?: InputMaybe<CreateEventRequestParams>;
};


export type MutationCreateEventTicketPurchaseFromWalletArgs = {
  params: CreateEventTicketPurchaseFromWalletParams;
};


export type MutationCreateEventTicketPurchaseIntentArgs = {
  params: CreateEventTicketPurchaseIntentParams;
};


export type MutationCreateFriendRequestArgs = {
  params: CreateFriendRequestParams;
};


export type MutationCreateGlobalPayoutOnboardingLinkArgs = {
  params: CreateGlobalPayoutOnboardingLinkParams;
};


export type MutationCreateIdeaArgs = {
  params: CreateIdeaParams;
};


export type MutationCreateIdeaInterestArgs = {
  params: CreateIdeaInterestParams;
};


export type MutationCreatePollArgs = {
  params: CreatePollParams;
};


export type MutationCreatePostArgs = {
  params: CreatePostParams;
};


export type MutationCreateUserArgs = {
  params?: InputMaybe<CreateUserParams>;
};


export type MutationCreateWalletPayoutIntentArgs = {
  params: CreateWalletPayoutIntentParams;
};


export type MutationCreateWalletTipIntentArgs = {
  params: CreateWalletTipIntentParams;
};


export type MutationCreateWalletTopUpIntentArgs = {
  params: CreateWalletTopUpIntentParams;
};


export type MutationDeclineChatRequestV2Args = {
  input: DeclineChatRequestV2Input;
};


export type MutationDeclineClubJoinRequestArgs = {
  params: DeclineClubJoinRequestParams;
};


export type MutationDeleteChatMessageV2Args = {
  input: DeleteChatMessageV2Input;
};


export type MutationDeleteChatRoomV2Args = {
  input: DeleteChatRoomV2Input;
};


export type MutationDeleteClubArgs = {
  params: DeleteClubParams;
};


export type MutationDeleteClubManagerArgs = {
  params: DeleteClubManagerParams;
};


export type MutationDeleteClubMemberArgs = {
  params: DeleteClubMemberParams;
};


export type MutationDeleteClubMembersArgs = {
  params: DeleteClubMembersParams;
};


export type MutationDeleteCommentArgs = {
  params: DeleteCommentParams;
};


export type MutationDeleteCuratedEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountCodeArgs = {
  params: DeleteDiscountCodeParams;
};


export type MutationDeleteEventAttendeeArgs = {
  params: DeleteEventAttendeeParams;
};


export type MutationDeleteEventRequestArgs = {
  params?: InputMaybe<DeleteEventRequestParams>;
};


export type MutationDeleteIdeaArgs = {
  params: DeleteIdeaParams;
};


export type MutationDeleteIdeaInterestArgs = {
  params: DeleteIdeaInterestParams;
};


export type MutationDeletePostArgs = {
  params: DeletePostParams;
};


export type MutationDismissChatRoomActivityArgs = {
  input: DismissChatRoomActivityInput;
};


export type MutationDuplicateEventArgs = {
  input: DuplicateEventInput;
};


export type MutationEditChatMessageV2Args = {
  input: EditChatMessageV2Input;
};


export type MutationExchangeEventCodeForDirectInviteArgs = {
  code: Scalars['String']['input'];
};


export type MutationExportClubMembersCsvArgs = {
  clubID: Scalars['ID']['input'];
};


export type MutationExportEventGuestFormAnswersCsvArgs = {
  eventID: Scalars['ID']['input'];
};


export type MutationExportEventGuestListCsvArgs = {
  eventID: Scalars['ID']['input'];
};


export type MutationFollowUserArgs = {
  params: FollowUserParams;
};


export type MutationImportTicketCheckoutProfileFromInstagramArgs = {
  params: ImportTicketCheckoutProfileFromInstagramParams;
};


export type MutationJoinChatV2Args = {
  input: JoinChatV2Input;
};


export type MutationLeaveChatV2Args = {
  input: LeaveChatV2Input;
};


export type MutationLinkPhoneNumberArgs = {
  params: LinkPhoneNumberParams;
};


export type MutationLogoutOfDeviceArgs = {
  input: LogoutOfDeviceInput;
};


export type MutationMarkChatAsReadV2Args = {
  input: MarkChatAsReadV2Input;
};


export type MutationMarkEventReviewAttendanceArgs = {
  input: MarkEventReviewAttendanceInput;
};


export type MutationMarkEventReviewUsersLikedArgs = {
  input: MarkEventReviewUsersLikedInput;
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkUserAsUnmetArgs = {
  params: MarkUserAsUnmetParams;
};


export type MutationMuteChatArgs = {
  input: MuteChatInput;
};


export type MutationPinChatV2Args = {
  input: PinChatV2Input;
};


export type MutationPrepareCreationCanvasAttachmentArgs = {
  input: PrepareCreationCanvasAttachmentInput;
};


export type MutationPrepareCreationCanvasHandoffArgs = {
  revisionID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
};


export type MutationRedeemEventTicketPurchaseCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationRegisterWaitlistLocationRequestArgs = {
  input: RegisterWaitlistLocationRequestInput;
};


export type MutationRegisterWaitlistUserArgs = {
  input: RegisterWaitlistUserInput;
};


export type MutationRemoveChatParticipantV2Args = {
  input: RemoveChatParticipantV2Input;
};


export type MutationRemoveMediaFromEventReviewHighlightArgs = {
  input: RemoveMediaFromEventReviewHighlightInput;
};


export type MutationRemovePlanRequestArgs = {
  input: RemovePlanRequestInput;
};


export type MutationReportArgs = {
  params: ReportParams;
};


export type MutationReportEventArgs = {
  params: ReportEventParams;
};


export type MutationReportHostNoShowsArgs = {
  input: ReportHostNoShowsInput;
};


export type MutationRequestTicketSalesApprovalArgs = {
  input: TicketSalesApprovalRequestInput;
};


export type MutationResolveEventConflictsArgs = {
  params: ResolveEventConflictsParams;
};


export type MutationRespondToEventDirectInviteArgs = {
  params: RespondToEventDirectInviteParams;
};


export type MutationRespondToFriendRequestArgs = {
  params: RespondToFriendRequestParams;
};


export type MutationSaveEventArgs = {
  params: SaveEventParams;
};


export type MutationSelectCreationCanvasOptionArgs = {
  input: SelectCreationCanvasOptionInput;
};


export type MutationSendChatMessageV2Args = {
  input: SendChatMessageV2Input;
};


export type MutationSendPasswordlessAuthEmailArgs = {
  params?: InputMaybe<SendPasswordlessAuthEmailParams>;
};


export type MutationSendPhoneVerificationCodeArgs = {
  params: SendPhoneVerificationCodeParams;
};


export type MutationSetChatTypingV2Args = {
  input: SetChatTypingV2Input;
};


export type MutationStartCreationCanvasArgs = {
  input: StartCreationCanvasInput;
};


export type MutationSubmitCreationCanvasMessageArgs = {
  input: SubmitCreationCanvasMessageInput;
};


export type MutationSubmitEventReviewRatingArgs = {
  input: SubmitEventReviewRatingInput;
};


export type MutationSubmitEventReviewUserTagsArgs = {
  input: SubmitEventReviewUserTagsInput;
};


export type MutationToggleChatReactionV2Args = {
  input: ToggleChatReactionV2Input;
};


export type MutationTogglePollVoteArgs = {
  params: TogglePollVoteParams;
};


export type MutationTrackActivityArgs = {
  input: TrackActivityInput;
};


export type MutationUnblockUserArgs = {
  params: UnblockUserParams;
};


export type MutationUnfollowUserArgs = {
  params: UnfollowUserParams;
};


export type MutationUnfriendUserArgs = {
  params: UnfriendUserParams;
};


export type MutationUnpinChatV2Args = {
  input: UnpinChatV2Input;
};


export type MutationUnsaveEventArgs = {
  params: UnsaveEventParams;
};


export type MutationUpdateChatRoomV2Args = {
  input: UpdateChatRoomV2Input;
};


export type MutationUpdateClubArgs = {
  params: UpdateClubParams;
};


export type MutationUpdateClubManagerArgs = {
  params: UpdateClubManagerParams;
};


export type MutationUpdateClubMemberArgs = {
  params: UpdateClubMemberParams;
};


export type MutationUpdateCommentArgs = {
  params: UpdateCommentParams;
};


export type MutationUpdateCreationCanvasContextArgs = {
  input: UpdateCreationCanvasContextInput;
};


export type MutationUpdateDiscountCodeArgs = {
  params: UpdateDiscountCodeParams;
};


export type MutationUpdateEntityEventArgs = {
  params: UpdateEntityEventParams;
};


export type MutationUpdateEventArgs = {
  params: UpdateEventParams;
};


export type MutationUpdateEventAttendeeArgs = {
  params: UpdateEventAttendeeParams;
};


export type MutationUpdateEventHostArgs = {
  params: UpdateEventHostParams;
};


export type MutationUpdateEventRequestArgs = {
  params?: InputMaybe<UpdateEventRequestParams>;
};


export type MutationUpdateEventReviewStepArgs = {
  input: UpdateEventReviewStepInput;
};


export type MutationUpdateIdeaArgs = {
  params: UpdateIdeaParams;
};


export type MutationUpdateIdeaInterestArgs = {
  params: UpdateIdeaInterestParams;
};


export type MutationUpdateNotificationSettingArgs = {
  input: UpdateNotificationSettingInput;
};


export type MutationUpdatePollArgs = {
  params: UpdatePollParams;
};


export type MutationUpdatePostArgs = {
  params: UpdatePostParams;
};


export type MutationUpdateUserArgs = {
  params?: InputMaybe<UpdateUserParams>;
};


export type MutationUpdateWaitlistLocationRequestPushTokensArgs = {
  input: UpdateWaitlistLocationRequestPushTokensInput;
};


export type MutationUpdateWaitlistUserPushTokensArgs = {
  input: UpdateWaitlistUserPushTokensInput;
};


export type MutationUploadImageArgs = {
  params: UploadImageParams;
};


export type MutationUpsertUserDeviceArgs = {
  input: UpsertUserDeviceInput;
};


export type MutationVerifyPhoneNumberArgs = {
  params: VerifyPhoneNumberParams;
};


export type MutationVerifyPhoneVerificationCodeArgs = {
  params: VerifyPhoneVerificationCodeParams;
};

export type MuteChatError = {
  __typename?: 'MuteChatError';
  message?: Maybe<Scalars['String']['output']>;
  type: MuteChatErrors;
};

export enum MuteChatErrors {
  NotParticipant = 'NOT_PARTICIPANT',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type MuteChatInput = {
  chatRoomID: Scalars['ID']['input'];
  muted: Scalars['Boolean']['input'];
};

export type MuteChatResult = {
  __typename?: 'MuteChatResult';
  errors?: Maybe<Array<MuteChatError>>;
  participant?: Maybe<ChatParticipant>;
  success: Scalars['Boolean']['output'];
};

export type MyEventDirectInvitesParams = {
  status?: InputMaybe<EventDirectInviteStatus>;
};

export type MyFriendRequestsParams = {
  direction: FriendRequestDirection;
  status?: InputMaybe<FriendRequestStatus>;
};

export type NewClubMembersParams = {
  clubId: Scalars['ID']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Date']['output'];
  data: Scalars['JSONObject']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: NotificationType;
  userID: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type NotificationCategorySetting = {
  __typename?: 'NotificationCategorySetting';
  category: NotificationSettingCategory;
  editable: Scalars['Boolean']['output'];
  effectiveEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
};

/** Event emitted when a new notification is created. */
export type NotificationCreatedEvent = {
  __typename?: 'NotificationCreatedEvent';
  cursor: Scalars['String']['output'];
  notification: Notification;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

/** Union of all notification event types. */
export type NotificationEvent = NotificationCreatedEvent;

export enum NotificationFilter {
  All = 'ALL',
  Spaces = 'SPACES'
}

export enum NotificationSettingCategory {
  ClubCommentsReplies = 'CLUB_COMMENTS_REPLIES',
  ClubNewMembers = 'CLUB_NEW_MEMBERS',
  ClubNewPlans = 'CLUB_NEW_PLANS',
  ClubPolls = 'CLUB_POLLS',
  ClubReactions = 'CLUB_REACTIONS',
  ClubTags = 'CLUB_TAGS',
  ClubUpdates = 'CLUB_UPDATES',
  CommentsReplies = 'COMMENTS_REPLIES',
  HostCapacityUpdates = 'HOST_CAPACITY_UPDATES',
  HostGuestReconfirmations = 'HOST_GUEST_RECONFIRMATIONS',
  HostPlanSaves = 'HOST_PLAN_SAVES',
  HostThanks = 'HOST_THANKS',
  HostTicketSales = 'HOST_TICKET_SALES',
  IdeaExpiry = 'IDEA_EXPIRY',
  IdeaInterest = 'IDEA_INTEREST',
  MessageRequests = 'MESSAGE_REQUESTS',
  PersonGoingPlans = 'PERSON_GOING_PLANS',
  PersonJoiningSpaces = 'PERSON_JOINING_SPACES',
  PersonMakingPlansSpacesIdeas = 'PERSON_MAKING_PLANS_SPACES_IDEAS',
  PlanRemindersUpdates = 'PLAN_REMINDERS_UPDATES',
  Reactions = 'REACTIONS',
  RsvpInvites = 'RSVP_INVITES',
  SavedPlanUpdates = 'SAVED_PLAN_UPDATES',
  Tags = 'TAGS'
}

export type NotificationSettingError = {
  __typename?: 'NotificationSettingError';
  code: NotificationSettingErrorCode;
  message: Scalars['String']['output'];
};

export enum NotificationSettingErrorCode {
  EntityUnavailable = 'ENTITY_UNAVAILABLE',
  InvalidScope = 'INVALID_SCOPE',
  RequiredCategory = 'REQUIRED_CATEGORY'
}

export enum NotificationSettingScope {
  Account = 'ACCOUNT',
  Club = 'CLUB',
  Person = 'PERSON'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  categories: Array<NotificationCategorySetting>;
  scope: NotificationSettingScope;
  subjectID?: Maybe<Scalars['ID']['output']>;
};

export enum NotificationType {
  Chat = 'CHAT',
  Club = 'CLUB',
  ClubJoinRequest = 'CLUB_JOIN_REQUEST',
  ClubOnboardingIntro = 'CLUB_ONBOARDING_INTRO',
  Event = 'EVENT',
  Idea = 'IDEA',
  OtherProfile = 'OTHER_PROFILE',
  PlanReview = 'PLAN_REVIEW',
  PlanReviewComplete = 'PLAN_REVIEW_COMPLETE',
  Profile = 'PROFILE',
  TipReceived = 'TIP_RECEIVED'
}

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type NotificationsParams = {
  filter?: InputMaybe<NotificationFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationsSummary = {
  __typename?: 'NotificationsSummary';
  hasUnread: Scalars['Boolean']['output'];
  hasUnseen: Scalars['Boolean']['output'];
  unreadCount: Scalars['Int']['output'];
  unseenCount: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
  totalSize?: Maybe<Scalars['Int']['output']>;
};

export type ParticipatedEventsSummary = {
  __typename?: 'ParticipatedEventsSummary';
  participatedEvents: Array<Event>;
};

/** Relationship type filter for people search */
export enum PeopleType {
  Following = 'FOLLOWING',
  Friend = 'FRIEND',
  Met = 'MET'
}

export type PinChatV2Error = {
  __typename?: 'PinChatV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: PinChatV2Errors;
};

export enum PinChatV2Errors {
  AlreadyPinned = 'ALREADY_PINNED',
  NotParticipant = 'NOT_PARTICIPANT',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type PinChatV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type PinChatV2Result = {
  __typename?: 'PinChatV2Result';
  errors?: Maybe<Array<PinChatV2Error>>;
  pinnedChatRoom?: Maybe<PinnedChatRoom>;
  success: Scalars['Boolean']['output'];
};

/** Represents a chat room pinned by the current user. */
export type PinnedChatRoom = {
  __typename?: 'PinnedChatRoom';
  chatRoom: ChatRoomV2;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

/** Persisted place entity. */
export type Place = {
  __typename?: 'Place';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  photoReference?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Scalars['String']['output']>>;
  userRatingsTotal?: Maybe<Scalars['Int']['output']>;
};

/** Value object — full place data without persistence identity. */
export type PlaceDetails = {
  __typename?: 'PlaceDetails';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  photoReference?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Scalars['String']['output']>>;
  userRatingsTotal?: Maybe<Scalars['Int']['output']>;
};

export type Poll = {
  __typename?: 'Poll';
  createdAt: Scalars['Date']['output'];
  creator: User;
  creatorID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  options: Array<PollOption>;
  ownerID: Scalars['String']['output'];
  ownerType: PollOwnerType;
  question: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type PollOptionsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PollOption = {
  __typename?: 'PollOption';
  createdAt: Scalars['Date']['output'];
  hasVoted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pollID: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  value: Scalars['String']['output'];
  votes: PollVotesConnection;
};


export type PollOptionVotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum PollOwnerType {
  ChatMessage = 'CHAT_MESSAGE',
  Post = 'POST',
  Room = 'ROOM'
}

export type PollParams = {
  id: Scalars['ID']['input'];
};

export type PollVote = {
  __typename?: 'PollVote';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  pollID: Scalars['ID']['output'];
  pollOptionID: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

export enum PollVoteAction {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

export type PollVoteEdge = {
  __typename?: 'PollVoteEdge';
  cursor: Scalars['String']['output'];
  node: PollVote;
};

export type PollVotesConnection = {
  __typename?: 'PollVotesConnection';
  edges: Array<PollVoteEdge>;
  pageInfo: PageInfo;
};

export type PossibleFriend = {
  __typename?: 'PossibleFriend';
  hasMet: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isFriend: Scalars['Boolean']['output'];
  /** The stored E.164 phone number of the matched user. */
  matchedPhone: Scalars['String']['output'];
  /** The original raw phone string from the caller's device contacts that matched this user. */
  matchedRawPhone: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type Post = {
  __typename?: 'Post';
  claps: ClapSummary;
  comments: CommentSummary;
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  entityID: Scalars['ID']['output'];
  entityType: PostEntityType;
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  poll?: Maybe<Poll>;
  postedBy: PostedBy;
  user: User;
  userID: Scalars['ID']['output'];
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor: Scalars['String']['output'];
  node: Post;
};

export enum PostEntityType {
  Club = 'CLUB',
  Event = 'EVENT',
  Idea = 'IDEA'
}

export type PostParams = {
  id: Scalars['ID']['input'];
};

export enum PostedBy {
  System = 'SYSTEM',
  User = 'USER'
}

export type PostsConnection = {
  __typename?: 'PostsConnection';
  edges: Array<PostEdge>;
  pageInfo: PageInfo;
};

export type PostsParams = {
  entityID: Scalars['ID']['input'];
  entityType: PostEntityType;
};

export type PrepareCreationCanvasAttachmentInput = {
  discoveryID?: InputMaybe<Scalars['ID']['input']>;
  eventID?: InputMaybe<Scalars['ID']['input']>;
  kind: CreationCanvasAttachmentKind;
  mediaImageID?: InputMaybe<Scalars['ID']['input']>;
  requestID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PreviewResolveEventConflictsParams = {
  operations: Array<EventConflictResolutionOperation>;
  /** Optional hypothetical evaluation time for preview-only cancellation impact. */
  previewAt?: InputMaybe<Scalars['Date']['input']>;
};

export type Query = {
  __typename?: 'Query';
  analytics?: Maybe<AnalyticsResult>;
  analyticsSummary: AnalyticsSummaryResult;
  /**
   * Get the chat list for the current user.
   * Returns a mixed list of regular chat rooms and club chat room groups,
   * ordered by most recent activity.
   * Club-type rooms are collapsed into ClubChatRoomGroup entries (one per club).
   */
  chatList: ChatListConnection;
  /**
   * Get messages for a chat room with cursor-based pagination.
   * Messages are ordered by created_at DESC (newest first).
   * Use 'after' cursor to load older messages.
   */
  chatMessagesV2: ChatMessageV2Connection;
  /**
   * Get a single chat room by ID, event ID, or idea ID.
   * Returns null if not found or user is not a participant.
   */
  chatRoomV2?: Maybe<ChatRoomV2>;
  /**
   * List chat rooms for the current user with optional filters.
   * Ordered by most recently active (updated_at DESC).
   */
  chatRoomsV2: ChatRoomV2Connection;
  /**
   * Check whether a waitlist location request has become supported and upgrade it to a waitlist user when possible.
   * This is a PUBLIC endpoint that does not require authentication.
   */
  checkWaitlistLocationRequestStatus: WaitlistLocationRequestStatus;
  /** Check the waitlist status for an email. This is a PUBLIC endpoint that does not require authentication. */
  checkWaitlistUserStatus: WaitlistUserStatus;
  club?: Maybe<Club>;
  clubChatRecommendations: Array<ClubChatRecommendation>;
  clubEngagement: Scalars['Float']['output'];
  clubMembers: ClubMembersConnection;
  clubs: ClubsConnection;
  comment?: Maybe<Comment>;
  comments: CommentsConnection;
  coverCostContributionEstimate: CoverCostContributionEstimate;
  creationCanvas: CreationCanvasSessionResult;
  creationCanvasHandoff: CreationCanvasHandoffResult;
  curatedEvents: CuratedEventsConnection;
  discountCode?: Maybe<DiscountCode>;
  discountCodes: DiscountCodesConnection;
  discoveries: DiscoveriesConnection;
  entityEvents: Array<EntityEvent>;
  event?: Maybe<Event>;
  eventCategories: Array<EventCategory>;
  eventCategory?: Maybe<EventCategory>;
  eventCodeInviteByCode?: Maybe<EventCodeInvite>;
  eventDirectGroupInviteRecipientCount: Scalars['Int']['output'];
  eventDirectInvitesSent: EventDirectInvitesConnection;
  eventInviteGroup?: Maybe<EventInviteGroup>;
  eventRequest?: Maybe<EventRequest>;
  eventReview?: Maybe<EventReview>;
  eventReviewHighlightMedia: EventReviewHighlightMediaConnection;
  eventReviewHighlightMonths: Array<EventReviewHighlightMonth>;
  eventReviewParticipants: EventReviewParticipantConnection;
  eventReviewsStatus: EventReviewStatusConnection;
  eventScheduleConflicts: EventsConnection;
  events: EventsConnection;
  eventsToReview: EventReviewConnection;
  feedV2: FeedV2Connection;
  findLocationCity: LocationCitiesConnection;
  /** @deprecated Use findWaitlistDistricts */
  findLocationCityDistricts: Array<LocationCityDistrict>;
  findLocationSuburb: LocationSuburbsConnection;
  /**
   * Given a list of raw phone numbers from device contacts,
   * returns Butter users whose verified phone number matches via suffix matching.
   * Excludes the caller and deleted users.
   */
  findPossibleFriends: Array<PossibleFriend>;
  /**
   * Get all districts for a given city. Returns an empty list if the city has no districts.
   * This is a PUBLIC endpoint that does not require authentication.
   */
  findWaitlistDistricts: Array<WaitlistDistrict>;
  frequentAttendees: Array<FrequentAttendee>;
  generateClubFromInstagram: GenerateClubFromInstagramResult;
  /**
   * Check if the user has any unseen chat messages.
   * Returns the user's unseen chats status.
   */
  hasUnseenChatsStatus: HasUnseenChatsStatus;
  /** Check if a waitlist exists for a city/group pair. This is a PUBLIC endpoint that does not require authentication. */
  hasWaitlist: HasWaitlistResult;
  hostToolsAccess: Array<HostToolGroupAccess>;
  idea?: Maybe<Idea>;
  ideas?: Maybe<IdeasConnection>;
  myEventDirectInvites: EventDirectInvitesConnection;
  myFriendRequests: FriendRequestsConnection;
  /**
   * Get the current user's waitlist status using their authenticated session email.
   * Requires authentication.
   */
  myWaitlistUserStatus: WaitlistUserStatus;
  newClubMembers: Scalars['Int']['output'];
  notificationSettings: NotificationSettings;
  notifications: NotificationsConnection;
  notificationsSummary: NotificationsSummary;
  /**
   * Get the current user's pinned (starred) chat rooms.
   * Ordered by pin creation time (newest first).
   */
  pinnedChats: Array<PinnedChatRoom>;
  poll?: Maybe<Poll>;
  post?: Maybe<Post>;
  posts: PostsConnection;
  previewAttendanceNoShowImpact: EventConflictResolutionPreview;
  previewCancelEvent: EventConflictResolutionPreview;
  previewResolveEventConflicts: EventConflictResolutionPreview;
  resolveCountryByCode: ResolveIpCountryResult;
  resolveIPCountry: ResolveIpCountryResult;
  /** Performs an agentic search across events, clubs, ideas, and users */
  search: SearchConnection;
  /** Search the authenticated user's friends by name. If no query is provided, returns all friends. */
  searchFriends: SearchFriendsConnection;
  /** Get users that can be mentioned in a post for a given entity (event or idea) */
  searchMentionable: SearchMentionableConnection;
  /**
   * Search across the authenticated user's people (friends, following, met).
   * Returns a flat, ordered list with friends first, following second, met third.
   * Deduplicates so a user only appears once under their highest-priority relationship.
   */
  searchPeople: SearchPeopleConnection;
  /** Get search suggestions personalized for the authenticated user */
  searchSuggestions: SearchSuggestionsResult;
  /**
   * Search waitlist locations for a city. Returns supported Butter districts or unsupported localities plus closest district fallback.
   * This is a PUBLIC endpoint that does not require authentication.
   */
  searchWaitlistLocations: WaitlistLocationSearchResultSet;
  ticketCost: EventTicketCost;
  ticketCostEstimate: EventTicketCost;
  ticketVariationPricingPreview: TicketVariationPricingPreview;
  totalGuestCount: Scalars['Int']['output'];
  user?: Maybe<User>;
  users: Array<User>;
  validateDiscountCode: DiscountCodeValidation;
  /**
   * Get display-ready race rows for a waitlist. Uses district rows when the city has multiple waitlist districts, otherwise group rows.
   * This is a PUBLIC endpoint that does not require authentication.
   */
  waitlistRace: WaitlistRace;
  /** Get all waitlists, optionally filtered by city. This is a PUBLIC endpoint that does not require authentication. */
  waitlists: Array<Waitlist>;
  wallet?: Maybe<Wallet>;
  walletClubs: Array<WalletClub>;
  walletIntent?: Maybe<WalletIntent>;
  walletIntents: WalletIntentConnection;
  walletPayoutQuote: WalletPayoutQuoteResult;
};


export type QueryAnalyticsArgs = {
  input: AnalyticsTypeInput;
};


export type QueryAnalyticsSummaryArgs = {
  input: AnalyticsSummaryTypeInput;
};


export type QueryChatListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ChatListParams>;
};


export type QueryChatMessagesV2Args = {
  first?: InputMaybe<Scalars['Int']['input']>;
  params: ChatMessagesV2Params;
};


export type QueryChatRoomV2Args = {
  params: ChatRoomV2Params;
};


export type QueryChatRoomsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ChatRoomsV2Params>;
};


export type QueryCheckWaitlistLocationRequestStatusArgs = {
  input: CheckWaitlistLocationRequestStatusInput;
};


export type QueryCheckWaitlistUserStatusArgs = {
  input: CheckWaitlistUserStatusInput;
};


export type QueryClubArgs = {
  params: ClubParams;
};


export type QueryClubChatRecommendationsArgs = {
  params: ClubChatRecommendations;
};


export type QueryClubEngagementArgs = {
  params: ClubEngagementParams;
};


export type QueryClubMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: ClubMembersParams;
};


export type QueryClubsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: ClubsParams;
};


export type QueryCommentArgs = {
  params: CommentParams;
};


export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: CommentsParams;
};


export type QueryCoverCostContributionEstimateArgs = {
  params: CoverCostContributionEstimateParams;
};


export type QueryCreationCanvasArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreationCanvasHandoffArgs = {
  revisionID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
};


export type QueryCuratedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<CuratedEventsParams>;
};


export type QueryDiscountCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscountCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: DiscountCodesParams;
};


export type QueryDiscoveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  categoryID?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  locationCityID: Scalars['ID']['input'];
};


export type QueryEntityEventsArgs = {
  params?: InputMaybe<EntityEventsParams>;
};


export type QueryEventArgs = {
  params: EventParams;
};


export type QueryEventCategoriesArgs = {
  level?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventCodeInviteByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryEventDirectGroupInviteRecipientCountArgs = {
  params: CreateEventDirectGroupInviteParams;
};


export type QueryEventDirectInvitesSentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params: EventDirectInvitesSentParams;
};


export type QueryEventInviteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventRequestArgs = {
  params: EventRequestParams;
};


export type QueryEventReviewArgs = {
  input: EventReviewInput;
};


export type QueryEventReviewHighlightMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  input: EventReviewHighlightMediaInput;
};


export type QueryEventReviewHighlightMonthsArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventReviewParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  input: EventReviewParticipantsInput;
};


export type QueryEventReviewsStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  input: EventReviewStatusInput;
};


export type QueryEventScheduleConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: EventScheduleConflictsParams;
};


export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: EventsParams;
};


export type QueryEventsToReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryFeedV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<FeedV2Params>;
};


export type QueryFindLocationCityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: FindLocationCityParams;
};


export type QueryFindLocationCityDistrictsArgs = {
  locationCityId: Scalars['ID']['input'];
};


export type QueryFindLocationSuburbArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: FindLocationSuburbParams;
};


export type QueryFindPossibleFriendsArgs = {
  params: FindPossibleFriendsParams;
};


export type QueryFindWaitlistDistrictsArgs = {
  locationCityId: Scalars['ID']['input'];
};


export type QueryFrequentAttendeesArgs = {
  params: FrequentAttendeesParams;
};


export type QueryGenerateClubFromInstagramArgs = {
  input: GenerateClubFromInstagramInput;
};


export type QueryHasWaitlistArgs = {
  input: HasWaitlistInput;
};


export type QueryHostToolsAccessArgs = {
  input: HostToolsAccessInput;
};


export type QueryIdeaArgs = {
  params?: InputMaybe<IdeaParams>;
};


export type QueryIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params?: InputMaybe<IdeasParams>;
};


export type QueryMyEventDirectInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params?: InputMaybe<MyEventDirectInvitesParams>;
};


export type QueryMyFriendRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params: MyFriendRequestsParams;
};


export type QueryNewClubMembersArgs = {
  params: NewClubMembersParams;
};


export type QueryNotificationSettingsArgs = {
  scope: NotificationSettingScope;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<NotificationsParams>;
};


export type QueryPollArgs = {
  params: PollParams;
};


export type QueryPostArgs = {
  params: PostParams;
};


export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: PostsParams;
};


export type QueryPreviewAttendanceNoShowImpactArgs = {
  eventID: Scalars['ID']['input'];
};


export type QueryPreviewCancelEventArgs = {
  eventID: Scalars['ID']['input'];
};


export type QueryPreviewResolveEventConflictsArgs = {
  params: PreviewResolveEventConflictsParams;
};


export type QueryResolveCountryByCodeArgs = {
  isoCode: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: SearchParams;
};


export type QuerySearchFriendsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: SearchFriendsParams;
};


export type QuerySearchMentionableArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: MentionableParams;
};


export type QuerySearchPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: SearchPeopleParams;
};


export type QuerySearchWaitlistLocationsArgs = {
  input: SearchWaitlistLocationsInput;
};


export type QueryTicketCostArgs = {
  params: TicketCostParams;
};


export type QueryTicketCostEstimateArgs = {
  params: TicketCostEstimateParams;
};


export type QueryTicketVariationPricingPreviewArgs = {
  params: TicketVariationPricingPreviewParams;
};


export type QueryTotalGuestCountArgs = {
  params?: InputMaybe<TotalGuestCountParams>;
};


export type QueryUserArgs = {
  params?: InputMaybe<UserParams>;
};


export type QueryUsersArgs = {
  params?: InputMaybe<UsersParams>;
};


export type QueryValidateDiscountCodeArgs = {
  params: ValidateDiscountCodeParams;
};


export type QueryWaitlistRaceArgs = {
  input: WaitlistRaceInput;
};


export type QueryWaitlistsArgs = {
  input?: InputMaybe<WaitlistsInput>;
};


export type QueryWalletArgs = {
  params?: InputMaybe<WalletParams>;
};


export type QueryWalletIntentArgs = {
  params: WalletIntentParams;
};


export type QueryWalletIntentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  params: WalletIntentsParams;
};


export type QueryWalletPayoutQuoteArgs = {
  params: WalletPayoutQuoteParams;
};

export enum RedeemEventTicketPurchaseCodeOutcome {
  AlreadyAttending = 'ALREADY_ATTENDING',
  AlreadyRedeemed = 'ALREADY_REDEEMED',
  AnonymousUserMustUpgrade = 'ANONYMOUS_USER_MUST_UPGRADE',
  CannotRedeemOwnCode = 'CANNOT_REDEEM_OWN_CODE',
  EventCancelled = 'EVENT_CANCELLED',
  EventEnded = 'EVENT_ENDED',
  Expired = 'EXPIRED',
  InvalidCode = 'INVALID_CODE',
  Success = 'SUCCESS',
  TicketAlreadyLinked = 'TICKET_ALREADY_LINKED',
  UserBlocked = 'USER_BLOCKED'
}

export type RedeemEventTicketPurchaseCodeResult = {
  __typename?: 'RedeemEventTicketPurchaseCodeResult';
  attendee?: Maybe<EventAttendee>;
  eventID?: Maybe<Scalars['ID']['output']>;
  outcome: RedeemEventTicketPurchaseCodeOutcome;
  request?: Maybe<EventRequest>;
  success: Scalars['Boolean']['output'];
};

export enum ReferrerType {
  Affiliate = 'AFFILIATE',
  EventInvite = 'EVENT_INVITE',
  Ugc = 'UGC',
  UserInvite = 'USER_INVITE'
}

export type RegisterWaitlistLocationRequestInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nearestLocationCityDistrictId?: InputMaybe<Scalars['ID']['input']>;
  nearestWaitlistDistrictId?: InputMaybe<Scalars['ID']['input']>;
  postcode: Scalars['String']['input'];
};

export type RegisterWaitlistLocationRequestResult = {
  __typename?: 'RegisterWaitlistLocationRequestResult';
  message?: Maybe<Scalars['String']['output']>;
  request?: Maybe<WaitlistLocationRequest>;
  success: Scalars['Boolean']['output'];
};

export type RegisterWaitlistUserInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  referrerType?: InputMaybe<ReferrerType>;
  referrerUserId?: InputMaybe<Scalars['ID']['input']>;
  referrerWaitlistUserId?: InputMaybe<Scalars['ID']['input']>;
  waitlistId: Scalars['ID']['input'];
};

export type RegisterWaitlistUserResult = {
  __typename?: 'RegisterWaitlistUserResult';
  message?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  waitlistUserId?: Maybe<Scalars['ID']['output']>;
};

export type RemoveChatParticipantV2Error = {
  __typename?: 'RemoveChatParticipantV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: RemoveChatParticipantV2Errors;
};

export enum RemoveChatParticipantV2Errors {
  NotAdmin = 'NOT_ADMIN',
  ParticipantNotFound = 'PARTICIPANT_NOT_FOUND',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type RemoveChatParticipantV2Input = {
  chatRoomID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type RemoveChatParticipantV2Result = {
  __typename?: 'RemoveChatParticipantV2Result';
  errors?: Maybe<Array<RemoveChatParticipantV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type RemoveMediaFromEventReviewHighlightInput = {
  highlightMediaId: Scalars['ID']['input'];
};

export type RemoveMediaFromEventReviewHighlightResult = {
  __typename?: 'RemoveMediaFromEventReviewHighlightResult';
  error?: Maybe<EventReviewError>;
  success: Scalars['Boolean']['output'];
};

export type RemovePlanRequestError = {
  __typename?: 'RemovePlanRequestError';
  message?: Maybe<Scalars['String']['output']>;
  type: RemovePlanRequestErrors;
};

export enum RemovePlanRequestErrors {
  NotAdmin = 'NOT_ADMIN',
  NoPlanActivity = 'NO_PLAN_ACTIVITY',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type RemovePlanRequestInput = {
  chatRoomID: Scalars['ID']['input'];
};

export type RemovePlanRequestResult = {
  __typename?: 'RemovePlanRequestResult';
  errors?: Maybe<Array<RemovePlanRequestError>>;
  success: Scalars['Boolean']['output'];
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['Date']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: ReportReason;
  reportedEntityID: Scalars['ID']['output'];
  reportedEntityType: ReportType;
  reporterUserID: Scalars['ID']['output'];
};

export type ReportError = {
  __typename?: 'ReportError';
  message: Scalars['String']['output'];
  type: ReportErrorType;
};

export enum ReportErrorType {
  InvalidInput = 'INVALID_INPUT'
}

export type ReportEventParams = {
  eventID: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<ReportReason>;
};

export type ReportEventResult = {
  __typename?: 'ReportEventResult';
  error?: Maybe<ReportError>;
  report?: Maybe<Report>;
  success: Scalars['Boolean']['output'];
};

export type ReportHostNoShowsInput = {
  hostUserIds: Array<Scalars['ID']['input']>;
  reviewId: Scalars['ID']['input'];
};

export type ReportHostNoShowsResult = {
  __typename?: 'ReportHostNoShowsResult';
  error?: Maybe<EventReviewError>;
  eventReview?: Maybe<EventReview>;
};

export type ReportParams = {
  entityID: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  reasonCode?: InputMaybe<ReportReason>;
  type: ReportType;
};

export enum ReportReason {
  EventReviewCoverCostJarMisuse = 'EVENT_REVIEW_COVER_COST_JAR_MISUSE',
  EventReviewHostNoShow = 'EVENT_REVIEW_HOST_NO_SHOW',
  EventReviewInappropriateBehaviour = 'EVENT_REVIEW_INAPPROPRIATE_BEHAVIOUR',
  EventReviewOther = 'EVENT_REVIEW_OTHER',
  EventReviewSafetyConcern = 'EVENT_REVIEW_SAFETY_CONCERN',
  GenericOther = 'GENERIC_OTHER'
}

export type ReportResult = {
  __typename?: 'ReportResult';
  error?: Maybe<ReportError>;
  report?: Maybe<Report>;
  success: Scalars['Boolean']['output'];
};

export enum ReportType {
  Chat = 'CHAT',
  Club = 'CLUB',
  Comment = 'COMMENT',
  Event = 'EVENT',
  Idea = 'IDEA',
  Post = 'POST',
  User = 'USER'
}

export type ResolveEventConflictsError = {
  __typename?: 'ResolveEventConflictsError';
  code: ResolveEventConflictsErrorCode;
  eventID: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export enum ResolveEventConflictsErrorCode {
  AlreadyAttending = 'ALREADY_ATTENDING',
  /** RSVP_EVENT was used for an event that requires host approval. */
  ApprovalRequired = 'APPROVAL_REQUIRED',
  /** REQUEST_REFUND was used on a Cover Cost attendee without a refundable payment. */
  AttendeeHasNoCoverCostPayment = 'ATTENDEE_HAS_NO_COVER_COST_PAYMENT',
  /** REQUEST_REFUND was used after Cover Cost funds were released; refunds must be handled manually. */
  CoverCostRefundAfterReleaseUnsupported = 'COVER_COST_REFUND_AFTER_RELEASE_UNSUPPORTED',
  EventFull = 'EVENT_FULL',
  EventNotFound = 'EVENT_NOT_FOUND',
  /** RSVP_EVENT was used for an event that is cancelled, ended, or otherwise not joinable. */
  EventNotJoinable = 'EVENT_NOT_JOINABLE',
  /** RSVP_EVENT was used for an event that requires RSVP form answers. */
  FormRequired = 'FORM_REQUIRED',
  /**
   * REQUEST_REFUND was used on a free event — the caller should send
   * LEAVE_EVENT instead.
   */
  FreeEvent = 'FREE_EVENT',
  /** The batch contained duplicate or contradictory ops for the same event. */
  InvalidOperation = 'INVALID_OPERATION',
  NotAttending = 'NOT_ATTENDING',
  /**
   * REQUEST_REFUND was used on a paid Cover Cost attendee before confirmation;
   * the caller should send LEAVE_EVENT because removal auto-refunds then.
   */
  RefundRequestNotRequiredBeforeConfirmation = 'REFUND_REQUEST_NOT_REQUIRED_BEFORE_CONFIRMATION',
  /**
   * LEAVE_EVENT was used on a ticketed event — the caller should send
   * REQUEST_REFUND instead.
   */
  TicketedEvent = 'TICKETED_EVENT',
  UserBlocked = 'USER_BLOCKED'
}

export type ResolveEventConflictsParams = {
  operations: Array<EventConflictResolutionOperation>;
};

export type ResolveEventConflictsResult = {
  __typename?: 'ResolveEventConflictsResult';
  /** The first failing op; the whole batch was rolled back. */
  error?: Maybe<ResolveEventConflictsError>;
  success: Scalars['Boolean']['output'];
};

export type ResolveIpCountryResult = {
  __typename?: 'ResolveIPCountryResult';
  country?: Maybe<LocationCountry>;
  ipCountryCode: Scalars['String']['output'];
  ipCountryName: Scalars['String']['output'];
  supported: Scalars['Boolean']['output'];
};

export enum RespondToEventDirectInviteOutcome {
  AlreadyHost = 'ALREADY_HOST',
  AlreadyResponded = 'ALREADY_RESPONDED',
  BecameAttendee = 'BECAME_ATTENDEE',
  Declined = 'DECLINED',
  EventCancelled = 'EVENT_CANCELLED',
  EventEnded = 'EVENT_ENDED',
  EventFull = 'EVENT_FULL',
  InviteNotFound = 'INVITE_NOT_FOUND',
  JoinedWaitlist = 'JOINED_WAITLIST',
  NotInvitee = 'NOT_INVITEE',
  ProvideAttendeeFormAnswers = 'PROVIDE_ATTENDEE_FORM_ANSWERS',
  RequiresCoverCost = 'REQUIRES_COVER_COST',
  RequiresTicket = 'REQUIRES_TICKET',
  UserBlocked = 'USER_BLOCKED'
}

export type RespondToEventDirectInviteParams = {
  accept: Scalars['Boolean']['input'];
  inviteID: Scalars['ID']['input'];
};

export type RespondToEventDirectInviteResult = {
  __typename?: 'RespondToEventDirectInviteResult';
  event?: Maybe<Event>;
  eventID?: Maybe<Scalars['ID']['output']>;
  invite?: Maybe<EventDirectInvite>;
  outcome: RespondToEventDirectInviteOutcome;
};

export type RespondToFriendRequestError = {
  __typename?: 'RespondToFriendRequestError';
  code: RespondToFriendRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum RespondToFriendRequestErrorCode {
  AlreadyResponded = 'ALREADY_RESPONDED',
  NotFound = 'NOT_FOUND',
  NotRecipient = 'NOT_RECIPIENT'
}

export type RespondToFriendRequestParams = {
  friendRequestID: Scalars['ID']['input'];
  responseType: FriendRequestResponseType;
};

export type RespondToFriendRequestResult = {
  __typename?: 'RespondToFriendRequestResult';
  error?: Maybe<RespondToFriendRequestError>;
  friendRequest?: Maybe<FriendRequest>;
};

export enum ReviewStep {
  Completed = 'COMPLETED',
  Confetti = 'CONFETTI',
  LockInNext = 'LOCK_IN_NEXT',
  MarkAttendance = 'MARK_ATTENDANCE',
  RateEvent = 'RATE_EVENT',
  StartGroupChat = 'START_GROUP_CHAT',
  Stats = 'STATS',
  Tags = 'TAGS',
  TipHost = 'TIP_HOST',
  UploadMedia = 'UPLOAD_MEDIA',
  UsersLiked = 'USERS_LIKED',
  UsersLikedActions = 'USERS_LIKED_ACTIONS'
}

export type Reward = {
  __typename?: 'Reward';
  description: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: RewardScope;
};

export enum RewardScope {
  Club = 'CLUB',
  Guest = 'GUEST',
  Host = 'HOST'
}

export type SaveEventParams = {
  eventID: Scalars['ID']['input'];
};

export type SaveEventResult = {
  __typename?: 'SaveEventResult';
  success: Scalars['Boolean']['output'];
};

export type SavedEventsSummary = {
  __typename?: 'SavedEventsSummary';
  savedEvents: Array<Event>;
};

/** Search connection following Relay connection pattern */
export type SearchConnection = {
  __typename?: 'SearchConnection';
  edges: Array<SearchEdge>;
  pageInfo: PageInfo;
};

/** Content type filter for search results */
export enum SearchContentType {
  Club = 'CLUB',
  Event = 'EVENT',
  Idea = 'IDEA',
  User = 'USER'
}

/** Search edge containing a search result node and cursor */
export type SearchEdge = {
  __typename?: 'SearchEdge';
  cursor: Scalars['String']['output'];
  node: SearchResultNode;
};

/** Connection type for friend search results */
export type SearchFriendsConnection = {
  __typename?: 'SearchFriendsConnection';
  edges: Array<SearchFriendsEdge>;
  pageInfo: PageInfo;
};

/** Edge containing a friend user and cursor */
export type SearchFriendsEdge = {
  __typename?: 'SearchFriendsEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Input parameters for searching friends */
export type SearchFriendsParams = {
  /** Optional search query to match against friend names. If not provided, returns all friends. */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Connection type for mentionable users */
export type SearchMentionableConnection = {
  __typename?: 'SearchMentionableConnection';
  edges: Array<SearchMentionableEdge>;
  pageInfo: PageInfo;
};

/** Edge containing a mentionable user and cursor */
export type SearchMentionableEdge = {
  __typename?: 'SearchMentionableEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Search ordering options */
export enum SearchOrderBy {
  Closest = 'CLOSEST',
  Newest = 'NEWEST',
  Popular = 'POPULAR',
  Relevance = 'RELEVANCE',
  Soonest = 'SOONEST'
}

/** Input parameters for search */
export type SearchParams = {
  contentType?: InputMaybe<SearchContentType>;
  location?: InputMaybe<LocationInput>;
  orderBy?: InputMaybe<SearchOrderBy>;
  query: Scalars['String']['input'];
  /**
   * IANA timezone identifier (e.g., "Australia/Melbourne") for interpreting
   * relative date expressions like "next weekend" or "tomorrow"
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Connection type for people search results */
export type SearchPeopleConnection = {
  __typename?: 'SearchPeopleConnection';
  edges: Array<SearchPeopleEdge>;
  pageInfo: PageInfo;
};

/** Edge containing a person user and cursor */
export type SearchPeopleEdge = {
  __typename?: 'SearchPeopleEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Input parameters for searching people (friends, following, met) */
export type SearchPeopleParams = {
  /** Optional search query to match against people names. If not provided, returns all people. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Optional relationship type filter. If not provided, returns all people across all relationship types. */
  type?: InputMaybe<PeopleType>;
};

/** Union type for search results - can be Event, Club, Idea, or User */
export type SearchResultNode = Club | Event | Idea | User;

/** A search suggestion to display to users */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** The emoji associated with the suggestion */
  emoji?: Maybe<Scalars['String']['output']>;
  /** Optional image URL for visual suggestions (used by highlights) */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Display label for the suggestion */
  label: Scalars['String']['output'];
  /** Number of searches for this suggestion over the past month (only populated for POPULAR type) */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The search query to execute when selected */
  query: Scalars['String']['output'];
  /** Type of suggestion for analytics tracking */
  type: SearchSuggestionType;
};

/** Type of search suggestion */
export enum SearchSuggestionType {
  Example = 'EXAMPLE',
  Highlight = 'HIGHLIGHT',
  Popular = 'POPULAR'
}

/** Response containing all search suggestions for a user */
export type SearchSuggestionsResult = {
  __typename?: 'SearchSuggestionsResult';
  /** Example search queries to inspire users */
  examples: Array<SearchSuggestion>;
  /** City-specific event highlights (e.g., Spring Racing Carnival) */
  highlights: Array<SearchSuggestion>;
  /** Popular searches from other users in the same city */
  popular: Array<SearchSuggestion>;
};

export type SearchWaitlistLocationsInput = {
  locationCityId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SelectCreationCanvasOptionInput = {
  requestID: Scalars['ID']['input'];
  revisionID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
};

export type SendChatMessageV2Error = {
  __typename?: 'SendChatMessageV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: SendChatMessageV2Errors;
};

export enum SendChatMessageV2Errors {
  BlockedUrl = 'BLOCKED_URL',
  NotParticipant = 'NOT_PARTICIPANT',
  PollOptionsRequired = 'POLL_OPTIONS_REQUIRED',
  PollQuestionRequired = 'POLL_QUESTION_REQUIRED',
  RoomNotFound = 'ROOM_NOT_FOUND',
  TextRequired = 'TEXT_REQUIRED',
  UserBlocked = 'USER_BLOCKED'
}

export type SendChatMessageV2Input = {
  attachments?: InputMaybe<Array<ChatAttachmentInput>>;
  chatRoomID: Scalars['ID']['input'];
  intent?: InputMaybe<ChatMessageIntent>;
  mentionedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  poll?: InputMaybe<ChatPollInput>;
  replyToID?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: ChatMessageType;
};

export type SendChatMessageV2Result = {
  __typename?: 'SendChatMessageV2Result';
  errors?: Maybe<Array<SendChatMessageV2Error>>;
  message?: Maybe<ChatMessageV2>;
  success: Scalars['Boolean']['output'];
};

export type SendPasswordlessAuthEmailParams = {
  device?: InputMaybe<DeviceType>;
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  useNewWebsite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendPasswordlessAuthEmailResult = {
  __typename?: 'SendPasswordlessAuthEmailResult';
  success: Scalars['Boolean']['output'];
};

export type SendPhoneVerificationCodeError = {
  __typename?: 'SendPhoneVerificationCodeError';
  code: SendPhoneVerificationCodeErrorCode;
  message: Scalars['String']['output'];
};

export enum SendPhoneVerificationCodeErrorCode {
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  RateLimited = 'RATE_LIMITED',
  TooManyAttempts = 'TOO_MANY_ATTEMPTS'
}

export type SendPhoneVerificationCodeParams = {
  dispatchID: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SendPhoneVerificationCodeResult = {
  __typename?: 'SendPhoneVerificationCodeResult';
  error?: Maybe<SendPhoneVerificationCodeError>;
  success: Scalars['Boolean']['output'];
};

export type SetChatTypingV2Error = {
  __typename?: 'SetChatTypingV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: SetChatTypingV2Errors;
};

export enum SetChatTypingV2Errors {
  NotParticipant = 'NOT_PARTICIPANT',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type SetChatTypingV2Input = {
  chatRoomID: Scalars['ID']['input'];
  isTyping: Scalars['Boolean']['input'];
};

export type SetChatTypingV2Result = {
  __typename?: 'SetChatTypingV2Result';
  errors?: Maybe<Array<SetChatTypingV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type SimilarEventsParams = {
  strict: Scalars['Boolean']['input'];
};

export type Social = {
  __typename?: 'Social';
  createdAt: Scalars['Date']['output'];
  entityID: Scalars['ID']['output'];
  entityType: SocialEntityType;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: SocialType;
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export enum SocialEntityType {
  Club = 'CLUB',
  User = 'USER'
}

export enum SocialType {
  Facebook = 'FACEBOOK',
  Goodreads = 'GOODREADS',
  Instagram = 'INSTAGRAM',
  Letterboxd = 'LETTERBOXD',
  Linktree = 'LINKTREE',
  Shelf = 'SHELF',
  Spotify = 'SPOTIFY',
  Strava = 'STRAVA',
  Substack = 'SUBSTACK',
  Tiktok = 'TIKTOK'
}

export type StartCreationCanvasInput = {
  area?: InputMaybe<CreationCanvasAreaInput>;
  requestID: Scalars['ID']['input'];
};

export enum StripeConnectAccountBusinessType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export type SubmitCreationCanvasMessageInput = {
  context?: InputMaybe<CreationCanvasContextInput>;
  expectedVersion: Scalars['Int']['input'];
  focusedRevisionID?: InputMaybe<Scalars['ID']['input']>;
  intent?: InputMaybe<CreationCanvasMessageIntent>;
  location?: InputMaybe<CreationCanvasLocationInput>;
  requestID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type SubmitEventReviewRatingInput = {
  rating: EventRating;
  reviewId: Scalars['ID']['input'];
};

export type SubmitEventReviewRatingResult = {
  __typename?: 'SubmitEventReviewRatingResult';
  error?: Maybe<EventReviewError>;
  eventReview?: Maybe<EventReview>;
};

export type SubmitEventReviewUserTagsInput = {
  eventId: Scalars['ID']['input'];
  tags: Array<EventReviewUserTagInput>;
};

export type SubmitEventReviewUserTagsResult = {
  __typename?: 'SubmitEventReviewUserTagsResult';
  error?: Maybe<EventReviewError>;
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscribe to real-time events for the user's chat list.
   * Receives new room notifications, unread count updates, and room updates.
   * Events are filtered to only rooms where the user is a participant.
   */
  chatListEventsV2: ChatListEvent;
  /**
   * Subscribe to real-time events for a specific chat room.
   * Receives message events, typing indicators, reactions, and participant changes.
   * Requires user to be a participant of the room.
   */
  chatRoomEventsV2: ChatRoomEvent;
  creationCanvasUpdates: CreationCanvasSessionResult;
  /**
   * Stream AI-generated event options one at a time.
   * Accepts either a free text prompt or a chat activity ID.
   * Each event contains a single generated event option.
   */
  generateEvents: GenerateEventStreamResult;
  /**
   * Subscribe to changes in the user's global hasUnseenChats status.
   * Emits updates when new messages arrive in user's rooms.
   * Client should set false optimistically after markChatsSeen mutation.
   */
  hasUnseenChatsStatus: HasUnseenChatsStatus;
  /**
   * Subscribe to notification events for the authenticated user.
   * Returns notification events as they occur in real-time.
   */
  notificationEvents: NotificationEvent;
  /**
   * Subscribe to real-time updates for a poll.
   * Receives the poll whenever anyone votes on it.
   */
  pollUpdated: Poll;
};


export type SubscriptionChatRoomEventsV2Args = {
  roomID: Scalars['ID']['input'];
};


export type SubscriptionCreationCanvasUpdatesArgs = {
  sessionID: Scalars['ID']['input'];
};


export type SubscriptionGenerateEventsArgs = {
  input: GenerateEventsInput;
};


export type SubscriptionPollUpdatedArgs = {
  pollID: Scalars['ID']['input'];
};

export type TicketCheckoutProfileFromInstagram = {
  __typename?: 'TicketCheckoutProfileFromInstagram';
  bio: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type TicketCostEstimateParams = {
  absorbFees: Scalars['Boolean']['input'];
  baseTicketCostCents: Scalars['Int']['input'];
  clubID?: InputMaybe<Scalars['ID']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
};

export type TicketCostParams = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  eventID: Scalars['ID']['input'];
  eventTicketVariationID?: InputMaybe<Scalars['ID']['input']>;
  type: EventTicketType;
};

export type TicketSalesApprovalRequest = {
  __typename?: 'TicketSalesApprovalRequest';
  createdAt: Scalars['Date']['output'];
  externalEventUrl: Scalars['String']['output'];
  forClubID?: Maybe<Scalars['ID']['output']>;
  forUserID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  requesterUserID: Scalars['ID']['output'];
  status: TicketSalesApprovalRequestStatus;
  summary: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TicketSalesApprovalRequestError = {
  __typename?: 'TicketSalesApprovalRequestError';
  code: TicketSalesApprovalRequestErrorCode;
  message: Scalars['String']['output'];
};

export enum TicketSalesApprovalRequestErrorCode {
  AlreadyApproved = 'ALREADY_APPROVED',
  ClubNotFound = 'CLUB_NOT_FOUND',
  DuplicatePendingRequest = 'DUPLICATE_PENDING_REQUEST',
  InvalidExternalEventUrl = 'INVALID_EXTERNAL_EVENT_URL',
  NotClubManager = 'NOT_CLUB_MANAGER',
  SummaryRequired = 'SUMMARY_REQUIRED'
}

export type TicketSalesApprovalRequestInput = {
  externalEventUrl?: InputMaybe<Scalars['String']['input']>;
  forClubID?: InputMaybe<Scalars['ID']['input']>;
  summary: Scalars['String']['input'];
};

export type TicketSalesApprovalRequestResult = {
  __typename?: 'TicketSalesApprovalRequestResult';
  error?: Maybe<TicketSalesApprovalRequestError>;
  request?: Maybe<TicketSalesApprovalRequest>;
  success: Scalars['Boolean']['output'];
};

export enum TicketSalesApprovalRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type TicketVariationPricePreview = {
  __typename?: 'TicketVariationPricePreview';
  guestTotalCents: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  receivesCents: Scalars['Int']['output'];
};

export type TicketVariationPricingPreview = {
  __typename?: 'TicketVariationPricingPreview';
  currency: WalletCurrency;
  maximumGuestTotalCents: Scalars['Int']['output'];
  minimumGuestTotalCents: Scalars['Int']['output'];
  projectedRevenueCents: Scalars['Int']['output'];
  variations: Array<TicketVariationPricePreview>;
};

export type TicketVariationPricingPreviewInput = {
  capacity: Scalars['Int']['input'];
  priceCents: Scalars['Int']['input'];
};

export type TicketVariationPricingPreviewParams = {
  absorbFees: Scalars['Boolean']['input'];
  clubID?: InputMaybe<Scalars['ID']['input']>;
  variations: Array<TicketVariationPricingPreviewInput>;
};

export type TipRecipient = Club | User;

export enum ToggleChatReactionAction {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type ToggleChatReactionV2Error = {
  __typename?: 'ToggleChatReactionV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: ToggleChatReactionV2Errors;
};

export enum ToggleChatReactionV2Errors {
  MessageNotFound = 'MESSAGE_NOT_FOUND',
  NotParticipant = 'NOT_PARTICIPANT'
}

export type ToggleChatReactionV2Input = {
  emoji: Scalars['String']['input'];
  messageID: Scalars['ID']['input'];
};

export type ToggleChatReactionV2Result = {
  __typename?: 'ToggleChatReactionV2Result';
  action?: Maybe<ToggleChatReactionAction>;
  errors?: Maybe<Array<ToggleChatReactionV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type TogglePollVoteParams = {
  pollOptionID: Scalars['ID']['input'];
};

export type TogglePollVoteResult = {
  __typename?: 'TogglePollVoteResult';
  action: PollVoteAction;
  success: Scalars['Boolean']['output'];
  vote?: Maybe<PollVote>;
};

export type TotalGuestCountParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
};

export type TrackActivityInput = {
  activityType: ActivityType;
  clubId?: InputMaybe<Scalars['ID']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  feed?: InputMaybe<FeedActivityMetadataInput>;
  ideaId?: InputMaybe<Scalars['ID']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type TrackActivityResult = {
  __typename?: 'TrackActivityResult';
  success: Scalars['Boolean']['output'];
};

export type UnblockUserParams = {
  userID: Scalars['ID']['input'];
};

export type UnblockUserResult = {
  __typename?: 'UnblockUserResult';
  errors: Array<UserBlockError>;
  success: Scalars['Boolean']['output'];
};

export type UnfollowUserParams = {
  followedUserID: Scalars['ID']['input'];
};

export type UnfollowUserResult = {
  __typename?: 'UnfollowUserResult';
  followedUserID?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UnfriendUserParams = {
  friendUserID: Scalars['ID']['input'];
};

export type UnfriendUserResult = {
  __typename?: 'UnfriendUserResult';
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['ID']['output']>;
};

export type UnpinChatV2Error = {
  __typename?: 'UnpinChatV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: UnpinChatV2Errors;
};

export enum UnpinChatV2Errors {
  NotPinned = 'NOT_PINNED',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type UnpinChatV2Input = {
  chatRoomID: Scalars['ID']['input'];
};

export type UnpinChatV2Result = {
  __typename?: 'UnpinChatV2Result';
  errors?: Maybe<Array<UnpinChatV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type UnsaveEventParams = {
  eventID: Scalars['ID']['input'];
};

export type UnsaveEventResult = {
  __typename?: 'UnsaveEventResult';
  success: Scalars['Boolean']['output'];
};

export type UnsupportedWaitlistLocation = {
  __typename?: 'UnsupportedWaitlistLocation';
  displayName: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postcode: Scalars['String']['output'];
};

export type UpdateChatRoomV2Error = {
  __typename?: 'UpdateChatRoomV2Error';
  message?: Maybe<Scalars['String']['output']>;
  type: UpdateChatRoomV2Errors;
};

export enum UpdateChatRoomV2Errors {
  NotAdmin = 'NOT_ADMIN',
  RoomNotFound = 'ROOM_NOT_FOUND'
}

export type UpdateChatRoomV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChatRoomV2Result = {
  __typename?: 'UpdateChatRoomV2Result';
  chatRoom?: Maybe<ChatRoomV2>;
  errors?: Maybe<Array<UpdateChatRoomV2Error>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateClubError = {
  __typename?: 'UpdateClubError';
  message?: Maybe<Scalars['String']['output']>;
  type: UpdateClubErrors;
};

export enum UpdateClubErrors {
  ClubNotFound = 'CLUB_NOT_FOUND',
  DecorativeLetters = 'DECORATIVE_LETTERS',
  DescriptionTooLong = 'DESCRIPTION_TOO_LONG',
  NameAlreadyExists = 'NAME_ALREADY_EXISTS',
  NameTooLong = 'NAME_TOO_LONG'
}

export type UpdateClubManagerParams = {
  displayHost?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  profileDescription?: InputMaybe<Scalars['String']['input']>;
  profileHeadline?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  profileMediaImageId?: InputMaybe<Scalars['ID']['input']>;
  profileName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubManagerResult = {
  __typename?: 'UpdateClubManagerResult';
  clubManager?: Maybe<ClubManager>;
  success: Scalars['Boolean']['output'];
};

export type UpdateClubMemberParams = {
  clubID?: InputMaybe<Scalars['ID']['input']>;
  emailMarketingOptIn: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateClubMemberResult = {
  __typename?: 'UpdateClubMemberResult';
  clubMember?: Maybe<ClubMember>;
  success: Scalars['Boolean']['output'];
};

export type UpdateClubParams = {
  ages?: InputMaybe<Array<Ages>>;
  askForEmailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  bannerMediaImageId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventMoments?: InputMaybe<Array<ClubEventMomentInput>>;
  faqs?: InputMaybe<Array<ClubFaqInput>>;
  galleryImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  genders?: InputMaybe<Array<Gender>>;
  group?: InputMaybe<ClubGroup>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  insights?: InputMaybe<Array<ClubInsightInput>>;
  joinQuestions?: InputMaybe<Array<ClubJoinQuestionInput>>;
  locationCityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationSuburbId?: InputMaybe<Scalars['ID']['input']>;
  managers?: InputMaybe<Array<Scalars['ID']['input']>>;
  meetingDays?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileDescription?: InputMaybe<Scalars['String']['input']>;
  profileHeadline?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  profileTitle?: InputMaybe<Scalars['String']['input']>;
  socials?: InputMaybe<Array<ClubSocialInput>>;
  ticketSellingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<ClubVisibility>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubResult = {
  __typename?: 'UpdateClubResult';
  club?: Maybe<Club>;
  errors?: Maybe<Array<UpdateClubError>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCommentError = {
  __typename?: 'UpdateCommentError';
  message?: Maybe<Scalars['String']['output']>;
  type: UpdateCommentErrors;
};

export enum UpdateCommentErrors {
  CommentNotFound = 'COMMENT_NOT_FOUND',
  ContentTooLong = 'CONTENT_TOO_LONG',
  NotAuthorized = 'NOT_AUTHORIZED'
}

export type UpdateCommentParams = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateCommentResult = {
  __typename?: 'UpdateCommentResult';
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<UpdateCommentError>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCreationCanvasContextInput = {
  context: CreationCanvasContextInput;
  requestID: Scalars['ID']['input'];
  sessionID: Scalars['ID']['input'];
};

export type UpdateDiscountCodeError = {
  __typename?: 'UpdateDiscountCodeError';
  message?: Maybe<Scalars['String']['output']>;
  type: UpdateDiscountCodeErrors;
};

export enum UpdateDiscountCodeErrors {
  CodeAlreadyExists = 'CODE_ALREADY_EXISTS',
  DiscountCodeNotFound = 'DISCOUNT_CODE_NOT_FOUND',
  InvalidValue = 'INVALID_VALUE',
  Unauthorized = 'UNAUTHORIZED'
}

export type UpdateDiscountCodeParams = {
  code?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDiscountCodeResult = {
  __typename?: 'UpdateDiscountCodeResult';
  discountCode?: Maybe<DiscountCode>;
  errors?: Maybe<Array<UpdateDiscountCodeError>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEntityEventParams = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateEntityEventResult = {
  __typename?: 'UpdateEntityEventResult';
  entityEvent: EntityEvent;
  success: Scalars['Boolean']['output'];
};

export type UpdateEventAttendeeParams = {
  calendarEventId?: InputMaybe<Scalars['String']['input']>;
  eventID?: InputMaybe<Scalars['ID']['input']>;
  form?: InputMaybe<Array<EventFormInputAnswer>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  onTheWay?: InputMaybe<Scalars['Boolean']['input']>;
  reconfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventAttendeeResult = {
  __typename?: 'UpdateEventAttendeeResult';
  attendee: EventAttendee;
  success: Scalars['Boolean']['output'];
};

export type UpdateEventError = {
  __typename?: 'UpdateEventError';
  message?: Maybe<Scalars['String']['output']>;
  type: UpdateEventErrors;
};

export enum UpdateEventErrors {
  CapacityBelowAttendeeCount = 'CAPACITY_BELOW_ATTENDEE_COUNT',
  CoverCostDescriptionRequired = 'COVER_COST_DESCRIPTION_REQUIRED',
  CoverCostPerPersonCentsInvalid = 'COVER_COST_PER_PERSON_CENTS_INVALID',
  CoverCostRequired = 'COVER_COST_REQUIRED',
  CoverCostRequiredByInvalid = 'COVER_COST_REQUIRED_BY_INVALID',
  CoverCostRequiredParticipantsInvalid = 'COVER_COST_REQUIRED_PARTICIPANTS_INVALID',
  CoverCostSettingsLocked = 'COVER_COST_SETTINGS_LOCKED',
  DecorativeLetters = 'DECORATIVE_LETTERS',
  DescriptionTooLong = 'DESCRIPTION_TOO_LONG',
  GooglePlaceNotFound = 'GOOGLE_PLACE_NOT_FOUND',
  InvalidGooglePlaceId = 'INVALID_GOOGLE_PLACE_ID',
  InvalidPlaceId = 'INVALID_PLACE_ID',
  InvalidTicketVariations = 'INVALID_TICKET_VARIATIONS',
  LocationCityResolutionFailed = 'LOCATION_CITY_RESOLUTION_FAILED',
  LocationOutsideSupportedCity = 'LOCATION_OUTSIDE_SUPPORTED_CITY',
  MenuSampleTooLong = 'MENU_SAMPLE_TOO_LONG',
  MonetizationPlanTypeLocked = 'MONETIZATION_PLAN_TYPE_LOCKED',
  StartDateInPast = 'START_DATE_IN_PAST',
  TicketSalesApprovalRequestInvalid = 'TICKET_SALES_APPROVAL_REQUEST_INVALID',
  TicketSalesApprovalRequestNotFound = 'TICKET_SALES_APPROVAL_REQUEST_NOT_FOUND',
  TicketSalesApprovalRequired = 'TICKET_SALES_APPROVAL_REQUIRED',
  TitleTooLong = 'TITLE_TOO_LONG',
  TooManyBannerImages = 'TOO_MANY_BANNER_IMAGES'
}

export type UpdateEventHostParams = {
  calendarEventId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  onTheWay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventHostResult = {
  __typename?: 'UpdateEventHostResult';
  host?: Maybe<Host>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEventParams = {
  absorbFees?: InputMaybe<Scalars['Boolean']['input']>;
  ages?: InputMaybe<Array<Ages>>;
  allowInvites?: InputMaybe<Scalars['Boolean']['input']>;
  approveGuests?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  bannerImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional free-text note explaining the cancellation. Only meaningful
   * when `canceled` is being flipped to true.
   */
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reason the host gave for cancelling the plan. Only meaningful when
   * `canceled` is being flipped from false to true on this update.
   */
  cancellationReason?: InputMaybe<EventCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  cohostsUserIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  coverCost?: InputMaybe<EventCoverCostParams>;
  description?: InputMaybe<Scalars['String']['input']>;
  earlyBirdDiscount?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  form?: InputMaybe<Array<CreateEventFormInput>>;
  genders?: InputMaybe<Array<Gender>>;
  /** Resolve a newly selected venue from Google Places. */
  googlePlaceID?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  hideFromNonMatching?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use placeID or googlePlaceID */
  location?: InputMaybe<LocationParams>;
  menuSample?: InputMaybe<Scalars['String']['input']>;
  /** Reuse an existing Butter place. Omit both place fields to preserve the current venue. */
  placeID?: InputMaybe<Scalars['ID']['input']>;
  publicPreciseLocation?: InputMaybe<Scalars['Boolean']['input']>;
  publishAt?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  structure?: InputMaybe<EventStructure>;
  ticketInclusions?: InputMaybe<Array<CreateEventTicketInclusionInput>>;
  ticketPrice?: InputMaybe<Scalars['Int']['input']>;
  ticketSalesApprovalRequestID?: InputMaybe<Scalars['ID']['input']>;
  ticketVariations?: InputMaybe<Array<EventTicketVariationInput>>;
  tippingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<EventTone>;
  type?: InputMaybe<EventType>;
  waitlists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventRequestParams = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  claimSpot?: InputMaybe<Scalars['Boolean']['input']>;
  coverCostContributionIntentID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventRequestResult = {
  __typename?: 'UpdateEventRequestResult';
  error?: Maybe<Scalars['String']['output']>;
  request?: Maybe<EventRequest>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEventResult = {
  __typename?: 'UpdateEventResult';
  errors?: Maybe<Array<UpdateEventError>>;
  event?: Maybe<Event>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEventReviewStepInput = {
  reviewId: Scalars['ID']['input'];
  step: ReviewStep;
};

export type UpdateEventReviewStepResult = {
  __typename?: 'UpdateEventReviewStepResult';
  error?: Maybe<EventReviewError>;
  eventReview?: Maybe<EventReview>;
};

export type UpdateIdeaInterestParams = {
  days: Array<IdeaInterestDay>;
  id: Scalars['ID']['input'];
  times: Array<IdeaInterestTime>;
};

export type UpdateIdeaInterestResult = {
  __typename?: 'UpdateIdeaInterestResult';
  interest: IdeaInterest;
  success: Scalars['Boolean']['output'];
};

export type UpdateIdeaParams = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIdeaResult = {
  __typename?: 'UpdateIdeaResult';
  idea?: Maybe<Idea>;
  success: Scalars['Boolean']['output'];
};

export type UpdateNotificationSettingInput = {
  category: NotificationSettingCategory;
  enabled: Scalars['Boolean']['input'];
  scope: NotificationSettingScope;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNotificationSettingResult = {
  __typename?: 'UpdateNotificationSettingResult';
  error?: Maybe<NotificationSettingError>;
  settings?: Maybe<NotificationSettings>;
};

export type UpdatePollParams = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePollResult = {
  __typename?: 'UpdatePollResult';
  poll?: Maybe<Poll>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePostError = {
  __typename?: 'UpdatePostError';
  message?: Maybe<Scalars['String']['output']>;
  type: UpdatePostErrors;
};

export enum UpdatePostErrors {
  ContentTooLong = 'CONTENT_TOO_LONG',
  NotAuthorized = 'NOT_AUTHORIZED',
  PostNotFound = 'POST_NOT_FOUND'
}

export type UpdatePostParams = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images: Array<Scalars['String']['input']>;
  poll?: InputMaybe<CreatePostPollParams>;
};

export type UpdatePostResult = {
  __typename?: 'UpdatePostResult';
  errors?: Maybe<Array<UpdatePostError>>;
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserDetail = {
  answer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  subtype: UserDetailSubtype;
  type: UserDetailType;
  visible: Scalars['Boolean']['input'];
};

export type UpdateUserHighlight = {
  caption: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateUserParams = {
  age?: InputMaybe<Scalars['String']['input']>;
  alcohol?: InputMaybe<Scalars['String']['input']>;
  /** Optional long-form “About me” content; see User.bio. */
  bio?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** Optional unverified delivery address. Omission leaves the current value unchanged. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<UpdateUserDetail>>;
  deviceTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['JSON']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  /** Short product-facing “Bio” content; see User.headline. */
  headline?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<UpdateUserHighlight>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastTimeAppUsed?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<UserLocationInput>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  meetPeopleLike?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  othersDescribeMe?: InputMaybe<Array<Scalars['String']['input']>>;
  pets?: InputMaybe<Scalars['String']['input']>;
  profileGalleryUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  socials?: InputMaybe<Array<UpdateUserSocial>>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserSocial = {
  handle: Scalars['String']['input'];
  type: SocialType;
};

export type UpdateWaitlistLocationRequestPushTokensInput = {
  pushNotificationTokens: Array<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

export type UpdateWaitlistLocationRequestPushTokensResult = {
  __typename?: 'UpdateWaitlistLocationRequestPushTokensResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateWaitlistUserPushTokensInput = {
  pushNotificationTokens: Array<Scalars['String']['input']>;
  waitlistUserId: Scalars['ID']['input'];
};

export type UpdateWaitlistUserPushTokensResult = {
  __typename?: 'UpdateWaitlistUserPushTokensResult';
  success: Scalars['Boolean']['output'];
};

export type UploadImageParams = {
  file: Scalars['Upload']['input'];
  variant?: InputMaybe<ImageVariant>;
};

export type UploadImageResult = {
  __typename?: 'UploadImageResult';
  imageId: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export type UpsertUserDeviceInput = {
  /** Native app version (e.g. "1.42.0"). */
  appVersion: Scalars['String']['input'];
  /**
   * Capability strings the client install supports. Used by the backend to gate
   * notifications and other actions to clients that can handle them.
   */
  capabilities: Array<Scalars['String']['input']>;
  /**
   * Stable per-install identifier generated by the client (SecureStore-backed UUID).
   * Same value sent at signup and on every app open.
   */
  deviceId: Scalars['String']['input'];
  platform: DevicePlatform;
  /**
   * Observed OS notification permission. True includes iOS provisional delivery;
   * false means a measured non-grant. Omitted or null preserves any prior report.
   */
  pushPermissionGranted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * FCM/APNS push token reported by this device. Token availability does not
   * establish OS notification permission.
   */
  pushToken?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUserDeviceResult = {
  __typename?: 'UpsertUserDeviceResult';
  userDevice?: Maybe<UserDevice>;
};

export type User = {
  __typename?: 'User';
  aboutToMeet: Scalars['Boolean']['output'];
  age: Scalars['Int']['output'];
  alcohol: Scalars['String']['output'];
  anonymous: Scalars['Boolean']['output'];
  authID?: Maybe<Scalars['ID']['output']>;
  /**
   * Optional long-form profile description presented as “About me”. Older setup
   * flows also stored their required short Bio here, so clients must use the
   * shared profile-text compatibility rules during the transition.
   */
  bio: Scalars['String']['output'];
  blockedUserEntries: Array<BlockedUserEntry>;
  blockedUsers: Array<Maybe<User>>;
  canSellTickets: Scalars['Boolean']['output'];
  children: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  /** Unverified delivery address, visible under the same privacy rules as email. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  creator: Scalars['Boolean']['output'];
  /** @deprecated use guestStats */
  currentStats?: Maybe<UserStats>;
  details: Array<UserDetail>;
  deviceTokens: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  events: EventsConnection;
  eventsAttendedSummary: EventsAttendedSummary;
  firstName: Scalars['String']['output'];
  flags: Scalars['JSON']['output'];
  followers: FollowersConnection;
  followersCount: Scalars['Int']['output'];
  following: FollowingConnection;
  followingCount: Scalars['Int']['output'];
  foundingMember: Scalars['Boolean']['output'];
  friends?: Maybe<FriendsConnection>;
  gender: Scalars['String']['output'];
  goldHost: Scalars['Boolean']['output'];
  group: Scalars['String']['output'];
  guestRewards: GuestRewardConnection;
  /**
   * Per-guest stats. Same shape: counters global, ranking/reliabilityStatus scoped
   * to the user's home city.
   */
  guestStats: GuestStats;
  hasMet: Scalars['Boolean']['output'];
  /**
   * Short profile summary presented in the product as “Bio”. The historical
   * GraphQL field name is retained for backwards compatibility.
   */
  headline: Scalars['String']['output'];
  highlights: Array<UserHighlight>;
  hostRewards: HostRewardConnection;
  /**
   * Per-host stats. Counters come from the global ledger; cityRanking and
   * reliabilityStatus are scoped to the user's home city via the per-city ledger.
   * For event-context reliability, prefer `Host.hostStats` on the event's host row
   * — it scopes to the event's city instead of the user's home.
   */
  hostStats: HostStats;
  id: Scalars['ID']['output'];
  inWaitlist: Scalars['Boolean']['output'];
  industry: Scalars['String']['output'];
  instagram: Scalars['String']['output'];
  interests: Array<Scalars['String']['output']>;
  /** Whether the user has at least one registered app device. */
  isAppUser: Scalars['Boolean']['output'];
  isFollowedBy: Scalars['Boolean']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isFriend: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated No replacement — rewards earned during a plan review surface via EventReview.earnedGuestRewards. Always returns null. */
  latestReward?: Maybe<Reward>;
  /** Last stored device location, otherwise the stored IP estimate. Only visible to this user. */
  location?: Maybe<UserLocation>;
  locationCity?: Maybe<LocationCity>;
  meetPeopleLike: Array<Scalars['String']['output']>;
  met?: Maybe<MetConnection>;
  mutualFriendsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  onboarded: Scalars['Boolean']['output'];
  othersDescribeMe: Array<Scalars['String']['output']>;
  /**
   * The chat room for a pending plan request that the current user sent to this user.
   * Returns null if no pending plan request exists.
   */
  pendingPlanRequestRoom?: Maybe<ChatRoomV2>;
  pendingTicketSalesApprovalRequest?: Maybe<TicketSalesApprovalRequest>;
  pets: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileGalleryUrls: Array<Scalars['String']['output']>;
  profileImageUrl: Scalars['String']['output'];
  pronouns: Scalars['String']['output'];
  /** A pending friend request that this user sent to the current user (can be accepted/declined). */
  receivedFriendRequest?: Maybe<FriendRequest>;
  /** @deprecated Use guestRewards / hostRewards. Always returns an empty connection. */
  rewards: UserRewardConnection;
  roles: Array<UserRole>;
  /** A pending friend request that the current user sent to this user (can be cancelled). */
  sentFriendRequest?: Maybe<FriendRequest>;
  socials: Array<Social>;
  suburb: Scalars['String']['output'];
  tiktok: Scalars['String']['output'];
  timesMetCount: Scalars['Int']['output'];
};


export type UserEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type UserFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type UserFollowingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type UserFriendsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  params?: InputMaybe<FriendsParams>;
};


export type UserGuestRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type UserHostRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type UserMetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type UserRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type UserBlockError = {
  __typename?: 'UserBlockError';
  message: Scalars['String']['output'];
  type: UserBlockErrorType;
};

export enum UserBlockErrorType {
  InvalidUserId = 'INVALID_USER_ID'
}

export type UserDetail = {
  __typename?: 'UserDetail';
  answer: Scalars['String']['output'];
  claps: ClapSummary;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  subtype: UserDetailSubtype;
  type: UserDetailType;
  updatedAt: Scalars['Date']['output'];
  userID: Scalars['ID']['output'];
  visible: Scalars['Boolean']['output'];
};

export enum UserDetailSubtype {
  InsightsBestBookIveRead = 'INSIGHTS_BEST_BOOK_IVE_READ',
  InsightsCartoonCharacter = 'INSIGHTS_CARTOON_CHARACTER',
  InsightsCocktail = 'INSIGHTS_COCKTAIL',
  InsightsDrinkOrder = 'INSIGHTS_DRINK_ORDER',
  InsightsFavoriteMusic = 'INSIGHTS_FAVORITE_MUSIC',
  InsightsFavoriteNeighborhoodSpot = 'INSIGHTS_FAVORITE_NEIGHBORHOOD_SPOT',
  InsightsHotTake = 'INSIGHTS_HOT_TAKE',
  InsightsLastMeal = 'INSIGHTS_LAST_MEAL',
  InsightsRedFlag = 'INSIGHTS_RED_FLAG',
  InsightsSongOutTheDoor = 'INSIGHTS_SONG_OUT_THE_DOOR',
  MeetPeopleAmbitiousNotCompetitive = 'MEET_PEOPLE_AMBITIOUS_NOT_COMPETITIVE',
  MeetPeopleBestSnacksShared = 'MEET_PEOPLE_BEST_SNACKS_SHARED',
  MeetPeopleBigIdeaBuild = 'MEET_PEOPLE_BIG_IDEA_BUILD',
  MeetPeopleCalmToChaos = 'MEET_PEOPLE_CALM_TO_CHAOS',
  MeetPeopleCookOverClub = 'MEET_PEOPLE_COOK_OVER_CLUB',
  MeetPeopleDeeperConversation = 'MEET_PEOPLE_DEEPER_CONVERSATION',
  MeetPeopleDontNeedAlc = 'MEET_PEOPLE_DONT_NEED_ALC',
  MeetPeopleEarlyOverLateNights = 'MEET_PEOPLE_EARLY_OVER_LATE_NIGHTS',
  MeetPeopleFiguringItOut = 'MEET_PEOPLE_FIGURING_IT_OUT',
  MeetPeopleHaveMovedHere = 'MEET_PEOPLE_HAVE_MOVED_HERE',
  MeetPeopleLastMinutePlan = 'MEET_PEOPLE_LAST_MINUTE_PLAN',
  MeetPeopleLaugh = 'MEET_PEOPLE_LAUGH',
  MeetPeopleLaughNoPunchline = 'MEET_PEOPLE_LAUGH_NO_PUNCHLINE',
  MeetPeopleLittleWeird = 'MEET_PEOPLE_LITTLE_WEIRD',
  MeetPeopleLiveOffline = 'MEET_PEOPLE_LIVE_OFFLINE',
  MeetPeopleMeaningEveryday = 'MEET_PEOPLE_MEANING_EVERYDAY',
  MeetPeopleMundaneSpecial = 'MEET_PEOPLE_MUNDANE_SPECIAL',
  MeetPeopleNotSerious = 'MEET_PEOPLE_NOT_SERIOUS',
  MeetPeopleParenthood = 'MEET_PEOPLE_PARENTHOOD',
  MeetPeopleSeriousAndSilly = 'MEET_PEOPLE_SERIOUS_AND_SILLY',
  MeetPeopleSharedOutlook = 'MEET_PEOPLE_SHARED_OUTLOOK',
  MeetPeopleShowUpWithIntention = 'MEET_PEOPLE_SHOW_UP_WITH_INTENTION',
  MeetPeopleTalkHours = 'MEET_PEOPLE_TALK_HOURS',
  MeetPeopleUnapologeticallyThemself = 'MEET_PEOPLE_UNAPOLOGETICALLY_THEMSELF',
  MeetPeopleValueQualityOverQuantity = 'MEET_PEOPLE_VALUE_QUALITY_OVER_QUANTITY',
  MeetPeopleVulnerabilityIsStrength = 'MEET_PEOPLE_VULNERABILITY_IS_STRENGTH',
  MeetPeopleWeekendsOpen = 'MEET_PEOPLE_WEEKENDS_OPEN',
  WhatImLikeConnectionGoal = 'WHAT_IM_LIKE_CONNECTION_GOAL',
  WhatImLikeConvoStarter = 'WHAT_IM_LIKE_CONVO_STARTER',
  WhatImLikeHobbyToTry = 'WHAT_IM_LIKE_HOBBY_TO_TRY',
  WhatImLikePersonality = 'WHAT_IM_LIKE_PERSONALITY',
  WhatImLikePlanIllJoin = 'WHAT_IM_LIKE_PLAN_ILL_JOIN',
  WhatImLikeRoleAtDinner = 'WHAT_IM_LIKE_ROLE_AT_DINNER'
}

export enum UserDetailType {
  Insights = 'INSIGHTS',
  MeetPeople = 'MEET_PEOPLE',
  WhatImLike = 'WHAT_IM_LIKE'
}

export type UserDevice = {
  __typename?: 'UserDevice';
  appVersion?: Maybe<Scalars['String']['output']>;
  capabilities: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSeenAt?: Maybe<Scalars['Date']['output']>;
  platform?: Maybe<DevicePlatform>;
  /**
   * Last reported OS notification permission for this device.
   * Null means no successful permission report is retained.
   */
  pushPermissionGranted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type UserFriendEdge = {
  __typename?: 'UserFriendEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserHighlight = {
  __typename?: 'UserHighlight';
  caption: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
};

export type UserLocation = {
  __typename?: 'UserLocation';
  coordinates: LocationCoordinates;
  source: UserLocationSource;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/**
 * Location input reusable across queries. If lat/lng not provided, falls back
 * to Cloudflare geolocation headers persisted on the user record.
 */
export type UserLocationInput = {
  /** User's current latitude */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** User's current longitude */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** IANA timezone (e.g. "Australia/Melbourne") */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum UserLocationSource {
  Ip = 'IP',
  Precise = 'PRECISE'
}

export type UserParams = {
  authID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserReward = {
  __typename?: 'UserReward';
  earnedAt: Scalars['Date']['output'];
  /** @deprecated Legacy compatibility only. UserReward lists are empty; use role-scoped reward fields. */
  event: Event;
  id: Scalars['ID']['output'];
  reward: Reward;
};

export type UserRewardConnection = {
  __typename?: 'UserRewardConnection';
  edges: Array<UserRewardEdge>;
  pageInfo: PageInfo;
};

export type UserRewardEdge = {
  __typename?: 'UserRewardEdge';
  cursor: Scalars['String']['output'];
  node: UserReward;
};

export enum UserRole {
  SuperUser = 'SUPER_USER'
}

export type UserStats = {
  __typename?: 'UserStats';
  cityName?: Maybe<Scalars['String']['output']>;
  cityRanking?: Maybe<Scalars['Int']['output']>;
  currentEventStreak: Scalars['Int']['output'];
  longestEventStreak: Scalars['Int']['output'];
  totalFriendsMade: Scalars['Int']['output'];
  totalHoursOffline: Scalars['Float']['output'];
  totalPeopleMet: Scalars['Int']['output'];
  totalTipEarningsCents: Scalars['Int']['output'];
};

export type UsersParams = {
  authIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ValidateDiscountCodeParams = {
  code: Scalars['String']['input'];
  eventID: Scalars['ID']['input'];
};

export type VerifyPhoneNumberParams = {
  firebaseIdToken: Scalars['String']['input'];
};

export type VerifyPhoneNumberResult = {
  __typename?: 'VerifyPhoneNumberResult';
  error?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VerifyPhoneVerificationCodeError = {
  __typename?: 'VerifyPhoneVerificationCodeError';
  code: VerifyPhoneVerificationCodeErrorCode;
  message: Scalars['String']['output'];
};

export enum VerifyPhoneVerificationCodeErrorCode {
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  InvalidOrExpiredCode = 'INVALID_OR_EXPIRED_CODE',
  PhoneAlreadyLinked = 'PHONE_ALREADY_LINKED',
  RateLimited = 'RATE_LIMITED',
  TooManyChecks = 'TOO_MANY_CHECKS'
}

export type VerifyPhoneVerificationCodeParams = {
  code: Scalars['String']['input'];
  /** Do not provision an identity or account when the number is unknown. */
  loginOnly?: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type VerifyPhoneVerificationCodeResult = {
  __typename?: 'VerifyPhoneVerificationCodeResult';
  error?: Maybe<VerifyPhoneVerificationCodeError>;
  token?: Maybe<Scalars['String']['output']>;
  /** The verified account — lets clients decide what to do next from the profile state. */
  user?: Maybe<User>;
};

export type Waitlist = {
  __typename?: 'Waitlist';
  city?: Maybe<Scalars['String']['output']>;
  currentUserCount: Scalars['Int']['output'];
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use waitlistDistrictId */
  locationCityDistrictId?: Maybe<Scalars['ID']['output']>;
  locationCityId?: Maybe<Scalars['ID']['output']>;
  locked: Scalars['Boolean']['output'];
  targetUserCount: Scalars['Int']['output'];
  waitlistDistrictId?: Maybe<Scalars['ID']['output']>;
};

export type WaitlistDistrict = {
  __typename?: 'WaitlistDistrict';
  boundaryGeojson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isPopular: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  locationCity: LocationCity;
  locationCityId: Scalars['ID']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  primaryName: Scalars['String']['output'];
  secondaryNames: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type WaitlistDistrictDistance = {
  __typename?: 'WaitlistDistrictDistance';
  distanceKm: Scalars['Float']['output'];
  district: WaitlistDistrict;
};

export type WaitlistLocationRequest = {
  __typename?: 'WaitlistLocationRequest';
  createdAt: Scalars['Date']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  locationCityId?: Maybe<Scalars['ID']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use nearestWaitlistDistrictId */
  nearestLocationCityDistrictId?: Maybe<Scalars['ID']['output']>;
  nearestWaitlistDistrictId?: Maybe<Scalars['ID']['output']>;
  postcode: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  upgradedAt?: Maybe<Scalars['Date']['output']>;
  upgradedWaitlistUserId?: Maybe<Scalars['ID']['output']>;
};

export type WaitlistLocationRequestStatus = {
  __typename?: 'WaitlistLocationRequestStatus';
  request?: Maybe<WaitlistLocationRequest>;
  upgraded: Scalars['Boolean']['output'];
  waitlistUserStatus?: Maybe<WaitlistUserStatus>;
};

export type WaitlistLocationSearchResult = {
  __typename?: 'WaitlistLocationSearchResult';
  /** @deprecated Use waitlistDistrict */
  locationCityDistrict?: Maybe<LocationCityDistrict>;
  postcode?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: WaitlistLocationSearchResultType;
  unsupportedLocality?: Maybe<UnsupportedWaitlistLocation>;
  waitlistDistrict?: Maybe<WaitlistDistrict>;
};

export type WaitlistLocationSearchResultSet = {
  __typename?: 'WaitlistLocationSearchResultSet';
  /** @deprecated Use closestWaitlistDistrict */
  closestLocationCityDistrict?: Maybe<LocationCityDistrict>;
  closestWaitlistDistrict?: Maybe<WaitlistDistrict>;
  closestWaitlistDistrictDistances: Array<WaitlistDistrictDistance>;
  closestWaitlistDistricts: Array<WaitlistDistrict>;
  results: Array<WaitlistLocationSearchResult>;
};

export enum WaitlistLocationSearchResultType {
  UnsupportedLocality = 'UNSUPPORTED_LOCALITY',
  WaitlistDistrict = 'WAITLIST_DISTRICT'
}

export type WaitlistRace = {
  __typename?: 'WaitlistRace';
  entries: Array<WaitlistRaceEntry>;
  mode: WaitlistRaceMode;
};

export type WaitlistRaceEntry = {
  __typename?: 'WaitlistRaceEntry';
  currentUserCount: Scalars['Int']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUserEntry: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  targetUserCount: Scalars['Int']['output'];
  waitlistDistrictId?: Maybe<Scalars['ID']['output']>;
};

export type WaitlistRaceInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  locationCityDistrictId?: InputMaybe<Scalars['ID']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  waitlistDistrictId?: InputMaybe<Scalars['ID']['input']>;
  waitlistId?: InputMaybe<Scalars['ID']['input']>;
};

export enum WaitlistRaceMode {
  District = 'DISTRICT',
  Group = 'GROUP'
}

export type WaitlistReferralInput = {
  clubId?: InputMaybe<Scalars['ID']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type WaitlistUserStatus = {
  __typename?: 'WaitlistUserStatus';
  city?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  isRegistered: Scalars['Boolean']['output'];
  isUnlocked: Scalars['Boolean']['output'];
  isWaitlistUnlocked: Scalars['Boolean']['output'];
  /** @deprecated Use waitlistDistrictId */
  locationCityDistrictId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use waitlistDistrictName */
  locationCityDistrictName?: Maybe<Scalars['String']['output']>;
  locationCityId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  referralCount: Scalars['Int']['output'];
  referralRank?: Maybe<Scalars['Int']['output']>;
  waitlistDistrictId?: Maybe<Scalars['ID']['output']>;
  waitlistDistrictName?: Maybe<Scalars['String']['output']>;
  waitlistDistrictPrimaryName?: Maybe<Scalars['String']['output']>;
  waitlistDistrictSecondaryNames: Array<Scalars['String']['output']>;
  waitlistId?: Maybe<Scalars['ID']['output']>;
  waitlistUserId?: Maybe<Scalars['ID']['output']>;
};

export type WaitlistsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  locationCityDistrictId?: InputMaybe<Scalars['ID']['input']>;
  locationCityId?: InputMaybe<Scalars['ID']['input']>;
  waitlistDistrictId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  available: Scalars['Int']['output'];
  currency: WalletCurrency;
  earnings: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  payoutSetup: WalletPayoutSetup;
  pendingIncoming: Scalars['Int']['output'];
  pendingOutgoing: Scalars['Int']['output'];
  stripeConnectLinkUrl?: Maybe<Scalars['String']['output']>;
  stripeConnectSetup: Scalars['Boolean']['output'];
};

export type WalletClub = {
  __typename?: 'WalletClub';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum WalletCurrency {
  Aud = 'AUD',
  Unknown = 'UNKNOWN',
  Usd = 'USD'
}

export type WalletGlobalPayoutAttempt = {
  __typename?: 'WalletGlobalPayoutAttempt';
  actualStripeFeeCents?: Maybe<Scalars['Int']['output']>;
  expectedStripeFeeCents: Scalars['Int']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  fundingStatus: WalletGlobalPayoutFundingStatus;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: WalletGlobalPayoutStatus;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  walletRecredited: Scalars['Boolean']['output'];
};

export enum WalletGlobalPayoutFundingStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Posted = 'POSTED',
  Unknown = 'UNKNOWN',
  Void = 'VOID'
}

export enum WalletGlobalPayoutStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Posted = 'POSTED',
  Processing = 'PROCESSING',
  Returned = 'RETURNED',
  Unknown = 'UNKNOWN'
}

export type WalletIntent = {
  __typename?: 'WalletIntent';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  manualAdjustment?: Maybe<WalletIntentManualAdjustment>;
  state: WalletIntentState;
  type: WalletIntentType;
  updatedAt: Scalars['Date']['output'];
  walletID: Scalars['ID']['output'];
  walletIntentButterPayout?: Maybe<WalletIntentButterPayout>;
  walletIntentEventCoverCostReceived?: Maybe<WalletIntentEventCoverCostReceived>;
  walletIntentEventCoverCostReceivedRefund?: Maybe<WalletIntentEventCoverCostReceivedRefund>;
  walletIntentEventCoverCostSent?: Maybe<WalletIntentEventCoverCostSent>;
  walletIntentEventCoverCostSentRefund?: Maybe<WalletIntentEventCoverCostSentRefund>;
  walletIntentEventTicketPurchase?: Maybe<WalletIntentEventTicketPurchase>;
  walletIntentEventTicketPurchaseRefund?: Maybe<WalletIntentEventTicketPurchaseRefund>;
  walletIntentEventTicketSale?: Maybe<WalletIntentEventTicketSale>;
  walletIntentEventTicketSaleRefund?: Maybe<WalletIntentEventTicketSaleRefund>;
  walletIntentPayout?: Maybe<WalletIntentPayout>;
  walletIntentTipReceived?: Maybe<WalletIntentTipReceived>;
  walletIntentTipSent?: Maybe<WalletIntentTipSent>;
  walletIntentTopUp?: Maybe<WalletIntentTopUp>;
};

export type WalletIntentButterPayout = {
  __typename?: 'WalletIntentButterPayout';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  type: WalletIntentButterPayoutType;
  walletIntentID: Scalars['ID']['output'];
};

export enum WalletIntentButterPayoutType {
  PostAndEarn = 'POST_AND_EARN',
  Unknown = 'UNKNOWN'
}

export type WalletIntentConnection = {
  __typename?: 'WalletIntentConnection';
  edges: Array<WalletIntentEdge>;
  pageInfo: PageInfo;
};

export type WalletIntentEdge = {
  __typename?: 'WalletIntentEdge';
  cursor: Scalars['String']['output'];
  node: WalletIntent;
};

export type WalletIntentEventCoverCostReceived = {
  __typename?: 'WalletIntentEventCoverCostReceived';
  coverCostCents: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  purchaserUser?: Maybe<User>;
  purchaserUserID: Scalars['ID']['output'];
  recipientWalletID: Scalars['ID']['output'];
  walletIntentEventCoverCostSentID: Scalars['ID']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentEventCoverCostReceivedRefund = {
  __typename?: 'WalletIntentEventCoverCostReceivedRefund';
  coverCostCentsRefunded: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  initiatedByUserID?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  purchaserUser?: Maybe<User>;
  purchaserUserID: Scalars['ID']['output'];
  reason: WalletIntentEventCoverCostRefundReason;
  walletIntentEventCoverCostReceivedID: Scalars['ID']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export enum WalletIntentEventCoverCostRefundReason {
  AdminInitiated = 'ADMIN_INITIATED',
  AttendeeLeftBeforeConfirmation = 'ATTENDEE_LEFT_BEFORE_CONFIRMATION',
  DeadlineNotMet = 'DEADLINE_NOT_MET',
  EventCancelled = 'EVENT_CANCELLED',
  HostRemoved = 'HOST_REMOVED',
  Other = 'OTHER',
  RequestRejected = 'REQUEST_REJECTED',
  Unknown = 'UNKNOWN'
}

export type WalletIntentEventCoverCostSent = {
  __typename?: 'WalletIntentEventCoverCostSent';
  authorizationExpiresAt?: Maybe<Scalars['Date']['output']>;
  butterFeeCents: Scalars['Int']['output'];
  coverCostCents: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  paymentMethod: CoverCostPaymentMethod;
  paymentState?: Maybe<CoverCostPaymentState>;
  purchaserUser?: Maybe<User>;
  purchaserUserID: Scalars['ID']['output'];
  totalCoverCostCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentEventCoverCostSentRefund = {
  __typename?: 'WalletIntentEventCoverCostSentRefund';
  butterFeeCentsRefunded: Scalars['Int']['output'];
  coverCostCentsRefunded: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  initiatedByUserID?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod: CoverCostPaymentMethod;
  purchaserUser?: Maybe<User>;
  purchaserUserID: Scalars['ID']['output'];
  reason: WalletIntentEventCoverCostRefundReason;
  refundStatus: CoverCostRefundStatus;
  totalCoverCostCentsRefunded: Scalars['Int']['output'];
  walletIntentEventCoverCostSentID: Scalars['ID']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentEventTicketPurchase = {
  __typename?: 'WalletIntentEventTicketPurchase';
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  eventRequestID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod: EventTicketPaymentMethod;
  state: WalletIntentState;
  totalCostCents: Scalars['Int']['output'];
  variation?: Maybe<EventTicketVariation>;
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentEventTicketPurchaseRefund = {
  __typename?: 'WalletIntentEventTicketPurchaseRefund';
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reason: EventTicketPurchaseRefundReason;
  refundAmountCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentEventTicketSale = {
  __typename?: 'WalletIntentEventTicketSale';
  baseTicketCostCents: Scalars['Int']['output'];
  butterFeeCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  purchasingUser?: Maybe<User>;
  purchasingUserID: Scalars['ID']['output'];
  receiptUrl: Scalars['String']['output'];
  ticketType: EventTicketType;
  totalCostCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentEventTicketSaleRefund = {
  __typename?: 'WalletIntentEventTicketSaleRefund';
  butterFeeRefundedCents: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  originalEarningsCents: Scalars['Int']['output'];
  purchaserUserID: Scalars['ID']['output'];
  reversalAmountCents: Scalars['Int']['output'];
  user?: Maybe<User>;
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentManualAdjustment = {
  __typename?: 'WalletIntentManualAdjustment';
  amountCents: Scalars['Int']['output'];
  note: Scalars['String']['output'];
};

export type WalletIntentParams = {
  walletIntentID: Scalars['ID']['input'];
};

export type WalletIntentPayout = {
  __typename?: 'WalletIntentPayout';
  butterFeeCents: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  globalPayoutAttempt?: Maybe<WalletGlobalPayoutAttempt>;
  id: Scalars['ID']['output'];
  payoutAmountCents: Scalars['Int']['output'];
  stripeFeeCents: Scalars['Int']['output'];
  totalPayoutAmountCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export enum WalletIntentState {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Unknown = 'UNKNOWN'
}

export type WalletIntentTipReceived = {
  __typename?: 'WalletIntentTipReceived';
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  sentFromUser?: Maybe<User>;
  sentFromUserID: Scalars['ID']['output'];
  tipAmountCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentTipSent = {
  __typename?: 'WalletIntentTipSent';
  createdAt: Scalars['Date']['output'];
  event?: Maybe<Event>;
  eventID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  totalTipAmountCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export type WalletIntentTopUp = {
  __typename?: 'WalletIntentTopUp';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  totalTopUpAmountCents: Scalars['Int']['output'];
  walletIntentID: Scalars['ID']['output'];
};

export enum WalletIntentType {
  ButterPayout = 'BUTTER_PAYOUT',
  EventCoverCostReceived = 'EVENT_COVER_COST_RECEIVED',
  EventCoverCostReceivedRefund = 'EVENT_COVER_COST_RECEIVED_REFUND',
  EventCoverCostSent = 'EVENT_COVER_COST_SENT',
  EventCoverCostSentRefund = 'EVENT_COVER_COST_SENT_REFUND',
  EventTicketPurchase = 'EVENT_TICKET_PURCHASE',
  EventTicketPurchaseRefund = 'EVENT_TICKET_PURCHASE_REFUND',
  EventTicketSale = 'EVENT_TICKET_SALE',
  EventTicketSaleRefund = 'EVENT_TICKET_SALE_REFUND',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  Payout = 'PAYOUT',
  TipReceived = 'TIP_RECEIVED',
  TipSent = 'TIP_SENT',
  TopUp = 'TOP_UP',
  Unknown = 'UNKNOWN'
}

export type WalletIntentsParams = {
  state?: InputMaybe<WalletIntentState>;
  states?: InputMaybe<Array<WalletIntentState>>;
  types?: InputMaybe<Array<WalletIntentType>>;
  walletID: Scalars['ID']['input'];
};

export type WalletParams = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<WalletCurrency>;
};

export enum WalletPayoutProvider {
  Connect = 'CONNECT',
  GlobalPayouts = 'GLOBAL_PAYOUTS',
  Unconfigured = 'UNCONFIGURED',
  Unknown = 'UNKNOWN'
}

export type WalletPayoutQuote = {
  __typename?: 'WalletPayoutQuote';
  butterFeeCents: Scalars['Int']['output'];
  currency: WalletCurrency;
  financialAccountFundingCents: Scalars['Int']['output'];
  grossAmountCents: Scalars['Int']['output'];
  provider: WalletPayoutProvider;
  recipientAmountCents: Scalars['Int']['output'];
  stripeFeeCents: Scalars['Int']['output'];
};

export type WalletPayoutQuoteError = {
  __typename?: 'WalletPayoutQuoteError';
  code: WalletPayoutQuoteErrorCode;
  message: Scalars['String']['output'];
};

export enum WalletPayoutQuoteErrorCode {
  BelowMinimum = 'BELOW_MINIMUM',
  SetupRequired = 'SETUP_REQUIRED',
  Unsupported = 'UNSUPPORTED'
}

export type WalletPayoutQuoteParams = {
  amount: Scalars['Int']['input'];
  walletID: Scalars['ID']['input'];
};

export type WalletPayoutQuoteResult = {
  __typename?: 'WalletPayoutQuoteResult';
  error?: Maybe<WalletPayoutQuoteError>;
  quote?: Maybe<WalletPayoutQuote>;
};

export type WalletPayoutSetup = {
  __typename?: 'WalletPayoutSetup';
  provider: WalletPayoutProvider;
  requirements?: Maybe<Scalars['String']['output']>;
  status: WalletPayoutSetupStatus;
};

export enum WalletPayoutSetupStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Ready = 'READY',
  Restricted = 'RESTRICTED',
  Unknown = 'UNKNOWN'
}

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, authID?: string | null, email?: string | null, contactEmail?: string | null, name: string, firstName: string, lastName: string, profileImageUrl: string, age: number, gender: string, bio: string, headline: string, phoneNumber?: string | null, instagram: string, anonymous: boolean, isAppUser: boolean } | null };

export type CheckoutProfileBioQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutProfileBioQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, headline: string, bio: string } | null };

export type CreateEventTicketPurchaseIntentMutationVariables = Exact<{
  params: CreateEventTicketPurchaseIntentParams;
}>;


export type CreateEventTicketPurchaseIntentMutation = { __typename?: 'Mutation', createEventTicketPurchaseIntent: { __typename?: 'CreateEventTicketPurchaseIntentResult', success: boolean, clientSecret?: string | null, walletIntentID?: string | null, processing: boolean, ticketCost?: { __typename?: 'EventTicketCheckoutCost', basePriceCents: number, feeAmountCents: number, stripeFeeCents: number, totalCostCents: number, totalDiscountCents: number, originalTotalCents?: number | null, currency: string } | null, errors?: Array<{ __typename?: 'CreateEventTicketPurchaseError', type: CreateEventTicketPurchaseIntentErrors, message: string }> | null, request?: { __typename?: 'EventRequest', id: string, state: EventRequestState, submittedAt?: any | null, decisionExpiresAt?: any | null, resolutionReason?: EventRequestResolutionReason | null } | null } };

export type GetClubQueryVariables = Exact<{
  params: ClubParams;
}>;


export type GetClubQuery = { __typename?: 'Query', club?: { __typename?: 'Club', id: string, name: string, headline: string, description: string, imageUrl: string, profileTitle: string, profileHeadline: string, profileDescription: string, profileImageUrl: string, premium: boolean, foundingMember: boolean, verified: boolean, meetingDays: Array<string>, plansHosted: number, locationSuburb?: { __typename?: 'LocationSuburb', suburb: string } | null, locationCities: Array<{ __typename?: 'LocationCity', city: string }>, managers: Array<{ __typename?: 'ClubManager', id: string, primary: boolean, displayHost: boolean, profileName?: string | null, profileHeadline?: string | null, profileDescription?: string | null, profileImageUrl?: string | null, user: { __typename?: 'User', id: string, firstName: string, profileImageUrl: string } }>, members: { __typename?: 'ClubMembersConnection', pageInfo: { __typename?: 'PageInfo', totalSize?: number | null }, edges: Array<{ __typename?: 'ClubMemberEdge', cursor: string, node: { __typename?: 'ClubMember', user: { __typename?: 'User', id: string, firstName: string, name: string, profileImageUrl: string } } }> }, events: { __typename?: 'EventsConnection', pageInfo: { __typename?: 'PageInfo', totalSize?: number | null }, edges: Array<{ __typename?: 'EventEdge', cursor: string, node: { __typename?: 'Event', id: string, title: string, startDate: any, bannerImageUrl: string, club?: { __typename?: 'Club', id: string, name: string } | null, location: { __typename?: 'EventPlace', suburb?: string | null, city?: string | null, state?: string | null }, hosts: Array<{ __typename?: 'Host', primary: boolean, user: { __typename?: 'User', id: string, name: string, profileImageUrl: string } }> } }> }, chatRoomsV2: { __typename?: 'ChatRoomV2Connection', edges: Array<{ __typename?: 'ChatRoomV2Edge', cursor: string, node: { __typename?: 'ChatRoomV2', id: string, name: string, description?: string | null, imageUrl?: string | null, memberCount: number } }> }, eventMoments: Array<{ __typename?: 'ClubEventMoment', id: string, imageUrl: string, caption: string }>, insights: Array<{ __typename?: 'ClubInsight', id: string, answer: string, visible: boolean }>, faqs: Array<{ __typename?: 'ClubFAQ', id: string, label: string, answer: string }>, socials: Array<{ __typename?: 'Social', id: string, type: SocialType, url: string, handle: string }> } | null };

export type GetClubEventsEmbedQueryVariables = Exact<{
  params: ClubParams;
  eventsParams: ClubEventsParams;
  first: Scalars['Int']['input'];
}>;


export type GetClubEventsEmbedQuery = { __typename?: 'Query', club?: { __typename?: 'Club', id: string, name: string, events: { __typename?: 'EventsConnection', edges: Array<{ __typename?: 'EventEdge', node: { __typename?: 'Event', id: string, title: string, startDate: any, bannerImageUrl: string, location: { __typename?: 'EventPlace', suburb?: string | null, city?: string | null, state?: string | null }, hosts: Array<{ __typename?: 'Host', primary: boolean, user: { __typename?: 'User', id: string, name: string, profileImageUrl: string } }> } }> } } | null };

export type GetClubForInviteQueryVariables = Exact<{
  params: ClubParams;
}>;


export type GetClubForInviteQuery = { __typename?: 'Query', club?: { __typename?: 'Club', id: string, name: string, headline: string, imageUrl: string, profileTitle: string, profileImageUrl: string, premium: boolean, foundingMember: boolean, visibility: ClubVisibility, locationSuburb?: { __typename?: 'LocationSuburb', suburb: string } | null, locationCities: Array<{ __typename?: 'LocationCity', city: string }>, managers: Array<{ __typename?: 'ClubManager', id: string, primary: boolean, user: { __typename?: 'User', id: string, firstName: string, profileImageUrl: string } }>, members: { __typename?: 'ClubMembersConnection', pageInfo: { __typename?: 'PageInfo', totalSize?: number | null } }, joinQuestions: Array<{ __typename?: 'ClubJoinQuestion', id: string }> } | null };

export type ClubChatInviteQueryQueryVariables = Exact<{
  clubParams: ClubParams;
  chatId: Scalars['ID']['input'];
}>;


export type ClubChatInviteQueryQuery = { __typename?: 'Query', club?: { __typename?: 'Club', id: string, name: string, headline: string, imageUrl: string, profileTitle: string, profileImageUrl: string, premium: boolean, foundingMember: boolean, visibility: ClubVisibility, locationSuburb?: { __typename?: 'LocationSuburb', suburb: string } | null, locationCities: Array<{ __typename?: 'LocationCity', city: string }>, managers: Array<{ __typename?: 'ClubManager', id: string, primary: boolean, user: { __typename?: 'User', id: string, firstName: string, profileImageUrl: string } }>, members: { __typename?: 'ClubMembersConnection', pageInfo: { __typename?: 'PageInfo', totalSize?: number | null } }, joinQuestions: Array<{ __typename?: 'ClubJoinQuestion', id: string }>, chatRoomV2?: { __typename?: 'ChatRoomV2', id: string, name: string, imageUrl?: string | null } | null } | null };

export type GetPlanInviteQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetPlanInviteQuery = { __typename?: 'Query', eventCodeInviteByCode?: { __typename?: 'EventCodeInvite', id: string, code: string, eventID: string, event: { __typename?: 'Event', id: string, title: string, description: string, headline: string, bannerImageUrl: string, startDate: any, capacity: number, location: { __typename?: 'EventPlace', suburb?: string | null, city?: string | null, state?: string | null }, hosts: Array<{ __typename?: 'Host', primary: boolean, user: { __typename?: 'User', id: string, firstName: string, name: string, profileImageUrl: string } }>, attendees: { __typename?: 'EventAttendeesConnection', edges: Array<{ __typename?: 'EventAttendeeEdge', node: { __typename?: 'EventAttendee', id: string } }> } }, createdBy: { __typename?: 'User', id: string, firstName: string, profileImageUrl: string } } | null };

export type SendPasswordlessAuthLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type SendPasswordlessAuthLinkMutation = { __typename?: 'Mutation', sendPasswordlessAuthEmail: { __typename?: 'SendPasswordlessAuthEmailResult', success: boolean } };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  city: Scalars['String']['input'];
  group: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, authID?: string | null, name: string, city?: string | null, group: string } };

export type EventFragment = { __typename?: 'Event', id: string, title: string, description: string, richDescription?: string | null, bannerImageUrl: string, bannerImageUrls: Array<string>, startDate: any, endDate: any, type: EventType, capacity: number, waitlists: boolean, approveGuests: boolean, isAttending: boolean, isHosting: boolean, tone?: EventTone | null, structure?: EventStructure | null, hasEnded: boolean, canceled: boolean, hiddenReason?: EventHiddenReason | null, headline: string, isPublished: boolean, publishedAt: any, menuSample: string, linkPreviews: Array<{ __typename?: 'EventLinkPreview', id: string, url: string, title?: string | null, description?: string | null, imageUrl?: string | null }>, formInputs: Array<{ __typename?: 'EventFormInput', id: string, label: string, placeholder: string, type: EventFormInputType, selectOptions: Array<string> }>, myRequest?: { __typename?: 'EventRequest', id: string, state: EventRequestState, submittedAt?: any | null, decisionExpiresAt?: any | null, resolutionReason?: EventRequestResolutionReason | null, form?: Array<{ __typename?: 'EventRequestFormAnswer', value: string, formQuestionID?: string | null, selectedValues?: Array<string> | null, formQuestionLabel: string, formQuestionType: EventFormInputType, formQuestionOptions: Array<string> }> | null, ticketPurchase?: { __typename?: 'EventRequestTicketPurchaseDetails', totalCostCents: number, state: WalletIntentState, variation?: { __typename?: 'EventTicketVariation', id: string, name: string } | null } | null, ticketPurchaseCode?: { __typename?: 'EventTicketPurchaseCode', code: string } | null } | null, ticketInclusions: Array<{ __typename?: 'EventTicketInclusion', id: string, text: string, position: number }>, regularTicketCost?: { __typename?: 'EventTicketCost', totalCostCents: number } | null, earlyBirdTicketCost?: { __typename?: 'EventTicketCost', totalCostCents: number } | null, ticketVariations: Array<{ __typename?: 'EventTicketVariation', id: string, name: string, emoji: string, description?: string | null, priceCents: number, totalCostCents: number, position: number, ticketsRemaining?: number | null, available: boolean, availableAfterID?: string | null, activatedAt?: any | null, archivedAt?: any | null, availabilityEndsAt?: any | null }>, location: { __typename?: 'EventPlace', isGeneralArea: boolean, exactDetailsHidden: boolean, name: string, suburb?: string | null, city?: string | null, state?: string | null, country?: string | null, postcode?: number | null, formattedAddress?: string | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, club?: { __typename?: 'Club', id: string, name: string, imageUrl: string, headline: string, premium: boolean, foundingMember: boolean } | null, hosts: Array<{ __typename?: 'Host', primary: boolean, user: { __typename?: 'User', id: string, name: string, firstName: string, age: number, bio: string, headline: string, suburb: string, profileImageUrl: string, foundingMember: boolean } }>, attendees: { __typename?: 'EventAttendeesConnection', edges: Array<{ __typename?: 'EventAttendeeEdge', node: { __typename?: 'EventAttendee', id: string, user: { __typename?: 'User', id: string, firstName: string, profileImageUrl: string } } }>, pageInfo: { __typename?: 'PageInfo', totalSize?: number | null } }, requests: { __typename?: 'EventRequestsConnection', edges: Array<{ __typename?: 'EventRequestEdge', node: { __typename?: 'EventRequest', type: EventRequestType, accepted: boolean } }> }, insight?: { __typename?: 'EventPersonalizedInsight', name: string, title: string, body: string } | null, similarEvents: Array<{ __typename?: 'Event', id: string, title: string, startDate: any, bannerImageUrl: string, type: EventType, capacity: number, waitlists: boolean, location: { __typename?: 'EventPlace', suburb?: string | null, city?: string | null, state?: string | null }, hosts: Array<{ __typename?: 'Host', primary: boolean, user: { __typename?: 'User', id: string, name: string, profileImageUrl: string } }>, attendees: { __typename?: 'EventAttendeesConnection', edges: Array<{ __typename?: 'EventAttendeeEdge', node: { __typename?: 'EventAttendee', id: string, user: { __typename?: 'User', id: string, firstName: string, profileImageUrl: string } } }>, pageInfo: { __typename?: 'PageInfo', totalSize?: number | null } } }> } & { ' $fragmentName'?: 'EventFragment' };

export type GetEventQueryVariables = Exact<{
  params: EventParams;
}>;


export type GetEventQuery = { __typename?: 'Query', event?: (
    { __typename?: 'Event' }
    & { ' $fragmentRefs'?: { 'EventFragment': EventFragment } }
  ) | null };

export type PlanTicketStatusQueryVariables = Exact<{
  params: EventParams;
}>;


export type PlanTicketStatusQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, myTicketConfirmed: boolean } | null };

export type SitemapEventsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type SitemapEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventsConnection', edges: Array<{ __typename?: 'EventEdge', node: { __typename?: 'Event', id: string } }> } };

export type SitemapClubsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type SitemapClubsQuery = { __typename?: 'Query', clubs: { __typename?: 'ClubsConnection', edges: Array<{ __typename?: 'ClubEdge', node: { __typename?: 'Club', id: string } }> } };

export type SendPhoneVerificationCodeMutationVariables = Exact<{
  params: SendPhoneVerificationCodeParams;
}>;


export type SendPhoneVerificationCodeMutation = { __typename?: 'Mutation', sendPhoneVerificationCode: { __typename?: 'SendPhoneVerificationCodeResult', success: boolean, error?: { __typename?: 'SendPhoneVerificationCodeError', code: SendPhoneVerificationCodeErrorCode, message: string } | null } };

export type VerifyPhoneVerificationCodeMutationVariables = Exact<{
  params: VerifyPhoneVerificationCodeParams;
}>;


export type VerifyPhoneVerificationCodeMutation = { __typename?: 'Mutation', verifyPhoneVerificationCode: { __typename?: 'VerifyPhoneVerificationCodeResult', token?: string | null, user?: { __typename?: 'User', id: string, anonymous: boolean } | null, error?: { __typename?: 'VerifyPhoneVerificationCodeError', code: VerifyPhoneVerificationCodeErrorCode, message: string } | null } };

export type ValidateDiscountCodeQueryVariables = Exact<{
  params: ValidateDiscountCodeParams;
}>;


export type ValidateDiscountCodeQuery = { __typename?: 'Query', validateDiscountCode: { __typename?: 'DiscountCodeValidation', valid: boolean, errorMessage?: string | null, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, type: DiscountCodeType, value: number, isActive: boolean, expiresAt?: any | null, maxUses?: number | null, currentUses: number } | null } };

export type EventBasicQueryVariables = Exact<{
  params: EventParams;
}>;


export type EventBasicQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, title: string, description: string, startDate: any, bannerImageUrl: string, regularTicketCost?: { __typename?: 'EventTicketCost', totalCostCents: number } | null, location: { __typename?: 'EventPlace', name: string, suburb?: string | null, city?: string | null, state?: string | null } } | null };

export type EventCostQueryVariables = Exact<{
  params: EventParams;
  ticketCostParams: TicketCostParams;
}>;


export type EventCostQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, title: string, description: string, startDate: any, bannerImageUrl: string, regularTicketCost?: { __typename?: 'EventTicketCost', basePriceCents: number, feeAmountCents: number, stripeFeeCents: number, totalCostCents: number } | null, location: { __typename?: 'EventPlace', name: string, suburb?: string | null, city?: string | null, state?: string | null } } | null, ticketCost: { __typename?: 'EventTicketCost', basePriceCents: number, totalCostCents: number, feePercentage: number, feeAmountCents: number, stripeFeeCents: number, discountCents: number, discount: number, available: boolean, earlyBirdDiscountCents: number, totalDiscountCents: number, originalTotalCents: number } };

export type EventFormDetailsQueryVariables = Exact<{
  params: EventParams;
}>;


export type EventFormDetailsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, isAttending: boolean, myAttendance?: { __typename?: 'EventAttendee', id: string, form?: Array<{ __typename?: 'EventRequestFormAnswer', formQuestionID?: string | null, selectedValues?: Array<string> | null, formQuestionLabel: string, value: string }> | null } | null, myRequest?: { __typename?: 'EventRequest', id: string, state: EventRequestState, submittedAt?: any | null } | null, club?: { __typename?: 'Club', id: string, name: string } | null, hosts: Array<{ __typename?: 'Host', id: string, primary: boolean, user: { __typename?: 'User', id: string, firstName: string } }>, formInputs: Array<{ __typename?: 'EventFormInput', id: string, label: string, placeholder: string, type: EventFormInputType, selectOptions: Array<string> }> } | null };

export type UpdateEventAttendeeMutationVariables = Exact<{
  params: UpdateEventAttendeeParams;
}>;


export type UpdateEventAttendeeMutation = { __typename?: 'Mutation', updateEventAttendee: { __typename?: 'UpdateEventAttendeeResult', success: boolean, attendee: { __typename?: 'EventAttendee', id: string, userID: string, reconfirmed: boolean, onTheWay: boolean } } };

export type UploadTicketCheckoutImageMutationVariables = Exact<{
  params: UploadImageParams;
}>;


export type UploadTicketCheckoutImageMutation = { __typename?: 'Mutation', uploadImage: { __typename?: 'UploadImageResult', imageUrl: string } };

export type WalletIntentQueryVariables = Exact<{
  params: WalletIntentParams;
}>;


export type WalletIntentQuery = { __typename?: 'Query', walletIntent?: { __typename?: 'WalletIntent', id: string, state: WalletIntentState, walletIntentEventTicketPurchase?: { __typename?: 'WalletIntentEventTicketPurchase', eventID: string, eventRequestID?: string | null, totalCostCents: number } | null } | null };

export type UserExistsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserExistsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName: string, email?: string | null, anonymous: boolean } | null };

export type ImportTicketCheckoutProfileFromInstagramMutationVariables = Exact<{
  params: ImportTicketCheckoutProfileFromInstagramParams;
}>;


export type ImportTicketCheckoutProfileFromInstagramMutation = { __typename?: 'Mutation', importTicketCheckoutProfileFromInstagram: { __typename?: 'ImportTicketCheckoutProfileFromInstagramResult', profile?: { __typename?: 'TicketCheckoutProfileFromInstagram', name: string, bio: string, profileImageUrl?: string | null } | null, error?: { __typename?: 'ImportTicketCheckoutProfileFromInstagramError', code: ImportTicketCheckoutProfileFromInstagramErrorCode, message: string } | null } };

export type UpdateTicketCheckoutProfileMutationVariables = Exact<{
  params: UpdateUserParams;
}>;


export type UpdateTicketCheckoutProfileMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, age: number, gender: string, bio: string, headline: string, profileImageUrl: string, phoneNumber?: string | null, contactEmail?: string | null } };

export const EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"richDescription"}},{"kind":"Field","name":{"kind":"Name","value":"linkPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"waitlists"}},{"kind":"Field","name":{"kind":"Name","value":"approveGuests"}},{"kind":"Field","name":{"kind":"Name","value":"isAttending"}},{"kind":"Field","name":{"kind":"Name","value":"isHosting"}},{"kind":"Field","name":{"kind":"Name","value":"formInputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"selectOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"decisionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionReason"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionID"}},{"kind":"Field","name":{"kind":"Name","value":"selectedValues"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketPurchase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"variation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketPurchaseCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tone"}},{"kind":"Field","name":{"kind":"Name","value":"structure"}},{"kind":"Field","name":{"kind":"Name","value":"hasEnded"}},{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenReason"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticketInclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regularTicketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earlyBirdTicketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketVariations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"availableAfterID"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityEndsAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isGeneralArea"}},{"kind":"Field","name":{"kind":"Name","value":"exactDetailsHidden"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuSample"}},{"kind":"Field","name":{"kind":"Name","value":"insight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"waitlists"}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventFragment, unknown>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authID"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"isAppUser"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const CheckoutProfileBioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckoutProfileBio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]} as unknown as DocumentNode<CheckoutProfileBioQuery, CheckoutProfileBioQueryVariables>;
export const CreateEventTicketPurchaseIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventTicketPurchaseIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEventTicketPurchaseIntentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEventTicketPurchaseIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"walletIntentID"}},{"kind":"Field","name":{"kind":"Name","value":"processing"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"feeAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"stripeFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"originalTotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"decisionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionReason"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEventTicketPurchaseIntentMutation, CreateEventTicketPurchaseIntentMutationVariables>;
export const GetClubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClubParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileTitle"}},{"kind":"Field","name":{"kind":"Name","value":"profileHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"profileDescription"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"locationSuburb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meetingDays"}},{"kind":"Field","name":{"kind":"Name","value":"managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"displayHost"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"profileDescription"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"upcoming"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plansHosted"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"CLUB"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventMoments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]}}]} as unknown as DocumentNode<GetClubQuery, GetClubQueryVariables>;
export const GetClubEventsEmbedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClubEventsEmbed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClubParams"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventsParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClubEventsParams"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventsParams"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetClubEventsEmbedQuery, GetClubEventsEmbedQueryVariables>;
export const GetClubForInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClubForInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClubParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileTitle"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"locationSuburb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"joinQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetClubForInviteQuery, GetClubForInviteQueryVariables>;
export const ClubChatInviteQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClubChatInviteQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clubParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClubParams"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clubParams"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileTitle"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"locationSuburb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"managers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"joinQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ClubChatInviteQueryQuery, ClubChatInviteQueryQueryVariables>;
export const GetPlanInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlanInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventCodeInviteByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"eventID"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlanInviteQuery, GetPlanInviteQueryVariables>;
export const SendPasswordlessAuthLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPasswordlessAuthLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPasswordlessAuthEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"device"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"ObjectField","name":{"kind":"Name","value":"redirectUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useNewWebsite"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SendPasswordlessAuthLinkMutation, SendPasswordlessAuthLinkMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"group"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"Variable","name":{"kind":"Name","value":"group"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const GetEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Event"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"richDescription"}},{"kind":"Field","name":{"kind":"Name","value":"linkPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"waitlists"}},{"kind":"Field","name":{"kind":"Name","value":"approveGuests"}},{"kind":"Field","name":{"kind":"Name","value":"isAttending"}},{"kind":"Field","name":{"kind":"Name","value":"isHosting"}},{"kind":"Field","name":{"kind":"Name","value":"formInputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"selectOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"decisionExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionReason"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionID"}},{"kind":"Field","name":{"kind":"Name","value":"selectedValues"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketPurchase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"variation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketPurchaseCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tone"}},{"kind":"Field","name":{"kind":"Name","value":"structure"}},{"kind":"Field","name":{"kind":"Name","value":"hasEnded"}},{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenReason"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticketInclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regularTicketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earlyBirdTicketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketVariations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"availableAfterID"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityEndsAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isGeneralArea"}},{"kind":"Field","name":{"kind":"Name","value":"exactDetailsHidden"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"foundingMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuSample"}},{"kind":"Field","name":{"kind":"Name","value":"insight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"waitlists"}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSize"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEventQuery, GetEventQueryVariables>;
export const PlanTicketStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlanTicketStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"myTicketConfirmed"}}]}}]}}]} as unknown as DocumentNode<PlanTicketStatusQuery, PlanTicketStatusQueryVariables>;
export const SitemapEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"canceled"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SitemapEventsQuery, SitemapEventsQueryVariables>;
export const SitemapClubsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapClubs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SitemapClubsQuery, SitemapClubsQueryVariables>;
export const SendPhoneVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPhoneVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendPhoneVerificationCodeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPhoneVerificationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SendPhoneVerificationCodeMutation, SendPhoneVerificationCodeMutationVariables>;
export const VerifyPhoneVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyPhoneVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyPhoneVerificationCodeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPhoneVerificationCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<VerifyPhoneVerificationCodeMutation, VerifyPhoneVerificationCodeMutationVariables>;
export const ValidateDiscountCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateDiscountCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidateDiscountCodeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateDiscountCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"discountCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"currentUses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ValidateDiscountCodeQuery, ValidateDiscountCodeQueryVariables>;
export const EventBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"regularTicketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<EventBasicQuery, EventBasicQueryVariables>;
export const EventCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventParams"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketCostParams"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TicketCostParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"regularTicketCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"feeAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"stripeFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketCostParams"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"feeAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"stripeFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountCents"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"earlyBirdDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"originalTotalCents"}}]}}]}}]} as unknown as DocumentNode<EventCostQuery, EventCostQueryVariables>;
export const EventFormDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventFormDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAttending"}},{"kind":"Field","name":{"kind":"Name","value":"myAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formQuestionID"}},{"kind":"Field","name":{"kind":"Name","value":"selectedValues"}},{"kind":"Field","name":{"kind":"Name","value":"formQuestionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formInputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"selectOptions"}}]}}]}}]}}]} as unknown as DocumentNode<EventFormDetailsQuery, EventFormDetailsQueryVariables>;
export const UpdateEventAttendeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventAttendee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEventAttendeeParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventAttendee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"reconfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"onTheWay"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEventAttendeeMutation, UpdateEventAttendeeMutationVariables>;
export const UploadTicketCheckoutImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadTicketCheckoutImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadImageParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}}]} as unknown as DocumentNode<UploadTicketCheckoutImageMutation, UploadTicketCheckoutImageMutationVariables>;
export const WalletIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WalletIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WalletIntentParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"walletIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"walletIntentEventTicketPurchase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventID"}},{"kind":"Field","name":{"kind":"Name","value":"eventRequestID"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostCents"}}]}}]}}]}}]} as unknown as DocumentNode<WalletIntentQuery, WalletIntentQueryVariables>;
export const UserExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserExists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]}}]} as unknown as DocumentNode<UserExistsQuery, UserExistsQueryVariables>;
export const ImportTicketCheckoutProfileFromInstagramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportTicketCheckoutProfileFromInstagram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportTicketCheckoutProfileFromInstagramParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importTicketCheckoutProfileFromInstagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ImportTicketCheckoutProfileFromInstagramMutation, ImportTicketCheckoutProfileFromInstagramMutationVariables>;
export const UpdateTicketCheckoutProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTicketCheckoutProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserParams"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}}]}}]}}]} as unknown as DocumentNode<UpdateTicketCheckoutProfileMutation, UpdateTicketCheckoutProfileMutationVariables>;